import * as THREE from "three";
import { SUBTRACTION, Brush, Evaluator } from 'three-bvh-csg';
import { MeshStandardMaterial, Mesh, SphereGeometry, BoxGeometry } from 'three';
// //import { Utils } from './utils';
//import { HyperFormula } from 'hyperformula';
import { CSG } from 'three-csg-ts';

import _ from 'lodash';
//import { Materials } from "./materials";
// import * as Comlink from "comlink";

import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { GroupedObservable } from "rxjs";
import threeSpritetext from "three-spritetext";
import { Utils } from "./utils";
import { ThreeUtils } from "./threeutils";
import { LineMaterial } from "three/examples/jsm/lines/LineMaterial";
// import { ThreeUtils } from "./threeutils";
// import { AngularFireStorage } from "@angular/fire/storage";
// import { AngularFirestore } from "@angular/fire/firestore";
import { Line2 } from 'three/examples/jsm/lines/Line2';
import { LineGeometry } from "three/examples/jsm/lines/LineGeometry";
import { InteractionManager } from "./interaction-manager";
import { StepExporter } from './step-exporter';
import { IBeamStandards, IBeamStandard, IBeamDimensions } from './ibeam-standards';
import { AluminumProfiles, AluProfileSeries } from './aluminum-profiles';
import { DINNorms, DINCategory, DINDimensions, DINFastener, DINTolerance } from './din-norms';
// import { CatmullRomCurve3 } from 'three'; // Import CatmullRomCurve3
import { Path } from 'three'; // Import Path for arc creation
import { LineCurve3, QuadraticBezierCurve3, CubicBezierCurve3, CatmullRomCurve3, CurvePath } from 'three'; // Import necessary curve types

// Add this interface before the class definition
interface RefPos {
    index: number;
    position: THREE.Vector3;
    worldPosition: THREE.Vector3;
    outputid: string;
    name: string;
    path: string;
    parentName?: string;
    parentPath?: string;
    origPos?: THREE.Vector3;
    normal?: THREE.Vector3;
}

class CADNodeEngine {
    testmesh: THREE.Mesh;
    interactionManager: InteractionManager;

    // Add connector sprite management similar to face centers
    hoveredConnectorSprite: THREE.Sprite | null = null;
    hoveredConnectorOriginalMaterial: THREE.SpriteMaterial | null = null;
    selectedConnectorSprite: THREE.Sprite | null = null;

    rows = [];

    spheres: any[];

    texturen = true;
    changedElements = [];

    loader: GLTFLoader;
    constructor() {
        THREE.Cache.enabled = true;
        //  console.log('cache', THREE.Cache.files)
        this.loader = new GLTFLoader();

        //     this.materials = new Materials();
    }




    // transformNodeFromRow(row: any[], commentrow: any[]) {
    //     var params = Utils.mapRowToParams(row, commentrow);
    //     var pos = params['position'].split(',');
    //     var rot = params['rotation'].split(',');

    //     var group = new THREE.Group();
    //     group.position.set(parseFloat(pos[0]), parseFloat(pos[1]), parseFloat(pos[2]));
    //     group.rotation.set(parseFloat(rot[0]), parseFloat(rot[1]), parseFloat(rot[2]));
    //     return group();

    // }


    // prop, nodename, value, object
    updateNodel(prop, nodename: string, value: any, scene: THREE.Scene) {
        //    if (nodetype == "material")
        scene.traverse((child) => {

            // node = door_lf_primary
            // visible = TRUE
            //  if (child.type === 'Mesh') {

            if (child?.name == nodename) {
                try {

                    if (value.toUpperCase() == 'TRUE')
                        value = true;
                    if (value.toUpperCase() == 'FALSE')
                        value = false;
                } catch (e) { }

                // Utils.setValue(child, prop, value);
                //    child[prop] = value;
                var props = prop.split('.');
                if (props.length > 1) {
                    if (props[0] == 'material') {
                        child['material'][props[1]].set(value);
                    } else
                        if (props[0] == 'scale') {
                            child['scale'][props[1]] = value;
                        } else {
                            child[props[0]][props[1]] = value;

                        }

                }
                else {
                    child[prop] = value;
                }

            }

            // if (child.material?.name == nodename) {
            //     child[prop].color = new THREE.Color(value);
            // }
            //   }
        });


    }

    grad2rad(grad) {
        return grad * Math.PI / 180;
    }


    diffTypeOfRow(commentRow, oldRow, newRow) {
        // Type: 0:none, 1:pos,rot,scale, 2:time, 3: recreate
        var typ = 0;

        if (commentRow)
            for (var i = 0; i < commentRow.length; i++) {

                if (oldRow[i] != newRow[i]) {
                    if (commentRow[i]) {

                        try {
                            if (commentRow[i].toLowerCase() == 'x' || commentRow[i].toLowerCase() == 'y' || commentRow[i].toLowerCase() == 'z'
                                || commentRow[i].toLowerCase() == 'rx' || commentRow[i].toLowerCase() == 'ry' || commentRow[i].toLowerCase() == 'rz'
                                || commentRow[i].toLowerCase() == 'sx' || commentRow[i].toLowerCase() == 'sy' || commentRow[i].toLowerCase() == 'sz') {
                                typ = 1;
                                continue;
                            }
                            if (commentRow[i].toLowerCase() == 'time') {
                                typ = 2;
                                continue;
                            }
                        } catch (e) {
                            console.warn('diffTypeOfRow', commentRow[i]);
                        }

                        typ = 3;
                        return typ;
                    }
                }
            }

        return typ;

    }

    public calculateFaceCenters(geometry) {
        const faceCenters = [];
        const faceNormals = [];
        const position = geometry.attributes.position;

        //   console.log(`[calculateFaceCenters] Processing geometry type: ${geometry.type}`, geometry);

        if (geometry.userData?.isRing) {
            const outerRadius = geometry.userData.outerRadius;
            const depth = geometry.userData.depth;

            // 1. Center of bottom face (local Z=0)
            faceCenters.push(new THREE.Vector3(0, 0, 0));
            faceNormals.push(new THREE.Vector3(0, 0, -1));

            // 2. Center of top face (local Z=depth)
            faceCenters.push(new THREE.Vector3(0, 0, depth));
            faceNormals.push(new THREE.Vector3(0, 0, 1));

            // 3. Overall Center
            faceCenters.push(new THREE.Vector3(0, 0, depth / 2));
            faceNormals.push(null); // No single normal for overall center

            // 4. Four points on the outer cylindrical surface at mid-height
            const midHeight = depth / 2;
            const angles = [0, Math.PI / 2, Math.PI, 3 * Math.PI / 2]; // For +X, +Y, -X, -Y in XY plane

            angles.forEach(angle => {
                const x = outerRadius * Math.cos(angle);
                const y = outerRadius * Math.sin(angle);
                faceCenters.push(new THREE.Vector3(x, y, midHeight));
                // Normal points radially outwards from Z-axis in XY plane
                faceNormals.push(new THREE.Vector3(Math.cos(angle), Math.sin(angle), 0).normalize());
            });
        }
        else if (geometry.type === 'ExtrudeGeometry') {
            const shapesParam = geometry.parameters.shapes;
            const firstShape = Array.isArray(shapesParam) ? shapesParam[0] : shapesParam;

            if (!firstShape || typeof firstShape.extractPoints !== 'function') {
                console.warn('ExtrudeGeometry: No valid shape found or shape is not a THREE.Shape instance.');
                return { faceCenters, faceNormals };
            }

            const shapePoints = firstShape.extractPoints().shape; // Vector2[]
            const depth = geometry.parameters.options.depth;
            const midDepth = depth / 2;

            // Determine unique vertices
            let uniqueShapeVertices = [...shapePoints];
            if (shapePoints.length > 1 && shapePoints[0].equals(shapePoints[shapePoints.length - 1])) {
                uniqueShapeVertices.pop();
            }
            const numUniqueVerts = uniqueShapeVertices.length;

            if (numUniqueVerts < 2) {
                console.warn('ExtrudeGeometry: Not enough unique vertices to define shape.');
                return { faceCenters, faceNormals };
            }

            // Calculate centroid of the base shape for face centers
            const baseCentroid = new THREE.Vector3();
            if (numUniqueVerts > 0) {
                for (let i = 0; i < numUniqueVerts; i++) {
                    baseCentroid.add(new THREE.Vector3(uniqueShapeVertices[i].x, uniqueShapeVertices[i].y, 0));
                }
                baseCentroid.divideScalar(numUniqueVerts);
            }

            // 1. Center of the base face (at z=0)
            faceCenters.push(baseCentroid.clone());
            faceNormals.push(new THREE.Vector3(0, 0, -1));

            // 2. Center of the top face (at z=depth)
            const topFaceCenter = new THREE.Vector3(baseCentroid.x, baseCentroid.y, depth);
            faceCenters.push(topFaceCenter);
            faceNormals.push(new THREE.Vector3(0, 0, 1));

            // 3. Center of the volume
            const volumeCenter = new THREE.Vector3(baseCentroid.x, baseCentroid.y, midDepth);
            faceCenters.push(volumeCenter);
            faceNormals.push(null);

            // 4. Midpoints of edges of the base shape
            for (let i = 0; i < numUniqueVerts; i++) {
                const p1 = uniqueShapeVertices[i];
                const p2 = uniqueShapeVertices[(i + 1) % numUniqueVerts];
                const vA = new THREE.Vector3(p1.x, p1.y, 0);
                const vB = new THREE.Vector3(p2.x, p2.y, 0);
                const center = new THREE.Vector3().addVectors(vA, vB).divideScalar(2);
                faceCenters.push(center);

                const tangent = new THREE.Vector3().subVectors(vB, vA);
                const normal = new THREE.Vector3(tangent.y, -tangent.x, 0).normalize();
                faceNormals.push(normal);
            }

            // 5. Midpoints of edges of the top shape
            for (let i = 0; i < numUniqueVerts; i++) {
                const p1 = uniqueShapeVertices[i];
                const p2 = uniqueShapeVertices[(i + 1) % numUniqueVerts];
                const vA = new THREE.Vector3(p1.x, p1.y, depth);
                const vB = new THREE.Vector3(p2.x, p2.y, depth);
                const center = new THREE.Vector3().addVectors(vA, vB).divideScalar(2);
                faceCenters.push(center);

                const tangent = new THREE.Vector3().subVectors(vB, vA);
                const normal = new THREE.Vector3(tangent.y, -tangent.x, 0).normalize();
                faceNormals.push(normal);
            }

            // 6. Centers of the vertical side faces
            for (let i = 0; i < numUniqueVerts; i++) {
                const p1 = uniqueShapeVertices[i];
                const p2 = uniqueShapeVertices[(i + 1) % numUniqueVerts];

                const centerSideFace = new THREE.Vector3(
                    (p1.x + p2.x) / 2,
                    (p1.y + p2.y) / 2,
                    midDepth
                );
                faceCenters.push(centerSideFace);

                const tangentBaseEdge = new THREE.Vector2(p2.x - p1.x, p2.y - p1.y);
                const sideFaceNormal = new THREE.Vector3(tangentBaseEdge.y, -tangentBaseEdge.x, 0).normalize();
                faceNormals.push(sideFaceNormal);
            }

            // 7. Corner points of the base shape (z=0)
            for (let i = 0; i < numUniqueVerts; i++) {
                const vBase = new THREE.Vector3(uniqueShapeVertices[i].x, uniqueShapeVertices[i].y, 0);
                faceCenters.push(vBase);
                faceNormals.push(null); // Corner points don't have a single normal
            }

            // 8. Corner points at mid-depth (z=depth/2)
            for (let i = 0; i < numUniqueVerts; i++) {
                const vMid = new THREE.Vector3(uniqueShapeVertices[i].x, uniqueShapeVertices[i].y, midDepth);
                faceCenters.push(vMid);
                faceNormals.push(null);
            }

            // 9. Corner points of the top shape (z=depth)
            for (let i = 0; i < numUniqueVerts; i++) {
                const vTop = new THREE.Vector3(uniqueShapeVertices[i].x, uniqueShapeVertices[i].y, depth);
                faceCenters.push(vTop);
                faceNormals.push(null);
            }
        }
        else if (geometry.type === 'BoxGeometry') {
            const halfWidth = geometry.parameters.width / 2;
            const halfHeight = geometry.parameters.height / 2;
            const halfDepth = geometry.parameters.depth / 2;

            // 1. Define the 6 face centers of a box
            faceCenters.push(
                new THREE.Vector3(halfWidth, 0, 0),   // +X face
                new THREE.Vector3(-halfWidth, 0, 0),  // -X face
                new THREE.Vector3(0, halfHeight, 0),  // +Y face
                new THREE.Vector3(0, -halfHeight, 0), // -Y face
                new THREE.Vector3(0, 0, halfDepth),   // +Z face
                new THREE.Vector3(0, 0, -halfDepth)   // -Z face
            );

            faceNormals.push(
                new THREE.Vector3(1, 0, 0),   // +X normal
                new THREE.Vector3(-1, 0, 0),  // -X normal
                new THREE.Vector3(0, 1, 0),   // +Y normal
                new THREE.Vector3(0, -1, 0),  // -Y normal
                new THREE.Vector3(0, 0, 1),   // +Z normal
                new THREE.Vector3(0, 0, -1)   // -Z normal
            );

            // 2. Define the 12 middle points on the edges of a box with proper edge normals
            faceCenters.push(
                new THREE.Vector3(halfWidth, halfHeight, 0),    // +X +Y edge
                new THREE.Vector3(halfWidth, -halfHeight, 0),   // +X -Y edge
                new THREE.Vector3(halfWidth, 0, halfDepth),     // +X +Z edge
                new THREE.Vector3(halfWidth, 0, -halfDepth),    // +X -Z edge
                new THREE.Vector3(-halfWidth, halfHeight, 0),   // -X +Y edge
                new THREE.Vector3(-halfWidth, -halfHeight, 0),  // -X -Y edge
                new THREE.Vector3(-halfWidth, 0, halfDepth),    // -X +Z edge
                new THREE.Vector3(-halfWidth, 0, -halfDepth),   // -X -Z edge
                new THREE.Vector3(0, halfHeight, halfDepth),    // +Y +Z edge
                new THREE.Vector3(0, halfHeight, -halfDepth),   // +Y -Z edge
                new THREE.Vector3(0, -halfHeight, halfDepth),   // -Y +Z edge
                new THREE.Vector3(0, -halfHeight, -halfDepth)   // -Y -Z edge
            );

            // Add proper edge normals (orthogonal to the edge, using one adjacent face as base)
            faceNormals.push(
                new THREE.Vector3(1, 0, 0),   // +X +Y edge: use +X face normal
                new THREE.Vector3(1, 0, 0),   // +X -Y edge: use +X face normal
                new THREE.Vector3(1, 0, 0),   // +X +Z edge: use +X face normal
                new THREE.Vector3(1, 0, 0),   // +X -Z edge: use +X face normal
                new THREE.Vector3(-1, 0, 0),  // -X +Y edge: use -X face normal
                new THREE.Vector3(-1, 0, 0),  // -X -Y edge: use -X face normal
                new THREE.Vector3(-1, 0, 0),  // -X +Z edge: use -X face normal
                new THREE.Vector3(-1, 0, 0),  // -X -Z edge: use -X face normal
                new THREE.Vector3(0, 1, 0),   // +Y +Z edge: use +Y face normal
                new THREE.Vector3(0, 1, 0),   // +Y -Z edge: use +Y face normal
                new THREE.Vector3(0, -1, 0),  // -Y +Z edge: use -Y face normal
                new THREE.Vector3(0, -1, 0)   // -Y -Z edge: use -Y face normal
            );

            // 3. Define the 8 corner points of a box (all 8 vertices)
            faceCenters.push(
                new THREE.Vector3(halfWidth, halfHeight, halfDepth),    // +X +Y +Z
                new THREE.Vector3(halfWidth, halfHeight, -halfDepth),   // +X +Y -Z
                new THREE.Vector3(halfWidth, -halfHeight, halfDepth),   // +X -Y +Z
                new THREE.Vector3(halfWidth, -halfHeight, -halfDepth),  // +X -Y -Z
                new THREE.Vector3(-halfWidth, halfHeight, halfDepth),   // -X +Y +Z
                new THREE.Vector3(-halfWidth, halfHeight, -halfDepth),  // -X +Y -Z
                new THREE.Vector3(-halfWidth, -halfHeight, halfDepth),  // -X -Y +Z
                new THREE.Vector3(-halfWidth, -halfHeight, -halfDepth)  // -X -Y -Z
            );

            // Add null normals for corner points
            for (let i = 0; i < 8; i++) {
                faceNormals.push(null);
            }

            // 4. Add center point of the box
            faceCenters.push(new THREE.Vector3(0, 0, 0));
            faceNormals.push(null);
        }
        else if (geometry.type === 'CylinderGeometry') {
            const halfHeight = geometry.parameters.height / 2;
            const radiusBottom = geometry.parameters.radiusBottom;
            const radiusTop = geometry.parameters.radiusTop;

            // 1. Define the center point of the cylinder
            const center = new THREE.Vector3(0, 0, 0);
            faceCenters.push(center);
            faceNormals.push(null);

            // 2. Define the center points of the flat sides
            const baseCenter = new THREE.Vector3(0, -halfHeight, 0);
            const topCenter = new THREE.Vector3(0, halfHeight, 0);
            faceCenters.push(baseCenter);
            faceCenters.push(topCenter);
            faceNormals.push(new THREE.Vector3(0, -1, 0));
            faceNormals.push(new THREE.Vector3(0, 1, 0));

            // 3. Define 4 points on the cylindrical surface at mid-height
            const angles = [0, Math.PI / 2, Math.PI, 3 * Math.PI / 2];
            angles.forEach(angle => {
                const x = Math.cos(angle) * radiusBottom;
                const z = Math.sin(angle) * radiusBottom;
                const midHeightPoint = new THREE.Vector3(x, 0, z);
                faceCenters.push(midHeightPoint);
                faceNormals.push(new THREE.Vector3(Math.cos(angle), 0, Math.sin(angle)).normalize());
            });

            // 4. Edge points around the base circumference (with edge normals)
            angles.forEach(angle => {
                const xBase = Math.cos(angle) * radiusBottom;
                const zBase = Math.sin(angle) * radiusBottom;
                const basePoint = new THREE.Vector3(xBase, -halfHeight, zBase);
                faceCenters.push(basePoint);

                // Edge normal: use radial normal (outward from cylinder axis)
                const radialNormal = new THREE.Vector3(Math.cos(angle), 0, Math.sin(angle));
                faceNormals.push(radialNormal);
            });

            // 5. Edge points around the top circumference (with edge normals)
            angles.forEach(angle => {
                const xTop = Math.cos(angle) * radiusTop;
                const zTop = Math.sin(angle) * radiusTop;
                const topPoint = new THREE.Vector3(xTop, halfHeight, zTop);
                faceCenters.push(topPoint);

                // Edge normal: use radial normal (outward from cylinder axis)
                const radialNormal = new THREE.Vector3(Math.cos(angle), 0, Math.sin(angle));
                faceNormals.push(radialNormal);
            });
        }
        else if (geometry.type === 'SphereGeometry') {
            const radius = geometry.parameters.radius;

            // Define the center point of the sphere
            const center = new THREE.Vector3(0, 0, 0);
            faceCenters.push(center);
            faceNormals.push(null);

            // Define points on each side of the sphere
            const directions = [
                new THREE.Vector3(1, 0, 0),  // Right
                new THREE.Vector3(-1, 0, 0), // Left
                new THREE.Vector3(0, 1, 0),  // Top
                new THREE.Vector3(0, -1, 0), // Bottom
                new THREE.Vector3(0, 0, 1),  // Front
                new THREE.Vector3(0, 0, -1)  // Back
            ];

            directions.forEach(direction => {
                const point = direction.clone().multiplyScalar(radius);
                faceCenters.push(point);
                faceNormals.push(direction.clone().normalize());
            });
        }
        else {
            // Fallback for general geometries - calculate face centers from actual geometry faces
            if (position && position.count > 0) {
                const indices = geometry.index;

                if (indices) {
                    // Indexed geometry - process triangular faces
                    for (let i = 0; i < indices.count; i += 3) {
                        const a = indices.getX(i);
                        const b = indices.getX(i + 1);
                        const c = indices.getX(i + 2);

                        const vA = new THREE.Vector3().fromBufferAttribute(position, a);
                        const vB = new THREE.Vector3().fromBufferAttribute(position, b);
                        const vC = new THREE.Vector3().fromBufferAttribute(position, c);

                        // Calculate face center
                        const faceCenter = new THREE.Vector3()
                            .addVectors(vA, vB)
                            .add(vC)
                            .divideScalar(3);

                        // Calculate face normal
                        const edge1 = new THREE.Vector3().subVectors(vB, vA);
                        const edge2 = new THREE.Vector3().subVectors(vC, vA);
                        const normal = new THREE.Vector3().crossVectors(edge1, edge2).normalize();

                        faceCenters.push(faceCenter);
                        faceNormals.push(normal);
                    }
                } else {
                    // Non-indexed geometry - assume consecutive triangles
                    for (let i = 0; i < position.count; i += 3) {
                        if (i + 2 < position.count) {
                            const vA = new THREE.Vector3().fromBufferAttribute(position, i);
                            const vB = new THREE.Vector3().fromBufferAttribute(position, i + 1);
                            const vC = new THREE.Vector3().fromBufferAttribute(position, i + 2);

                            // Calculate face center
                            const faceCenter = new THREE.Vector3()
                                .addVectors(vA, vB)
                                .add(vC)
                                .divideScalar(3);

                            // Calculate face normal
                            const edge1 = new THREE.Vector3().subVectors(vB, vA);
                            const edge2 = new THREE.Vector3().subVectors(vC, vA);
                            const normal = new THREE.Vector3().crossVectors(edge1, edge2).normalize();

                            faceCenters.push(faceCenter);
                            faceNormals.push(normal);
                        }
                    }
                }

                // Limit the number of face centers for performance
                if (faceCenters.length > 50) {
                    const step = Math.ceil(faceCenters.length / 50);
                    const limitedFaceCenters = [];
                    const limitedFaceNormals = [];

                    for (let i = 0; i < faceCenters.length; i += step) {
                        limitedFaceCenters.push(faceCenters[i]);
                        limitedFaceNormals.push(faceNormals[i]);
                    }

                    return { faceCenters: limitedFaceCenters, faceNormals: limitedFaceNormals };
                }
            }
        }

        //   console.log(`[calculateFaceCenters] Generated ${faceCenters.length} face centers for ${geometry.type}`);
        return { faceCenters, faceNormals };
    }

    public addFaceCenters(object, outputid, index?: number) {
        if (!object?.geometry) return;

        // Calculate the face centers and normals
        const { faceCenters, faceNormals } = this.calculateFaceCenters(object.geometry);

        // Store all reference points in the object's userData
        object.userData.faceCenters = faceCenters.map((center, i) => ({
            position: center.clone(),
            normal: faceNormals[i]?.clone() || null,
            index: i + 1,
            outputid: outputid
        }));
    }

    showFaceCenters(obj, scene, createLabels: boolean = false, showNormals: boolean = false) {
        console.log("[showFaceCenters] Called for obj:", obj?.name, "Type:", obj?.userData?.typ, "Path:", obj?.userData?.path);

        // Guard against undefined scene
        if (!scene) {
            console.warn('Scene is undefined in showFaceCenters');
            return;
        }

        // First, find all objects with helpers and remove them (BUT PROTECT CONNECTORS)
        const objectsWithHelpers = [];
        scene.traverse((child) => {
            if (child.children) {
                const hasHelpers = child.children.some(c =>
                    (c.userData.type === "refpoint" || c.userData.type === "refnormal") &&
                    c.userData.isFaceCenter === true && // Only consider face center helpers for removal
                    !c.userData.isConnector && // Don't consider connectors as helpers to remove
                    !this.isPartOfConnector(c) // Don't consider connector parts as helpers to remove
                );
                if (hasHelpers) {
                    objectsWithHelpers.push(child);
                }
            }
        });

        // Remove helpers and reset any selected sprites (BUT PROTECT CONNECTORS)
        objectsWithHelpers.forEach(object => {
            console.log(`[CONNECTOR PROTECTION] Processing object: ${object.name}`);
            const toRemove = object.children.filter(child => {
                // Only remove face center helpers, never connectors
                const isFaceCenterHelper = (child.userData.type === "refpoint" || child.userData.type === "refnormal") &&
                    child.userData.isFaceCenter === true;
                const isConnector = child.userData.isConnector;
                const isPartOfConnector = this.isPartOfConnector(child);

                if (isConnector || isPartOfConnector) {
                    console.log(`[CONNECTOR PROTECTION] PROTECTED: ${child.userData.connectorLabel || child.userData.type || 'connector'} - NOT REMOVING`);
                    return false; // NEVER remove connectors
                }

                return isFaceCenterHelper;
            });

            console.log(`[CONNECTOR PROTECTION] Removing ${toRemove.length} face center helpers from ${object.name}`);
            toRemove.forEach(child => {
                console.log(`[CONNECTOR PROTECTION] Removing helper: ${child.userData.type} index ${child.userData.index}`);
                object.remove(child);
            });
        });

        // Add new helpers for the selected object
        if (obj && obj.userData.faceCenters) {
            console.log(`[showFaceCenters] Found ${obj.userData.faceCenters.length} face centers for ${obj.name}`);

            obj.userData.faceCenters.forEach((faceCenter, index) => {
                if (!faceCenter.position) {
                    console.warn(`[showFaceCenters] Invalid position for faceCenter index ${index} on ${obj.name}`);
                    return;
                }

                // Create sphere for face center point (instead of sprite)
                const sphereRadius = 2; // Smaller than connector spheres (which are typically 3)
                const sphereGeometry = new THREE.SphereGeometry(sphereRadius, 12, 12);
                const sphereMaterial = new THREE.MeshStandardMaterial({
                    color: 0xff00ff, // Magenta color for face centers
                    metalness: 0.8, // Increased metalness for more shine
                    roughness: 0.1, // Reduced roughness for more reflectivity
                    transparent: false,
                    envMapIntensity: 1.2 // Added environment map intensity for better reflections
                });
                const sphere = new THREE.Mesh(sphereGeometry, sphereMaterial);
                sphere.position.copy(faceCenter.position);
                sphere.userData.type = "refpoint";
                sphere.userData.outputid = faceCenter.outputid;
                sphere.userData.outputid2 = faceCenter.outputid; // For compatibility
                sphere.userData.index = faceCenter.index;
                sphere.userData.origpos = faceCenter.position.clone(); // Store original position
                sphere.userData.isHelper = true;
                sphere.userData.isFaceCenter = true; // Mark as face center for distinction
                // Add properties for proximity effect
                sphere.userData.originalScale = 1.0; // Store original scale for proximity effect
                sphere.userData.originalOpacity = 1.0; // Store original opacity
                sphere.userData.originalColor = new THREE.Color(0xaa00ff); // Store original color
                sphere.renderOrder = 999;
                sphere.castShadow = true;
                sphere.receiveShadow = true;

                obj.add(sphere);

                // Create a text label above the sphere to show the index number (only if createLabels is true)
                if (createLabels) {
                    const canvas = document.createElement('canvas');
                    canvas.width = 128;
                    canvas.height = 128;
                    const context = canvas.getContext('2d');

                    // Clear the canvas with transparent background
                    context.clearRect(0, 0, canvas.width, canvas.height);

                    // Draw the number
                    context.fillStyle = 'rgba(255, 255, 255, 1)';
                    context.strokeStyle = 'rgba(0, 0, 0, 0.8)';
                    context.lineWidth = 3;
                    context.textAlign = 'center';
                    context.textBaseline = 'middle';
                    context.font = 'bold 80px Arial';
                    const text = `${index + 1}`;
                    context.strokeText(text, canvas.width / 2, canvas.height / 2);
                    context.fillText(text, canvas.width / 2, canvas.height / 2);

                    const texture = new THREE.CanvasTexture(canvas);
                    texture.needsUpdate = true;

                    const spriteMaterial = new THREE.SpriteMaterial({
                        map: texture,
                        transparent: true,
                        depthTest: false,
                        depthWrite: false,
                        sizeAttenuation: true,
                        alphaTest: 0.1
                    });

                    const labelSprite = new THREE.Sprite(spriteMaterial);
                    labelSprite.position.copy(faceCenter.position);
                    labelSprite.position.y += sphereRadius + 3; // Position above the sphere
                    labelSprite.scale.set(6, 6, 1); // Smaller scale for the label
                    labelSprite.userData.type = "refpoint_label";
                    labelSprite.userData.parentSphere = sphere;
                    labelSprite.userData.isHelper = true;
                    labelSprite.userData.isFaceCenter = true;
                    labelSprite.renderOrder = 1000;

                    obj.add(labelSprite);
                }

                // Add the sphere to interaction manager if available
                if (this.interactionManager) {
                    this.interactionManager.add(sphere, {
                        mouseEnter: (obj) => {
                            // Scale up the sphere on hover
                            obj.scale.multiplyScalar(1.3);
                            // Highlight the sphere
                            if (obj instanceof THREE.Mesh) {
                                const material = obj.material as THREE.MeshStandardMaterial;
                                obj.userData.originalColor = material.color.clone();
                                material.color.setHex(0xFFEB3B); // Yellow highlight
                            }
                            document.body.style.cursor = 'pointer';
                        },
                        mouseLeave: (obj) => {
                            // Scale down the sphere
                            obj.scale.divideScalar(1.3);
                            // Restore original color
                            if (obj.userData.originalColor && obj instanceof THREE.Mesh) {
                                const material = obj.material as THREE.MeshStandardMaterial;
                                material.color.copy(obj.userData.originalColor);
                            }
                            document.body.style.cursor = 'default';
                        },
                        click: (obj, event) => {
                            console.log('Face center sphere clicked:', {
                                outputid: obj.userData.outputid,
                                index: obj.userData.index
                            });

                            // Copy to clipboard (same logic as sprite clicks)
                            if (obj.userData.outputid && obj.userData.index !== undefined) {
                                const textToCopy = obj.userData.outputid + "." + obj.userData.index;
                                navigator.clipboard.writeText(textToCopy).then(() => {
                                    console.log('Copied to clipboard:', textToCopy);
                                });
                            }
                        }
                    });
                }

                // Calculate normal vector for storage (always calculate, but only show if requested)
                let normalVector = faceCenter.normal;

                // If no normal is provided, calculate a fallback normal (axis-aligned, not diagonal)
                if (!normalVector) {
                    // For corner/edge points, use axis-aligned normal instead of diagonal
                    const objectCenter = new THREE.Vector3();
                    obj.geometry.computeBoundingBox();
                    if (obj.geometry.boundingBox) {
                        obj.geometry.boundingBox.getCenter(objectCenter);
                    }

                    const directionToPoint = new THREE.Vector3().subVectors(faceCenter.position, objectCenter);
                    if (directionToPoint.length() < 0.001) {
                        // If position is at center, use upward normal as fallback
                        normalVector = new THREE.Vector3(0, 1, 0);
                    } else {
                        // Pick the dominant axis direction (largest component)
                        const absX = Math.abs(directionToPoint.x);
                        const absY = Math.abs(directionToPoint.y);
                        const absZ = Math.abs(directionToPoint.z);

                        if (absX >= absY && absX >= absZ) {
                            // X is dominant
                            normalVector = new THREE.Vector3(directionToPoint.x > 0 ? 1 : -1, 0, 0);
                        } else if (absY >= absX && absY >= absZ) {
                            // Y is dominant
                            normalVector = new THREE.Vector3(0, directionToPoint.y > 0 ? 1 : -1, 0);
                        } else {
                            // Z is dominant
                            normalVector = new THREE.Vector3(0, 0, directionToPoint.z > 0 ? 1 : -1);
                        }
                    }
                }

                // Store the normal in the sphere's userData for later use
                if (normalVector) {
                    sphere.userData.normal = normalVector.clone();
                }

                // Create arrow for normal only if showNormals is true
                if (showNormals && normalVector) {
                    const arrowLength = 25; // Reduced from 50 to 25
                    const arrowHelper = new THREE.ArrowHelper(
                        normalVector.normalize(),
                        faceCenter.position,
                        arrowLength,
                        0x00ff00,
                        arrowLength * 0.3, // Reduced head length (was 0.45)
                        arrowLength * 0.2  // Reduced head width (was 0.35)
                    );
                    arrowHelper.userData.type = "refnormal";
                    arrowHelper.userData.index = faceCenter.index;
                    arrowHelper.userData.normal = normalVector.clone();
                    arrowHelper.userData.isHelper = true;
                    arrowHelper.userData.isFaceCenter = true; // Mark as face center for distinction
                    // Add properties for proximity effect
                    arrowHelper.userData.originalScale = 1.0; // Store original scale for proximity effect
                    arrowHelper.userData.originalOpacity = 1.0; // Store original opacity
                    arrowHelper.renderOrder = 1000;

                    // Make the arrow ignore depth
                    if (arrowHelper.line) {
                        const lineMaterial = new THREE.LineBasicMaterial({
                            color: 0x00ff00,
                            linewidth: 2, // Reduced from 3 to 2
                            depthTest: false,
                            depthWrite: false,
                            transparent: true
                        });
                        (arrowHelper.line as THREE.Line).material = lineMaterial;
                    }

                    if (arrowHelper.cone) {
                        const coneMaterial = new THREE.MeshBasicMaterial({
                            color: 0x00ff00,
                            depthTest: false,
                            depthWrite: false,
                            transparent: true
                        });
                        (arrowHelper.cone as THREE.Mesh).material = coneMaterial;
                    }

                    obj.add(arrowHelper);
                }
            });
        } else {
            console.log(`[showFaceCenters] No valid faceCenters found or obj is null for ${obj?.name}`);
        }
    }

    /**
     * Toggle the visibility of normals for existing face centers
     * @param obj The object containing face centers
     * @param scene The scene
     * @param showNormals Whether to show or hide the normals
     */
    toggleFaceCenterNormals(obj, scene, showNormals: boolean) {
        if (!obj || !obj.userData.faceCenters) {
            console.warn('No face centers found on object');
            return;
        }

        if (showNormals) {
            // Add normal arrows to existing face center spheres
            obj.userData.faceCenters.forEach((faceCenter, index) => {
                // Find the corresponding sphere
                const sphere = obj.children.find(child =>
                    child.userData.type === "refpoint" &&
                    child.userData.isFaceCenter === true &&
                    child.userData.index === faceCenter.index
                );

                if (sphere && sphere.userData.normal) {
                    // Check if normal arrow already exists
                    const existingArrow = obj.children.find(child =>
                        child.userData.type === "refnormal" &&
                        child.userData.isFaceCenter === true &&
                        child.userData.index === faceCenter.index
                    );

                    if (!existingArrow) {
                        const normalVector = sphere.userData.normal;
                        const arrowLength = 25;
                        const arrowHelper = new THREE.ArrowHelper(
                            normalVector.normalize(),
                            faceCenter.position,
                            arrowLength,
                            0x00ff00,
                            arrowLength * 0.3,
                            arrowLength * 0.2
                        );
                        arrowHelper.userData.type = "refnormal";
                        arrowHelper.userData.index = faceCenter.index;
                        arrowHelper.userData.normal = normalVector.clone();
                        arrowHelper.userData.isHelper = true;
                        arrowHelper.userData.isFaceCenter = true;
                        arrowHelper.userData.originalScale = 1.0;
                        arrowHelper.userData.originalOpacity = 1.0;
                        arrowHelper.renderOrder = 1000;

                        // Make the arrow ignore depth
                        if (arrowHelper.line) {
                            const lineMaterial = new THREE.LineBasicMaterial({
                                color: 0x00ff00,
                                linewidth: 2,
                                depthTest: false,
                                depthWrite: false,
                                transparent: true
                            });
                            (arrowHelper.line as THREE.Line).material = lineMaterial;
                        }

                        if (arrowHelper.cone) {
                            const coneMaterial = new THREE.MeshBasicMaterial({
                                color: 0x00ff00,
                                depthTest: false,
                                depthWrite: false,
                                transparent: true
                            });
                            (arrowHelper.cone as THREE.Mesh).material = coneMaterial;
                        }

                        obj.add(arrowHelper);
                    }
                }
            });
        } else {
            // Remove normal arrows from face centers
            const arrowsToRemove = obj.children.filter(child =>
                child.userData.type === "refnormal" &&
                child.userData.isFaceCenter === true
            );

            arrowsToRemove.forEach(arrow => {
                obj.remove(arrow);
            });
        }
    }

    /**
     * Helper method to check if an object is part of a connector
     * @param obj The object to check
     * @returns true if the object is part of a connector
     */
    private isPartOfConnector(obj: THREE.Object3D): boolean {
        // Check if this object is directly a connector
        if (obj.userData?.isConnector) {
            return true;
        }

        // Check if this object is a child of a connector group
        let parent = obj.parent;
        while (parent) {
            if (parent.userData?.isConnector) {
                return true;
            }
            parent = parent.parent;
        }

        // Check specific connector-related userData flags
        if (obj.userData?.isConnectorArrow ||
            obj.userData?.isConnectorSphere ||
            obj.userData?.connectorType ||
            obj.userData?.connectorLabel) {
            return true;
        }

        return false;
    }

    // Note: createNumberedSprite method removed as face centers now use spheres instead of sprites

    prependUnderscoreToNumbers(inputString) {
        return inputString.replace(/(\d+)/g, '_$1');
    }
    removeUnderscoreBeforeNumbers(inputString) {
        return inputString.replace(/_+(\d+)/g, '$1');
    }


    private async updateNamedExpressions(row: any[], commentrow: any[], objectnames: string[], excel, scene, path: string) {
        // namedObjectExpressions beim erzeugen des graphen
        var sheetid = await excel.getSheetId("sheetname");

        for (var i = 0; i < commentrow.length; i++) {
            if (commentrow[i] == "pos" || commentrow[i] == "p1" || commentrow[i] == "p2") {
                if (row[i] && typeof row[i] === 'string') {
                    for (const objectName of objectnames) {
                        // Match pattern: objectName followed by dot and number
                        const regex = new RegExp(`^${objectName}\\.\\d+$`);
                        if (regex.test(row[i])) {
                            // Found match
                            const namedExpression = row[i]; // this.prependUnderscoreToNumbers(row[i]);
                            var index = parseInt(namedExpression.split('.')[1]);
                            var outputid2 = namedExpression.split('.')[0];
                            // get value of anchor, bis jetzt nur anchors in gleichem projekt unterstützt
                            var anchorpath = path;

                            // userdata von anchor sprite                         
                            // index =
                            // 8
                            // isHelper =
                            // true
                            // origpos =
                            // Vector3 {x: 50, y: 50, z: -50}
                            // outputid2 =
                            // 'cube35'
                            // type =
                            // 'refpoint'
                            const anchor = ThreeUtils.getObjectByUserDataProps(scene, ["outputid2", "index"], [outputid2, index]);
                            if (anchor) {
                                const value = anchor.position.toArray();
                                const worldPosition = new THREE.Vector3();
                                anchor.getWorldPosition(worldPosition);
                                row[i] = `(${worldPosition.x},${worldPosition.y},${worldPosition.z})`;
                                const worldValue = worldPosition.toArray();
                                const origpos = anchor.userData.origpos.toArray();
                                console.log("anchor", anchor, value, origpos, worldValue);
                            }

                            // ggf. über namedExpression setzen, flexibler?
                            //  const cellRef = `Sheet${sheetid + 1}!${String.fromCharCode(65 + i)}${rowindex + 1}`;
                            // if (!excel.hasNamedExpression(namedExpression)) {
                            //    const changes =  excel.addNamedExpression(namedExpression, `(0,0,0)`, sheetid);
                            // } else {
                            //     const changes = excel.updateNamedExpression(namedExpression, `(0,0,0)`, sheetid);
                            // }
                        }
                    }
                }
            }
        }
        return row;
    }

    // Helper method to check if row exists in other nodes and create an instance if found
    private checkRowExistsInOtherNodes(row: any[], scene: THREE.Scene, currentPath: string, params: any): THREE.Mesh | THREE.InstancedMesh | null {
        let existingMesh: THREE.Mesh | null = null;
        let instanceCount = 0;

        // First pass: count instances and find existing mesh
        scene.traverse((node) => {
            if (node.userData?.row && node.name !== currentPath) {
                // Create copies of the rows to compare
                const rowToCheck = [...row];
                const existingRow = [...node.userData.row];
                const commentrow = node.userData.commentrow;

                // Skip comparison of transformation parameters
                if (commentrow) {
                    for (let i = 0; i < commentrow.length; i++) {
                        const comment = commentrow[i]?.toLowerCase();
                        if (comment === 'x' || comment === 'y' || comment === 'z' ||
                            comment === 'rx' || comment === 'ry' || comment === 'rz' ||
                            comment === 'sx' || comment === 'sy' || comment === 'sz') {
                            rowToCheck[i] = null;
                            existingRow[i] = null;
                        }
                    }
                    rowToCheck[0] = null;
                    existingRow[0] = null;
                }

                // Compare the modified rows
                if (JSON.stringify(rowToCheck) === JSON.stringify(existingRow)) {
                    instanceCount++;
                    if (!existingMesh && node instanceof THREE.Mesh) {
                        existingMesh = node;
                    }
                }
            }
        });

        // If we found an existing mesh, create a new mesh with the same geometry and material
        if (existingMesh) {
            console.log(`Found ${instanceCount} instances of the same object. Creating new mesh.`);

            // Create a new mesh with the same geometry and material
            const newMesh = new THREE.Mesh(
                existingMesh.geometry,
                existingMesh.material
            );

            // Copy basic properties
            newMesh.castShadow = existingMesh.castShadow;
            newMesh.receiveShadow = existingMesh.receiveShadow;
            newMesh.name = currentPath;

            return newMesh;
        }

        return null;
    }

    async checkRowValid(row: any[], commentrow: any[]) {
        for (let j = 0; j < row?.length; j++) {
            if (typeof row[j] === 'string') {
                if (row[j]?.startsWith("#.")) {
                    return false;
                }
            }
        }

        // Check that x, y, z, width, height, length parameters are numbers
        const numericParams = ['x', 'y', 'z', 'width', 'height', 'length'];

        for (let j = 0; j < commentrow.length; j++) {
            if (typeof commentrow[j] === 'string') {
                const comment = commentrow[j]?.toLowerCase();
                if (numericParams.includes(comment)) {
                    // Check if the corresponding value is a valid number
                    if (row[j] !== null && row[j] !== undefined) {
                        const numValue = parseFloat(row[j]);
                        if (isNaN(numValue)) {
                            console.warn(`Invalid numeric value for ${comment}: ${row[j]}`);
                            return false;
                        }
                    }
                }
            }

        }

        return true;
    }

    async createOrUpdateCADNode(rowindex: number, sheetid: number, name: string, row: any[], commentrow: any[], scene: THREE.Scene, excels: any, configuration: string, loaded: any, workers: any, customerid: string, projectid: string, projectconfigmodel: any, sourcesheetid, forceupdate = false) {
        if (!row[0])
            return null;

        if (!this.checkRowValid(row, commentrow)) {
            return null;
        }



        // if (row[0] === "copy") {
        //     const sourceObjectId = row[1];
        //     const copiedObject = await this.createCopy(sourceObjectId, scene);

        //     if (copiedObject) {
        //         copiedObject.name = name;
        //         scene.add(copiedObject);

        //         // Apply standard transformations
        //         if (row[5]) copiedObject.position.x = parseFloat(row[5]);
        //         if (row[6]) copiedObject.position.y = parseFloat(row[6]);
        //         if (row[7]) copiedObject.position.z = parseFloat(row[7]);
        //         if (row[8]) copiedObject.rotation.x = this.grad2rad(parseFloat(row[8]));
        //         if (row[9]) copiedObject.rotation.y = this.grad2rad(parseFloat(row[9]));
        //         if (row[10]) copiedObject.rotation.z = this.grad2rad(parseFloat(row[10]));

        //         return copiedObject;
        //     }
        //     return null;
        // }
        name = name.replace(/root\^/g, "");
        //    console.log('name', name)
        var prenames = scene.name; // Utils.preNames(scene);
        var path = prenames + "^" + name;
        path = path.replace(/root\^/g, "");
        path = "root^" + path;
        path = path.replace(/\^^/g, "^");
        path = path.replace(/\^\^/g, "^");
        path = path.replace(/\^\^/g, "^");



        // For subprojects, ensure consistent path format
        // if (row[1]?.toUpperCase().startsWith('PROJECT:')) {
        //     // If this is not the first sheet (sheetid > 0), ensure sheet info is included
        //     if (sheetid > 0) {
        //         const sheetPrefix = `$${sourcesheetid || sheetid}#sheet: Sheet${sheetid + 1}`;
        //         //     if (!path.includes(sheetPrefix)) {
        //         // Extract project and object parts
        //         const projectMatch = path.match(/\$\d+#project\d+/);
        //         const objectName = name.split('#').pop();
        //         if (projectMatch) {
        //             path = `root^${sheetPrefix}^${projectMatch[0]}^${objectName}`;
        //         }
        //         //     }
        //     }
        // }

        //  console.log("path", path);
        var params = Utils.mapRowToParams(row, commentrow);

        // Check for existing instances and create instanced mesh if needed
        // const instancedMesh = this.checkRowExistsInOtherNodes(row, scene, path, params);
        // if (instancedMesh) {
        //     scene.add(instancedMesh);
        //     // set userdata of instanced mesh
        //     instancedMesh.userData.row = row;
        //     instancedMesh.userData.commentrow = commentrow;
        //     instancedMesh.userData.path = path;
        //     instancedMesh.userData.isInstanced = true;
        //     instancedMesh.userData.rowindex = rowindex;
        //     instancedMesh.userData.sheetid = sheetid;
        //     instancedMesh.userData.name = name;
        //     instancedMesh.userData.typ = row[1];
        //     instancedMesh.userData.isSheetOrSubproject = isSheetOrSubproject;
        //     instancedMesh.userData.configuration = configuration;
        //     instancedMesh.userData.loaded = loaded;
        //     instancedMesh.userData.workers = workers;
        //     instancedMesh.userData.customerid = customerid;
        //     instancedMesh.userData.projectid = projectid;
        //     instancedMesh.userData.projectconfigmodel = projectconfigmodel;
        //     instancedMesh.userData.sourcesheetid = sourcesheetid;
        //   //  return instancedMesh;
        // }

        // Continue with original createOrUpdateCADNode logic...
        var cadnode = null;
        var object = scene.getObjectByName(path);
        // 'root^$0#sheet: Sheet84^$2#project49^$0#outerframe'
        //  root^$0#sheet: Sheet84^$2#project49^$0#outerframe

        // "root^$2#project49^$0#outerframe"    nach ersten eerzeugen

        // Check if node was previously cut and needs recreation
        var cuttedBy = false;
        var tocutoutputids = null;
        var cutoutputids = null;
        if (!forceupdate) {
            //          console.log('Node was previously cut, recreating:', name);
            cuttedBy = object?.userData?.cuttedBy;
            // const recreatedNode = await this.recreateCADNode(existingNode, scene, excels);
            // if (recreatedNode) {
            //     return recreatedNode;
            tocutoutputids = object?.userData?.tocutoutputids;
            cutoutputids = object?.userData?.cutoutputids;



            // }
        }
        //  if (object?.userData.tocutoutputids)
        //      tocutoutputids = object.userData.tocutoutputids;

        // "root^$0#sheet: Sheet84^$2#project49^$0#cube14"

        //        console.log("path", path, object);
        //        console.log('scene', scene);

        var isSheetOrSubproject = false; 6
        if (row?.length > 1)
            isSheetOrSubproject = row[1]?.toUpperCase().startsWith('SHEET:') || row[1]?.toUpperCase().startsWith('PROJECT:') || false;

        var diff = 3;// recreate
        if (object) {
            var oldrow = object.userData.row;
            var tcommentrow = object.userData.commentrow;
            var diff = this.diffTypeOfRow(tcommentrow, oldrow, row); // x,y,z etc keine neueerstellung, #TODO: bei subproject subnodes check und update
            if (forceupdate) diff = 3;
            if (diff > 2) { // && !isSheetOrSubproject) {
                //       console.log("remove", object.name);
                scene.remove(object);
            }
            else
                cadnode = object;

        }

        // Check if row is marked as not visible
        if (params?.visible === false) {
            if (object) {
                scene.remove(object);
            }
            return null;
        }

        // parameter überschreiben, wenn config gesetzt
        var config = null;
        var defaultrow = null;
        if (projectconfigmodel)
            if (projectconfigmodel[path])
                config = projectconfigmodel[path];
        if (config) {
            defaultrow = JSON.parse(JSON.stringify(row));
            row = config.row;
            commentrow = config.commentrow;
            // ##TODO! _hier_ check auf zell abhängigkeiten von row auf andere zellen im aktuellem sheet und neu holen

        }


        // other sheets
        var group = null;

        if (diff > 2) {

            if (row[1].toUpperCase().startsWith('SHEET:')) {

                var sheetname = row[1].split(': ')[1];
                sheetid = await excels[configuration].getSheetId(sheetname);
                const startTime = performance.now();
                // #todo: set/getconfiguration kann auch andere änderungen verursachen in sheet
                var outputRowsObject = await excels[configuration].getConfiguration(sheetid, commentrow, row);
                var outputRows = outputRowsObject.map(row => row.data);
                var outputRowIndexes = outputRowsObject.map(row => row.rowindex);
                const endTime = performance.now();
                //      console.log(`getConfiguration took ${endTime - startTime} milliseconds`);
                group = new THREE.Group();

                // wenn neue cadnode project, config holen und in sheet schreiben. geänderte Zellen updaten/outputRows neu holen, die noch über sind
                // const { outputRows: updatedOutputRows, outputRowIndexes: updatedOutputRowIndexes } =
                //     await this.updateConfigurationAndOutputRows(path, projectconfigmodel, excels, outputRows, outputRowIndexes);
                // outputRows = updatedOutputRows;
                // outputRowIndexes = updatedOutputRowIndexes;

                group.userData.isSheet = true;

                var cr = null;
                for (var i = 0; i < outputRows.length; i += 1) {

                    if (outputRows[i][0] == '#') {
                        cr = outputRows[i];
                        i++
                    }
                    try {
                        const startTime = performance.now();
                        var name = path + "$" + sheetid + "#" + outputRows[i][0];
                        var outputRowIndex = outputRowIndexes[i];
                        var tcadnode = await this.createOrUpdateCADNode(outputRowIndex, sheetid, name, outputRows[i], cr, group, excels, configuration, loaded, workers, customerid, projectid, projectconfigmodel, sourcesheetid);
                        const endTime = performance.now();
                        //       console.log(`createOrUpdateCADNode took ${endTime - startTime} milliseconds`);
                        //   cadnode.userData.issheet = true;
                        if (!tcadnode) {
                            console.warn("warn", "sheet Cadnode creation failed", typ, rowindex, name, row, commentrow, configuration);
                            continue;
                        }
                    } catch (error) {
                        console.log("Error in createOrUpdateCADNode sheet", path, cadnode)

                    }

                    cadnode = tcadnode;
                    // cadnode.userData.configuration = subconfigurationname;
                    //cadnode.userData.commentrow = commentrow;
                    //cadnode.userData.row = row;
                    //  cadnode.userData.rowindex = rowindex;
                    // cadnode.userData.typ = outputRows[i][1];
                }
            }

            // other Projects
            // TODO: laden
            var typ = row[1].toUpperCase();
            if (row[1].toUpperCase().startsWith('PROJECT:')) { // TODO: LIBRARY: ...
                var sourcesheetid1 = sheetid;
                var subconfigurationname = row[1].split(': ')[1]; // deprecated: customerid + "_" + row[1].split(': ')[1];
                console.log(path);

                // Extract last number between ^ and # from path
                const pathMatch = path.match(/\^(\d+)#/);
                const lastNumber = pathMatch ? pathMatch[1] : null;
                console.log('Last number in path:', lastNumber);
                if (lastNumber) {
                    sourcesheetid1 = parseInt(lastNumber);
                }

                var sheetnameP = "Sheet 1";
                var sheetIdP = 0;// await excels[subconfigurationname].getSheetId(sheetnameP);
                // konfigparameter setzen, achtung bei mehrerenunterkongiruation und konfigspeicherung von nutzer
                //     console.log("subconfigurationname", subconfigurationname, excels[subconfigurationname])
                if (!excels[subconfigurationname])
                    return null;

                // #TODO: schreibt eigentlich auch werte in parent sheet
                var outputRowsObject = await excels[subconfigurationname].getConfiguration(sheetIdP, commentrow, row);
                var outputRowsP = outputRowsObject.map(row => row.data);
                var outputRowIndexes = outputRowsObject.map(row => row.rowindex);
                // wenn neue cadnode project, config holen und in sheet schreiben. geänderte Zellen updaten/outputRows neu holen, die noch über sind
                // const { outputRows: updatedOutputRows, outputRowIndexes: updatedOutputRowIndexes } =
                //     await this.updateConfigurationAndOutputRows(path, projectconfigmodel, excels, outputRows, outputRowIndexes);
                // outputRows = updatedOutputRows;
                // outputRowIndexes = updatedOutputRowIndexes;

                group = new THREE.Group();
                // Remove any double carets from path
                path = path.replace(/\^\^+/g, '^');
                group.name = path;// name;
                group.userData.typ = row[1];
                group.userData.subproject = subconfigurationname;
                group.userData.issubproject = true;
                group.userData.sourcesheetid = sourcesheetid1;
                scene.add(group);
                //  group.name = this.preNames(group);
                // cadnode = await this.createCADNode(row[0], row[1], row[0], group, excels, configurationname, loaded, workers, customerid, projectid);

                // TODO achtung mit weiteren zeilen TODO: head bei mehrren rows !!
                var cr = null;
                for (var i = 0; i < outputRowsP.length; i += 1) {
                    if (outputRowsP[i][0] == '#') {
                        cr = outputRowsP[i];
                        i++
                    }
                    try {
                        const startTime = performance.now();
                        //    console.log('subconfigurationname', subconfigurationname);
                        var name = "$" + sheetIdP + "#" + outputRowsP[i][0];
                        var outputRowIndex = outputRowIndexes[i];
                        var tcadnode = await this.createOrUpdateCADNode(outputRowIndex, sheetIdP, name, outputRowsP[i], cr, group, excels, subconfigurationname, loaded, workers, customerid, projectid, projectconfigmodel, sourcesheetid1);
                        const endTime = performance.now();

                        if (!tcadnode) {
                            continue;
                        }
                        //        console.log(`createOrUpdateCADNode took ${endTime - startTime} milliseconds`);
                        //        console.log("subproject cadnode", cadnode);
                        //  cadnode = await this.createOrUpdateCADNode(rowindex, sheetid, "$" + sheetid + "#" + outputRows[i][0], outputRows[i], cr, group, excels, configuration, loaded, workers, customerid, projectid, projectconfigmodel);
                    } catch (error) {
                        console.log("Error", error)

                    }
                    cadnode = tcadnode;
                }

            }

            // 
            var objectnames = await excels[configuration].getObjects3dNames(sheetid);
            row = await this.updateNamedExpressions(row, commentrow, objectnames, excels[configuration], scene, path);
            params = Utils.mapRowToParams(row, commentrow);


            const startTime1 = performance.now();

            // Primitives
            switch (typ) {
                case "LINE":
                    cadnode = await this.createLine(params['p1'], params['p2'], params['width'], params['material']);
                    break;
                case "DIMENSIONLINE":
                    var paramsobj = {
                        orthogonalLength: params.orthogonalLength,
                        orthogonalOffset: params.orthogonalOffset,
                        textSize: params.textSize,
                        textPadding: params.textPadding,
                        textBackground: params.textBackground,
                        textColor: params.textColor,
                        rotation: params.rotation
                    }
                    cadnode = await this.createDimensionLine(params['p1'], params['p2'], params['width'], params['material'], paramsobj);
                    if (!cadnode) {
                        console.warn("warn", "Dimension line creation failed");
                        return null;
                    }
                    break;

                case "SHAPE":
                    // Use enhanced shape creation that supports mixed segments and circles
                    cadnode = await this.createEnhancedShape(params);
                    if (!cadnode) {
                        // Fallback to regular shape creation
                        cadnode = await this.createShape(
                            params['points'],
                            parseFloat(params['depth']), // Ensure depth is a number
                            params['material'],
                            params['splinePath'],    // Legacy parameter
                            params['splineDivisions'] ? parseInt(params['splineDivisions']) : undefined // Legacy parameter
                        );
                    }
                    break;
                case "SURFACE":
                    cadnode = await this.createSurface(params['points'], params['indices'], params['material']);
                    break;
                case "TEXTFLAT":
                    cadnode = await this.createText(params['textflat'], params['font'], params['fontsize'], params['color'], params['align']);
                    break;
                case "EXTRUSION":
                    const bevelWidth = parseFloat(params['bevelwidth']) || 0;
                    const bevelSegments = parseInt(params['bevelsegments']) || 1;
                    cadnode = await this.createExtrusion(params['baseplane'], params['extrusionvector'], params['material'], bevelWidth, bevelSegments);
                    break;
                case "SUBTRACTION":
                    // TODO: funktioniert noch nicht für unterprojekte
                    // hier wird nur die subtraction geändert, nicht wenn sich eines der objekte geändert hat
                    cadnode = await this.createSubtraction(params['cuttedoutputids'], params['cutoutputids'], sheetid, scene, name, path, configuration, excels);
                    return;
                    break;
                case "RING": // Added ring case
                    cadnode = this.createRing(params['outerRadius'], params['innerRadius'], params['depth'], params['material']);
                    break;
                case "CYLINDER":
                    try {

                        cadnode = await this.createCylinder(params['radiusTop'], params['radiusBottom'], params['height'], params['material']);
                    }
                    catch (err) {
                        console.log("error", err)
                    }

                    break;
                case "SPHERE":
                    cadnode = this.createSphere(params['radius'], params['material']);
                    break;
                case "CAPSULE":
                    cadnode = this.createCapsule(params['radius'], params['length'], params['capSubdivisions'], params['radialSegments'], params['material']);
                    break;
                case "CUBE":
                    cadnode = this.createCube(params['width'], params['length'], params['height'], params['material'], params['segments']);
                    break;
                case "IMAGE3D":
                    cadnode = await this.createBillboard(params['width'], params['height'], params['material'], params['filename']);
                    break;
                case "LATHE":
                    cadnode = this.createLathe(params['points'], params['material']);
                    break;
                case "TUBE":
                    // Parse bendRadiusFactor, provide default if missing/invalid
                    let bendFactor = parseFloat(params['bendradiusfactor']);
                    if (isNaN(bendFactor) || bendFactor <= 0) {
                        bendFactor = 1.5; // Default value
                    }
                    cadnode = this.createTube(params['path'], parseFloat(params['radius']), bendFactor, this.str2material(params['material']));
                    break;
                case "SPRING":
                    cadnode = this.createSpring(
                        parseFloat(params['radius']),
                        parseFloat(params['pitch']),
                        parseFloat(params['turns']),
                        parseFloat(params['wireRadius']),
                        parseFloat(params['length']),
                        this.str2material(params['material'])
                    );
                    break;
                case "LIGHT":
                    cadnode = await this.createLight(params['color'], params['intensity'], params['distance'], params['decay']);
                    break;
                case "GLTF":
                    cadnode = await this.createGltf(params['filename']);
                    break;
                case "PROFILE":
                    cadnode = await this.createProfile(params['points'], params['depth'], params['material']);
                    break;
                case "CONNECTOR":
                    // Parse position from params or fallback to standard position fields
                    let connectorPosition: THREE.Vector3;
                    if (params['position']) {
                        // Parse position string "(x,y,z)"
                        const posStr = params['position'].replace('(', '').replace(')', '').split(',');
                        connectorPosition = new THREE.Vector3(
                            parseFloat(posStr[0]) || 0,
                            parseFloat(posStr[1]) || 0,
                            parseFloat(posStr[2]) || 0
                        );
                    } else {
                        // Fallback to individual x,y,z parameters
                        connectorPosition = new THREE.Vector3(
                            parseFloat(params.x) || 0,
                            parseFloat(params.y) || 0,
                            parseFloat(params.z) || 0
                        );
                    }

                    // Parse normal vector from string "(x,y,z)"
                    let connectorNormal: THREE.Vector3;
                    if (params['normal']) {
                        const normalStr = params['normal'].replace('(', '').replace(')', '').split(',');
                        connectorNormal = new THREE.Vector3(
                            parseFloat(normalStr[0]) || 0,
                            parseFloat(normalStr[1]) || 1,
                            parseFloat(normalStr[2]) || 0
                        );
                    } else {
                        connectorNormal = new THREE.Vector3(0, 1, 0); // Default normal
                    }

                    const connectorLabel = params['label'] || 'C1';

                    // Advanced connector parameters
                    const connectorParams = {
                        type: params['type'] || 'sphere', // Default to sphere type
                        showArrow: this.parseBoolean(params['showArrow']),
                        showSphere: true, // Force show sphere for now while debugging
                        arrowLength: parseFloat(params['arrowLength']) || 15,
                        arrowColor: params['arrowColor'] ? parseInt(params['arrowColor'].replace('#', '0x')) : 0xff0000,
                        sphereRadius: parseFloat(params['sphereRadius']) || 3,
                        sphereColor: params['sphereColor'] ? parseInt(params['sphereColor'].replace('#', '0x')) : 0x4CAF50,
                        connectorType: params['connectorType'] || 'default',
                        size: parseFloat(params['size']) || 128,
                        shape: params['shape'] || 'circle',
                        backgroundColor: params['backgroundColor'] || 'rgba(255, 255, 255, 0.9)',
                        borderColor: params['borderColor'] || 'rgba(0, 0, 0, 0.8)',
                        textColor: params['textColor'] || 'rgba(0, 0, 0, 1)',
                        interactive: this.parseBoolean(params['interactive']) !== false
                    };

                    console.log('[CONNECTOR DEBUG] Creating connector with params:', connectorParams);

                    cadnode = this.createConnectorVisualization(connectorPosition, connectorNormal, connectorLabel, connectorParams);

                    // Store engineering parameters in userData for later reference
                    if (cadnode) {
                        cadnode.userData.engineeringParams = {
                            voltage: params['voltage'],
                            current: params['current'],
                            pressure: params['pressure'],
                            flowRate: params['flowRate'],
                            fluidType: params['fluidType'],
                            threadSize: params['threadSize'],
                            material: params['material'],
                            torque: params['torque']
                        };

                        // Set the outputid that will be used later for the connector
                        const outputid = name.split('#').pop();
                        cadnode.userData.outputid = outputid;
                    }
                    break;
                case "IBEAM":
                case "ibeam":
                    const ibeamParams = {
                        profile: row[2],
                        width: row[3] ? parseFloat(row[3]) : undefined,
                        height: row[4] ? parseFloat(row[4]) : undefined,
                        length: row[5] ? parseFloat(row[5]) : 150,
                        flangeThickness: row[6] ? parseFloat(row[6]) : undefined,
                        webThickness: row[7] ? parseFloat(row[7]) : undefined,
                        material: this.str2material(row[8] || "#445566"),
                        startSlope: parseFloat(row[9] || "0"),
                        endSlope: parseFloat(row[10] || "0"),
                        x: parseFloat(row[11] || "0"),
                        y: parseFloat(row[12] || "0"),
                        z: parseFloat(row[13] || "0"),
                        rx: parseFloat(row[14] || "0"),
                        ry: parseFloat(row[15] || "0"),
                        rz: parseFloat(row[16] || "0")
                    };

                    //            console.log("Creating I-beam with parameters:", ibeamParams);

                    cadnode = this.createIBeam(
                        ibeamParams.profile,
                        ibeamParams.width,
                        ibeamParams.height,
                        ibeamParams.length,
                        ibeamParams.flangeThickness,
                        ibeamParams.webThickness,
                        ibeamParams.material,
                        ibeamParams.startSlope,
                        ibeamParams.endSlope
                    );

                    if (cadnode) {
                        this.setNodeTransformations(cadnode, {
                            x: ibeamParams.x,
                            y: ibeamParams.y,
                            z: ibeamParams.z,
                            rx: ibeamParams.rx,
                            ry: ibeamParams.ry,
                            rz: ibeamParams.rz
                        });
                    } else {
                        console.warn("Failed to create I-beam", ibeamParams);
                    }
                    break;

                case "aluprofile":
                    const aluMaterial = this.str2material(params.material);
                    const aluProfileMesh = this.createAluProfile(params.series, params.size, params.length, aluMaterial);
                    if (aluProfileMesh) {
                        cadnode = aluProfileMesh;
                    }
                    break;

                case "light":
                    cadnode = await this.createLight(params.color, params.intensity, params.distance, params.decay);
                    break;
                case "GLTF":
                    cadnode = await this.createGltf(params['filename']);
                    break;
                case "PROFILE":
                    cadnode = await this.createProfile(params['points'], params['depth'], params['material']);
                    break;

                case "GRID":
                case "grid":
                    cadnode = this.createMeasuringGrid(
                        name,
                        parseFloat(params['width']), // width
                        parseFloat(params['length']), // length
                        parseFloat(params['mainGap']), // mainGap
                        parseFloat(params['subGap']), // subGap
                        parseFloat(params['nthLabel']), // nthLabel
                        parseFloat(params['labelSize']), // labelSize
                        parseFloat(params['lineWidth']), // lineWidth
                        params['mainColor'],             // mainColor
                        params['subColor'],             // subColor
                        params['labelColor'],            // labelColor
                        {
                            showSubLines: params['showSubLines'] !== 'false',
                            showLabels: params['showLabels'] !== 'false',
                            startX: params['startX'] ? parseFloat(params['startX']) : undefined,
                            endX: params['endX'] ? parseFloat(params['endX']) : undefined,
                            startY: params['startY'] ? parseFloat(params['startY']) : undefined,
                            endY: params['endY'] ? parseFloat(params['endY']) : undefined,
                            labelOffsetX: params['labelOffsetX'] ? parseFloat(params['labelOffsetX']) : 0,
                            labelOffsetY: params['labelOffsetY'] ? parseFloat(params['labelOffsetY']) : 0
                        }
                    );
                    break;

                case "ARROW":
                    cadnode = this.createArrow(
                        params['start'],
                        params['end'],
                        parseFloat(params['width']),
                        params['material'],
                        parseFloat(params['headLength']),
                        parseFloat(params['headWidth'])
                    );
                    break;

                case "lathe":
                    cadnode = this.createLathe(params['points'], params['material']);
                    break;
                case "SPRING":
                    cadnode = this.createSpring(
                        parseFloat(params['radius']),
                        parseFloat(params['pitch']),
                        parseFloat(params['turns']),
                        parseFloat(params['wireRadius']),
                        parseFloat(params['length']),
                        this.str2material(params['material'])
                    );
                    break;
            }

            if (!cadnode) {
                console.warn("warn", "Cadnode creation failed", typ, rowindex, name, row, commentrow, configuration);
                return null;
            }


            const endTime1 = performance.now();
            //     console.log(`GEOMETRY Generation took ${endTime1 - startTime1} milliseconds`);

            if (!cadnode && !group) {
                console.warn("no cadnode ", typ, rowindex, name, row, commentrow, configuration);
                return;
            }

            // Kanten
            if (typ == "EXTRUSION" || typ == "CYLINDER" || typ == "SUBTRACTION" || typ == "CUBE" || typ == "CAPSULE") {

                if (!(params['edges'] == false && typeof (params['edges']) === "boolean")) {

                    var egeometry = new THREE.EdgesGeometry(cadnode.geometry, 15);
                    var linestandard = new THREE.LineSegments(egeometry, new THREE.LineBasicMaterial({ color: new THREE.Color('black'), linewidth: 1, transparent: false, }));
                    linestandard.name = "KANTE";
                    linestandard.userData.type = "edge";
                    linestandard.userData.isHelper = true;
                    linestandard.userData.path = cadnode.userData.path;

                    cadnode.add(linestandard);
                }


            }


            //            cadnode.userData.outputid = path.split('#')[path.split('#').length - 1];


            var fcname = path.split('#')[path.split('#').length - 1];;

            const startTime2 = performance.now();
            // Add face centers to all mesh objects, including complex geometries
            if (cadnode instanceof THREE.Mesh || (cadnode instanceof THREE.Group && cadnode.children.some(child => child instanceof THREE.Mesh))) {
                this.addFaceCenters(cadnode, fcname); // #TODO: zieht zu viel zeit!!!

                // Also add face centers to child meshes in groups
                if (cadnode instanceof THREE.Group) {
                    cadnode.traverse((child) => {
                        if (child instanceof THREE.Mesh && child !== cadnode && child.geometry) {
                            const childName = fcname + '_' + (child.name || 'child');
                            this.addFaceCenters(child, childName);
                        }
                    });
                }
            }
            const endTime2 = performance.now();
            //console.log(`addFaceCenters took ${endTime2 - startTime2} milliseconds`);

            // scene.traverse(child => { // TODO: gehjt schöner?
            //     if (child.userData.type === "refpoint" || child.userData.type === "refnormal") {
            //         child.visible = false;
            //     }
            // });
        }

        if (group) {
            cadnode = group;
        }
        cadnode.position.x = 0;  // Reset to 0
        cadnode.position.y = 0;
        cadnode.position.z = 0;
        cadnode.rotation.x = 0;
        cadnode.rotation.y = 0;
        cadnode.rotation.z = 0;
        cadnode.scale.x = 1;
        cadnode.scale.y = 1;
        cadnode.scale.z = 1;

        const startTime = performance.now();


        if (params['refrot'] != null) {   // params von cube
            try {
                const [refoutputid, indexStr] = params['refrot'].split('.');
                const index = parseInt(indexStr);
                const refobj = ThreeUtils.getObjectByUserDataProp(scene, "outputid", refoutputid);
                // const refnormalob = refobj?.children?.find(child => child.userData.index === index && child.userData.type === "refnormal" && child.userData.isHelper);
                let reforientationvector = ThreeUtils.getRotationVectorByObjectNameAndFaceCenterIndex(scene, refoutputid, index, cadnode);
                let refnormalob = reforientationvector;


                if (refnormalob) {
                    const refnormal = refnormalob.clone();
                    console.log("refnormal", refnormal);
                    cadnode.updateMatrixWorld(true);

                    const normalMatrix = new THREE.Matrix4();
                    normalMatrix.lookAt(new THREE.Vector3(0, 0, 0), refnormal, new THREE.Vector3(0, 0, -1));
                    var q = new THREE.Quaternion();

                    q.setFromRotationMatrix(normalMatrix);
                    //     const xAxis = new THREE.Vector3(1, 0, 0);
                    //     const qRotation = new THREE.Quaternion();
                    //     qRotation.setFromAxisAngle(xAxis, Math.PI / 2);
                    //     q.multiply(qRotation);

                    // cadnode.quaternion.copy(q);
                    //  refobj.updateMatrixWorld(true);
                    //  refobj.updateMatrix();      
                    cadnode.quaternion.copy(refobj.quaternion.clone());
                    cadnode.quaternion.multiply(q);

                    const rotationQuat = new THREE.Quaternion();
                    if (params['rx'] != null) {
                        const rxQuat = new THREE.Quaternion();
                        rxQuat.setFromAxisAngle(new THREE.Vector3(1, 0, 0), THREE.MathUtils.degToRad(parseFloat(params['rx'])));
                        rotationQuat.multiply(rxQuat);
                        cadnode.userData.rx = params['rx'];
                    }
                    if (params['ry'] != null) {
                        const ryQuat = new THREE.Quaternion();
                        ryQuat.setFromAxisAngle(new THREE.Vector3(0, 1, 0), THREE.MathUtils.degToRad(parseFloat(params['ry'])));
                        rotationQuat.multiply(ryQuat);
                        cadnode.userData.ry = params['ry'];
                    }
                    if (params['rz'] != null) {
                        const rzQuat = new THREE.Quaternion();
                        rzQuat.setFromAxisAngle(new THREE.Vector3(0, 0, 1), THREE.MathUtils.degToRad(parseFloat(params['rz'])));
                        rotationQuat.multiply(rzQuat);
                        cadnode.userData.rz = params['rz'];
                    }
                    cadnode.quaternion.multiply(rotationQuat);

                    cadnode.updateMatrix();
                    cadnode.userData.refnormalobj = refnormalob;
                    if (!refobj.userData.refnormalobjs)
                        refobj.userData.refnormalobjs = [];
                    refobj.userData.refnormalobjs[params['refrot']] = cadnode;
                    cadnode.userData.refrot = params['refrot'];
                }

            } catch (error) {
                console.warn("refrot error", error);
            }
        }


        // refpoints
        // parent object durchiterieren und beziehungen entsprechend udpaten (nur x,y,z,rx,ry,rz,sx,sy,sz)
        if (params['refpos']) {
            try {
                // CRITICAL: Never modify connector positions!
                if (cadnode.userData?.isConnector) {
                    console.warn('[CONNECTOR PROTECTION] Blocked attempt to modify connector position via refpos:', cadnode.userData.connectorLabel || cadnode.userData.outputid);
                } else {
                    let refposvector: THREE.Vector3 | null = null;
                    let refobj: THREE.Object3D | null = null;

                    // Check if refpos is a connector name (no dot separator)
                    if (!params['refpos'].includes('.')) {
                        // This is a connector name
                        const connectorName = params['refpos'];
                        refposvector = this.getWorldVectorByConnectorName(scene, connectorName, cadnode);

                        // Find the connector group for reference
                        scene.traverse((child) => {
                            if (child.userData?.isConnector &&
                                child.userData?.connectorLabel === connectorName &&
                                child instanceof THREE.Group) {
                                refobj = child;
                            }
                        });
                    } else if (params['refpos'].includes('.') && params['refpos'].endsWith('.connector')) {
                        // This is outputid.connector format
                        const [connectorOutputId, _] = params['refpos'].split('.');

                        // Find the connector by its outputid/label
                        scene.traverse((child) => {
                            if (child.userData?.isConnector &&
                                (child.userData?.connectorLabel === connectorOutputId || child.userData?.outputid === connectorOutputId) &&
                                child instanceof THREE.Group) {
                                // Get world position of the connector
                                refposvector = new THREE.Vector3();
                                child.getWorldPosition(refposvector);
                                refobj = child;
                            }
                        });

                        // Fallback to getWorldVectorByConnectorName if not found
                        if (!refposvector) {
                            refposvector = this.getWorldVectorByConnectorName(scene, connectorOutputId, cadnode);
                        }
                    } else {
                        // This is a face center reference
                        const [refoutputid, indexStr] = params['refpos'].split('.');
                        const index = parseInt(indexStr);

                        // Only proceed if indexStr is a valid number
                        if (!isNaN(index)) {
                            refposvector = ThreeUtils.getWorldVectorByObjectNameAndFaceCenterIndex(scene, refoutputid, index, cadnode);
                            refobj = ThreeUtils.getObjectByUserDataProp(scene, "outputid", refoutputid);
                        }
                    }

                    if (refposvector) {
                        // Store the original position before applying rotations
                        const originalPosition = refposvector.clone();

                        // Now set the position
                        cadnode.position.copy(originalPosition);

                        // Update matrices after rotation
                        cadnode.updateMatrix();
                        cadnode.updateMatrixWorld(true);

                        if (refobj) {
                            cadnode.userData.refposobj = refobj;
                            if (!refobj.userData.refposobjs)
                                refobj.userData.refposobjs = [];
                            refobj.userData.refposobjs[params['refpos']] = cadnode;
                        }
                        cadnode.userData.refpos = params['refpos'];

                        // If this is a connector reference, also establish dependency tracking
                        if (params['refpos'].includes('.') && params['refpos'].endsWith('.connector')) {
                            const [connectorOutputId, _] = params['refpos'].split('.');

                            // Find the connector and establish dependency
                            scene.traverse((child) => {
                                if (child.userData?.isConnector &&
                                    (child.userData?.connectorLabel === connectorOutputId || child.userData?.outputid === connectorOutputId) &&
                                    child instanceof THREE.Group) {

                                    // Track dependency on the connector
                                    cadnode.userData.refposobj = child;
                                    if (!child.userData.refposobjs)
                                        child.userData.refposobjs = [];
                                    child.userData.refposobjs[params['refpos']] = cadnode;
                                }
                            });
                        } else if (!params['refpos'].includes('.')) {
                            // Handle standalone connector name dependency
                            const connectorName = params['refpos'];

                            scene.traverse((child) => {
                                if (child.userData?.isConnector &&
                                    child.userData?.connectorLabel === connectorName &&
                                    child instanceof THREE.Group) {

                                    // Track dependency on the connector
                                    cadnode.userData.refposobj = child;
                                    if (!child.userData.refposobjs)
                                        child.userData.refposobjs = [];
                                    child.userData.refposobjs[params['refpos']] = cadnode;
                                }
                            });
                        }
                    }
                }
            } catch (error) {
                console.warn("refpos error", error);
            }
        }

        // CRITICAL: Special handling for connectors (both creation and recreation)
        if (cadnode.userData?.isConnector) {
            // This is a connector - always preserve original position from parameters only
            console.log('[CONNECTOR PROTECTION] Setting connector position directly from parameters for:', cadnode.userData.connectorLabel || cadnode.userData.outputid);

            // Set position directly from spreadsheet parameters (no transformations)
            const originalX = params['x'] ? parseFloat(params['x']) : 0;
            const originalY = params['y'] ? parseFloat(params['y']) : 0;
            const originalZ = params['z'] ? parseFloat(params['z']) : 0;

            cadnode.position.set(originalX, originalY, originalZ);
            console.log('[CONNECTOR PROTECTION] Set connector position to:', originalX, originalY, originalZ);
        } else {
            // Apply local position offsets after refpos and rotations (normal handling for non-connectors)
            cadnode.updateMatrix();
            if (params['x'] != null) {
                let xDirection = new THREE.Vector3(parseFloat(params['x']), 0, 0); // Local X
                xDirection.applyQuaternion(cadnode.quaternion);
                cadnode.position.add(xDirection);
            }
            if (params['y'] != null) {
                let yDirection = new THREE.Vector3(0, parseFloat(params['y']), 0); // Local Y
                yDirection.applyQuaternion(cadnode.quaternion);
                cadnode.position.add(yDirection);
            }
            if (params['z'] != null) {
                let zDirection = new THREE.Vector3(0, 0, parseFloat(params['z'])); // Local Z
                zDirection.applyQuaternion(cadnode.quaternion);
                cadnode.position.add(zDirection);
            }
        }

        // Special handling for text containers to preserve alignment
        if (cadnode.userData.isTextContainer) {
            // Store the original alignment offset
            const textMesh = cadnode.children[0];
            const originalX = textMesh.position.x;

            // Apply rotations to the container
            if (params['rx'] != null && params['refrot'] == null)
                cadnode.rotation.x = this.grad2rad(parseFloat(params['rx']));
            if (params['ry'] != null && params['refrot'] == null)
                cadnode.rotation.y = this.grad2rad(parseFloat(params['ry']));
            if (params['rz'] != null && params['refrot'] == null)
                cadnode.rotation.z = this.grad2rad(parseFloat(params['rz']));

            // Ensure text mesh maintains its alignment offset after container transformations
            textMesh.position.x = originalX;
        } else {
            // Normal rotation handling for non-text objects
            if (params['rx'] != null && params['refrot'] == null)
                cadnode.rotation.x = this.grad2rad(parseFloat(params['rx']));
            if (params['ry'] != null && params['refrot'] == null)
                cadnode.rotation.y = this.grad2rad(parseFloat(params['ry']));
            if (params['rz'] != null && params['refrot'] == null)
                cadnode.rotation.z = this.grad2rad(parseFloat(params['rz']));
        }

        // Apply scaling
        if (params['sx'] != null)
            cadnode.scale.x = parseFloat(params['sx']);
        if (params['sy'] != null)
            cadnode.scale.y = parseFloat(params['sy']);
        if (params['sz'] != null)
            cadnode.scale.z = parseFloat(params['sz']);

        // Handle origin after all other transformationsgr
        if (params['origin']) {
            const origin = params['origin'].split(',');
            if (origin.length == 3) {
                let direction = new THREE.Vector3(parseFloat(origin[0]), parseFloat(origin[1]), parseFloat(origin[2]));
                direction.applyQuaternion(cadnode.quaternion);
                cadnode.position.sub(direction);
                cadnode.userData.origin = direction;
            } else {
                const [refoutputid, indexStr] = params['origin'].split('.');
                const index = parseInt(indexStr);
                let refobj = ThreeUtils.getObjectByUserDataProp(scene, "outputid", refoutputid);
                if (!refobj)
                    refobj = cadnode;


                let refposvector = ThreeUtils.getLocalVectorByObjectNameAndFaceCenterIndex(refobj, index, cadnode);
                if (refposvector) {
                    // Transform refposvector to account for rotation
                    const rotatedRefPosVector = refposvector.clone();
                    if (cadnode.quaternion) {
                        rotatedRefPosVector.applyQuaternion(cadnode.quaternion);
                    }
                    cadnode.position.sub(rotatedRefPosVector);
                }
                cadnode.userData.origin = refposvector;
            }
        }

        if (isNaN(cadnode.position.x)) cadnode.position.x = 0;
        if (isNaN(cadnode.position.y)) cadnode.position.y = 0;
        if (isNaN(cadnode.position.z)) cadnode.position.z = 0;
        if (isNaN(cadnode.rotation.x)) cadnode.rotation.x = 0;
        if (isNaN(cadnode.rotation.y)) cadnode.rotation.y = 0;
        if (isNaN(cadnode.rotation.z)) cadnode.rotation.z = 0;
        if (isNaN(cadnode.scale.x)) cadnode.scale.x = 1;
        if (isNaN(cadnode.scale.y)) cadnode.scale.y = 1;
        if (isNaN(cadnode.scale.z)) cadnode.scale.z = 1;



        cadnode.visible = true;
        if (params['visible'] != null && params['visible'] != undefined) {
            if (params['visible'] == 0)
                cadnode.visible = false;
            else
                cadnode.visible = (params['visible']);
        }

        // CRITICAL: Special handling for connector visibility and scale preservation
        if (cadnode.userData?.isConnector) {
            // Ensure connector remains visible unless explicitly hidden
            if (params['visible'] == null || params['visible'] == undefined) {
                cadnode.visible = true;
            }

            // Preserve connector sprite scales during updates
            cadnode.traverse((child) => {
                if (child instanceof THREE.Sprite && child.userData.originalScale) {
                    // Reset to original scale if it was modified during interactions
                    child.scale.copy(child.userData.originalScale);
                }
            });

            console.log('[CONNECTOR PROTECTION] Ensured connector visibility and scale for:', cadnode.userData.connectorLabel || cadnode.userData.outputid, 'visible:', cadnode.visible);
        }


        const endTime = performance.now();

        // gltf nodes
        // createOrUpdateCADNode(a.row, sheetid, objectname, dataset[a.row], commentrow, scenenode, this.excels, this.selectedSubprojectID, this.toload, this.workers, this.customerid, this.projectid, this.project.configModel);
        for (var i = 0; i < commentrow?.length; i++) {
            try {
                if (commentrow[i]?.startsWith("node")) { // == "nodematerial") {
                    var objectname = path;
                    if (objectname) {
                        var object1 = cadnode;// scene.getObjectByName(objectname);
                        var nodename = commentrow[i].split('=')[1];

                        var statement = row[i];
                        var prop = statement.split('=')[0];
                        var value = statement.split('=')[1];
                        this.updateNodel(prop, nodename, value, object1);
                    }
                }

            } catch (error) {

            }
        }


        //  tnode.add(cadnode);
        cadnode.updateMatrix();
        path = path.replace(/\^\^+/g, '^');

        // Add sheet name to path if it's from a different sheet
        // if (sourcesheetid !== undefined && sourcesheetid !== sheetid) {
        //     const sheetName = row[0]; // Sheet name is in first column
        //     if (sheetName && !path.includes(sheetName)) {
        //         path = `${sheetName}^${path}`;
        //     }
        // }

        //  console.log('path', path);

        cadnode.name = path;
        cadnode.userData.configuration = configuration;
        cadnode.userData.typ = row[1];
        cadnode.userData.commentrow = commentrow;
        cadnode.userData.row = JSON.parse(JSON.stringify(row));
        if (!cadnode.userData.rowindex)
            cadnode.userData.rowindex = rowindex;
        cadnode.userData.sheetid = sheetid;
        cadnode.userData.sourcesheetid = sourcesheetid;
        cadnode.userData.outputid = path.split('#').pop();
        cadnode.userData.rx = params['rx'];
        cadnode.userData.ry = params['ry'];
        cadnode.userData.rz = params['rz'];
        cadnode.userData.defaultrow = defaultrow;
        cadnode.userData.rowParams = Utils.mapRowToParams(row, commentrow);


        // Calculate the bounding box of the cadnode
        // var exc = excels[configuration];
        // if (object) {
        //     const changes1 = await excels[configuration].changeNamedExpression(row[0] + ".width", sheetid);
        //     const changes2 = await excels[configuration].changeNamedExpression(row[0] + ".height", sheetid);
        //     const changes3 = await excels[configuration].changeNamedExpression(row[0] + ".depth", sheetid);
        // } else {
        //     var na = this.prependUnderscoreToNumbers(row[0]) + ".width";
        //     var val = (boundingBox.max.x - boundingBox.min.x).toString();
        //     var changes4 = await exc.addNamedExpression(na, val);
        //     //   var changes5 = await excels[configuration].addNamedExpression(row[0] + "height", boundingBox.max.y - boundingBox.min.y, sheetid);
        //     //   var changes6 = await excels[configuration].addNamedExpression(row[0] + ".depth", (boundingBox.max.z - boundingBox.min.z).toString(), sheetid);
        // }
        //        console.log('Bounding Box:', boundingBox);
        try {
            const boundingBox = new THREE.Box3().setFromObject(cadnode);
            cadnode.userData.boundingbox = boundingBox;
            if (!isFinite(boundingBox.min.x) || !isFinite(boundingBox.min.y) || !isFinite(boundingBox.min.z) ||
                !isFinite(boundingBox.max.x) || !isFinite(boundingBox.max.y) || !isFinite(boundingBox.max.z)) {
                console.warn("Invalid bounding box detected", boundingBox);
                return null;
            }
        } catch (error) {
            console.warn("warn", error);
            return null;
        }

        if (!object)
            cadnode.userData.cadstate = "created";
        else
            cadnode.userData.cadstate = "updated";


        // refpos
        cadnode.updateMatrixWorld(true);

        this.handleRefObjects(cadnode, scene);

        //        cadnode.children.forEach(child => this.updateChild(child, cadnode));
        // cadnode.children.forEach(child => this.updateChild(child, cadnode));
        // cadnode.children.forEach(child => this.updateChild(child, cadnode));
        // cadnode.children.forEach(child => this.updateChild(child, cadnode));
        // cadnode.children.forEach(child => this.updateChild(child, cadnode));

        if (diff > 2) {

            scene.add(cadnode);
        }
        cadnode.userData.path = Utils.preNames(cadnode);
        cadnode.userData.path = cadnode.userData.path.replace("root^root^", "root^")
        //  console.log(`postprocessing took ${endTime - startTime} milliseconds`);
        // console.log('#### cadnode.name', cadnode.name + " " + cadnode.userData.path);


        // ggf. erneut schneiden
        if (cuttedBy || tocutoutputids) {
            //    cadnode.userData.cutted = false;
            //   var cuttedoutputids = cadnode.userData.outputid; //  params['cuttedoutputids'];
            //   var cutoutputids = (cuttedBy as any).split('#').pop(); //  params['cutoutputids'];
            var o = object.userData;
            var subtractionname = cadnode.userData.subtraction;

            cadnode = await this.createSubtraction(tocutoutputids, cutoutputids, sheetid, scene, name, path, configuration, excels, true);
        }
        // if (tocutoutputids) {

        //     cadnode = await this.createSubtraction(tocutoutputids, cadnode.userData.outputid, sheetid, scene, name, path, configuration, excels, true);
        // }


        return cadnode;

        return cadnode;
        return cadnode.toJSON();

    }


    handleRefObjects(cadnode: THREE.Object3D, scene: THREE.Scene) {
        // Early return if no ref objects exist
        if (!cadnode.userData.refnormalobjs && !cadnode.userData.refposobjs) return;

        // If this is a connector, only process its dependencies but don't let it be affected by them
        if (cadnode.userData?.isConnector) {
            // Only process objects that reference this connector (update their positions)
            const refposobjs = cadnode.userData.refposobjs || {};
            Object.values(refposobjs).forEach((refObj: THREE.Object3D) => {
                if (!refObj) return;
                // Update the dependent object's position based on this connector
                this.updateDependentObjectPosition(refObj, cadnode, scene);
            });
            return; // Don't process the connector's own refpos if it has any
        }

        // Merge refnormalobjs and refposobjs for non-connector objects
        const mergedRefs = {
            ...(cadnode.userData.refnormalobjs || {}),
            ...(cadnode.userData.refposobjs || {})
        };

        // Handle each reference object recursively
        Object.values(mergedRefs).forEach((refObj: THREE.Object3D) => {
            if (!refObj) return;

            // Update position and rotation based on the parent node
            if (refObj.userData.refpos) {
                let refposvector: THREE.Vector3 | null = null;

                // Check if refpos is a connector reference (outputid.connector format)
                if (refObj.userData.refpos.includes('.') && refObj.userData.refpos.endsWith('.connector')) {
                    // Handle connector dependency update
                    const [refoutputid, _] = refObj.userData.refpos.split('.');

                    // Find the connector by its outputid/label
                    scene.traverse((child) => {
                        if (child.userData?.isConnector &&
                            (child.userData?.connectorLabel === refoutputid || child.userData?.outputid === refoutputid) &&
                            child instanceof THREE.Group) {
                            // Get world position of the connector
                            refposvector = new THREE.Vector3();
                            child.getWorldPosition(refposvector);
                        }
                    });

                    // Fallback to getWorldVectorByConnectorName if not found
                    if (!refposvector) {
                        refposvector = this.getWorldVectorByConnectorName(scene, refoutputid, refObj);
                    }
                } else if (!refObj.userData.refpos.includes('.')) {
                    // Handle standalone connector name
                    const connectorName = refObj.userData.refpos;
                    refposvector = this.getWorldVectorByConnectorName(scene, connectorName, refObj);
                } else {
                    // Handle face center dependency update
                    const [refoutputid, indexStr] = refObj.userData.refpos.split('.');
                    const index = parseInt(indexStr);

                    // Only proceed if indexStr is a valid number
                    if (!isNaN(index)) {
                        refposvector = ThreeUtils.getWorldVectorByObjectNameAndFaceCenterIndex(scene, refoutputid, index, refObj);
                    }
                }

                if (refposvector) {
                    // CRITICAL: Never modify connector positions!
                    if (refObj.userData?.isConnector) {
                        console.warn('[CONNECTOR PROTECTION] Blocked attempt to modify connector position:', refObj.userData.connectorLabel || refObj.userData.outputid);
                        return; // Skip position modification for connectors
                    }

                    // Store the original position before applying rotations
                    const originalPosition = refposvector.clone();

                    // Apply local transformations from the object's parameters
                    const params = Utils.mapRowToParams(refObj.userData.row, refObj.userData.commentrow);

                    // Set base position
                    refObj.position.copy(originalPosition);

                    // Apply local offset transformations
                    refObj.updateMatrix();
                    if (params['x'] != null) {
                        let xDirection = new THREE.Vector3(parseFloat(params['x']), 0, 0);
                        xDirection.applyQuaternion(refObj.quaternion);
                        refObj.position.add(xDirection);
                    }
                    if (params['y'] != null) {
                        let yDirection = new THREE.Vector3(0, parseFloat(params['y']), 0);
                        yDirection.applyQuaternion(refObj.quaternion);
                        refObj.position.add(yDirection);
                    }
                    if (params['z'] != null) {
                        let zDirection = new THREE.Vector3(0, 0, parseFloat(params['z']));
                        zDirection.applyQuaternion(refObj.quaternion);
                        refObj.position.add(zDirection);
                    }

                    // Update matrices after all transformations
                    refObj.updateMatrix();
                    refObj.updateMatrixWorld(true);
                }
            }

            if (refObj.userData.refrot) {
                try {
                    const [refoutputid, indexStr] = refObj.userData.refrot.split('.');
                    const index = parseInt(indexStr);
                    const refobj = ThreeUtils.getObjectByUserDataProp(scene, "outputid", refoutputid);
                    // const refnormalob = refobj?.children?.find(child => child.userData.index === index && child.userData.type === "refnormal" && child.userData.isHelper);
                    let reforientationvector = ThreeUtils.getRotationVectorByObjectNameAndFaceCenterIndex(scene, refoutputid, index, cadnode);
                    let refnormalob = reforientationvector;


                    if (refnormalob) {
                        const refnormal = refnormalob.clone();
                        //    console.log("refnormal", refnormal);
                        refObj.updateMatrixWorld(true);

                        const normalMatrix = new THREE.Matrix4();
                        normalMatrix.lookAt(new THREE.Vector3(0, 0, 0), refnormal, new THREE.Vector3(0, 0, -1));
                        var q = new THREE.Quaternion();

                        q.setFromRotationMatrix(normalMatrix);
                        //     const xAxis = new THREE.Vector3(1, 0, 0);
                        //     const qRotation = new THREE.Quaternion();
                        //     qRotation.setFromAxisAngle(xAxis, Math.PI / 2);
                        //     q.multiply(qRotation);

                        // cadnode.quaternion.copy(q);
                        //  refobj.updateMatrixWorld(true);
                        //  refobj.updateMatrix();      
                        refObj.quaternion.copy(refobj.quaternion.clone());
                        refObj.quaternion.multiply(q);

                        const rotationQuat = new THREE.Quaternion();
                        if (refObj.userData.rx != null) {
                            const rxQuat = new THREE.Quaternion();
                            rxQuat.setFromAxisAngle(new THREE.Vector3(1, 0, 0), THREE.MathUtils.degToRad(parseFloat(refObj.userData.rx)));
                            rotationQuat.multiply(rxQuat);
                        }
                        if (refObj.userData.ry != null) {
                            const ryQuat = new THREE.Quaternion();
                            ryQuat.setFromAxisAngle(new THREE.Vector3(0, 1, 0), THREE.MathUtils.degToRad(parseFloat(refObj.userData.ry)));
                            rotationQuat.multiply(ryQuat);
                        }
                        if (refObj.userData.rz != null) {
                            const rzQuat = new THREE.Quaternion();
                            rzQuat.setFromAxisAngle(new THREE.Vector3(0, 0, 1), THREE.MathUtils.degToRad(parseFloat(refObj.userData.rz)));
                            rotationQuat.multiply(rzQuat);
                        }
                        refObj.quaternion.multiply(rotationQuat);

                        refObj.updateMatrix();
                        // cadnode.userData.refnormalobj = refnormalob;
                        // if (!refobj.userData.refnormalobjs)
                        //     refobj.userData.refnormalobjs = [];
                        //     refobj.userData.refnormalobjs[refObj.userData.refrot] = cadnode;

                    }

                } catch (error) {
                    console.warn("refrot error", error);
                }
            }

            // Handle origin point if specified
            if (refObj.userData.origin) {
                //  const origin = refObj.userData.origin.split(',');
                let direction = refObj.userData.origin;
                direction.applyQuaternion(refObj.quaternion);
                refObj.position.sub(direction);


            }

            // Update matrices
            refObj.updateMatrix();
            refObj.updateMatrixWorld(true);

            // Recursively handle nested reference objects
            this.handleRefObjects(refObj, scene);
        });
    }

    createProfile(cadnode, depth, material) {
        const profile = new THREE.Mesh(
            new THREE.BoxGeometry(1, 1, depth),
            material
        );
        profile.position.set(0, 0, 0);
        cadnode.add(profile);
    }

    updateChild(child, cadnode) {
        child.updateMatrixWorld(true);

        if (child.userData.refposobj) {
            child.userData.refposobj.updateMatrixWorld(true);
            const worldPos = new THREE.Vector3();
            child.getWorldPosition(worldPos);
            //           child.userData.refposobj.position.copy(worldPos);
            child.userData.refposobj.position.set(0, 0, 0); //
        }

        if (child.userData.refnormalobj) {
            child.userData.refnormalobj.updateMatrixWorld(true);
            const refNormal = child.userData.normal.clone();

            const normalMatrix = new THREE.Matrix4().lookAt(
                new THREE.Vector3(0, 0, 0),
                refNormal,
                new THREE.Vector3(0, 0, -1)
            );

            const baseQuaternion = new THREE.Quaternion().setFromRotationMatrix(normalMatrix);
            const xRotation = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(1, 0, 0), Math.PI / 2);

            const finalQuaternion = new THREE.Quaternion().multiplyQuaternions(
                cadnode.quaternion,
                baseQuaternion.multiply(xRotation)
            );

            child.userData.refnormalobj.quaternion.copy(finalQuaternion);

            // Apply additional rotations (rx, ry, rz)
            this.applyAdditionalRotations(child.userData.refnormalobj);
        }

        if (child.userData.refposobj) {
            const refPos = new THREE.Vector3();
            child.userData.refposobj.getWorldPosition(refPos);
            //  cadnode.position.copy(refPos);
        }

        if (child.userData.origin) {
            const originParams = child.userData.origin.split(',');
            if (originParams.length === 3) {
                const originVector = new THREE.Vector3(
                    parseFloat(originParams[0]),
                    parseFloat(originParams[1]),
                    parseFloat(originParams[2])
                );
                //    cadnode.position.add(originVector);
            }
        }

        if (child.userData.refposobj) {
            child.userData.refposobj.position.copy(child.position);

            // 
            const refPosObjRotation = new THREE.Euler().setFromQuaternion(child.userData.refposobj.quaternion);
            const vector = new THREE.Vector3(1, 0, 0); // Example vector
            vector.applyEuler(refPosObjRotation);

            // get refposobj origin
            const refPosObjOrigin = child.userData.refposobj.userData.
                refPosObjOrigin.sub(vector);




            //  this.applyLocalTransforms(child.userData.refposobj, child.parent);
            //  child.userData.refposobj.children.forEach(grandChild => this.updateChild(grandChild, cadnode));
        }
    }

    applyAdditionalRotations(obj) {
        const rotationOrder = ['rx', 'ry', 'rz'];
        const rotationAxes = [
            new THREE.Vector3(1, 0, 0),
            new THREE.Vector3(0, 1, 0),
            new THREE.Vector3(0, 0, 1)
        ];

        rotationOrder.forEach((rot, index) => {
            if (obj.userData[rot] != null) {
                const angle = THREE.MathUtils.degToRad(parseFloat(obj.userData[rot]));
                this.rotateAroundPoint(obj, new THREE.Vector3(), rotationAxes[index], angle);
            }
        });

        obj.updateMatrix();
    }

    applyLocalTransforms(obj, subscene) {
        const params = Utils.mapRowToParams(obj.userData.row, obj.userData.commentrow);
        const localDirections = [
            new THREE.Vector3(1, 0, 0),
            new THREE.Vector3(0, 1, 0),
            new THREE.Vector3(0, 0, 1)
        ];

        ['x', 'y', 'z'].forEach((axis, index) => {
            if (params[axis] != null) {
                const direction = localDirections[index].clone().applyQuaternion(obj.quaternion);
                obj.position.add(direction.multiplyScalar(parseFloat(params[axis])));
            }
        });

        if (params['origin']) {
            this.applyOrigin(obj, params, subscene);
        }
    }

    applyOrigin(obj, params, subscene) {
        const origin = params['origin'].split(',');
        if (origin.length === 3) {
            const originPoint = new THREE.Vector3(
                parseFloat(origin[0]),
                parseFloat(origin[1]),
                parseFloat(origin[2])
            );
            obj.position.sub(originPoint);
            this.applyRotationsAroundOrigin(obj, originPoint, params);
            obj.position.add(originPoint);
        } else {
            const [refOutputId, indexStr] = params['origin'].split('.');
            const index = parseInt(indexStr);
            const refObj = ThreeUtils.getObjectByUserDataProp(subscene.parent, "outputid", refOutputId) || obj;
            const refPosObj = refObj.children.find(child => child.userData.index === index);

            if (refPosObj && refPosObj.userData.origPos) {
                const originPoint = refPosObj.userData.origPos.clone();
                obj.position.sub(originPoint);
                this.applyRotationsAroundOrigin(obj, originPoint, params);
                obj.position.add(originPoint);
            }
        }
    }

    applyRotationsAroundOrigin(obj, originPoint, params) {
        const rotationOrder = ['rx', 'ry', 'rz'];
        const rotationAxes = [
            new THREE.Vector3(1, 0, 0),
            new THREE.Vector3(0, 1, 0),
            new THREE.Vector3(0, 0, 1)
        ];

        rotationOrder.forEach((rot, index) => {
            if (params[rot] != null) {
                const angle = THREE.MathUtils.degToRad(parseFloat(params[rot]));
                this.rotateAroundPoint(obj, originPoint, rotationAxes[index], angle);
            }
        });
    }

    rotateAroundPoint(obj, point, axis, angle) {
        obj.position.sub(point);
        obj.position.applyAxisAngle(axis, angle);
        obj.position.add(point);
        obj.rotateOnAxis(axis, angle);
    }
    updateChild2(child, cadnode) {

        if (child.userData.refposobj) {
            child.userData.refposobj.updateMatrixWorld(true);
            const worldpos = child.getWorldPosition(new THREE.Vector3());
            child.userData.refposobj.position.copy(worldpos);
        }

        let quat = new THREE.Quaternion();
        if (child.userData.refnormalobj) {
            child.updateMatrixWorld(true);
            child.updateMatrix();
            child.userData.refnormalobj.updateMatrixWorld(true);
            const refnormal = child.userData.normal;
            const normalMatrix = new THREE.Matrix4();
            normalMatrix.lookAt(new THREE.Vector3(0, 0, 0), refnormal, new THREE.Vector3(0, 0, -1));
            child.userData.refnormalobj.quaternion.setFromRotationMatrix(normalMatrix);
            quat = child.userData.refnormalobj.quaternion.clone();
            const xAxis = new THREE.Vector3(1, 0, 0);
            const qRotation = new THREE.Quaternion();
            qRotation.setFromAxisAngle(xAxis, Math.PI / 2);
            quat.multiply(qRotation);

            child.userData.refnormalobj.quaternion.copy(cadnode.quaternion);
            child.userData.refnormalobj.quaternion.multiply(quat);
        }

        const rotationQuat = new THREE.Quaternion();
        if (child.userData.refposobj?.userData?.rx) {
            const rxQuat = new THREE.Quaternion();
            rxQuat.setFromAxisAngle(new THREE.Vector3(1, 0, 0), THREE.MathUtils.degToRad(parseFloat(child.userData.refposobj.userData.rx)));
            rotationQuat.multiply(rxQuat);
        }
        if (child.userData.refposobj?.userData?.ry) {
            const ryQuat = new THREE.Quaternion();
            ryQuat.setFromAxisAngle(new THREE.Vector3(0, 1, 0), THREE.MathUtils.degToRad(parseFloat(child.userData.refposobj.userData.ry)));
            rotationQuat.multiply(ryQuat);
        }
        if (child.userData.refposobj?.userData?.rz) {
            const rzQuat = new THREE.Quaternion();
            rzQuat.setFromAxisAngle(new THREE.Vector3(0, 0, 1), THREE.MathUtils.degToRad(parseFloat(child.userData.refposobj.userData.rz)));
            rotationQuat.multiply(rzQuat);
        }

        child.userData.refposobj?.quaternion.multiply(rotationQuat);
        child.userData.refposobj?.updateMatrix();

        //     const refnormal = child.userData.refnormalobj.userData.normal.clone();
        //     console.log("refnormal", refnormal);
        //     cadnode.updateMatrixWorld(true);

        //     const normalMatrix = new THREE.Matrix4();
        //     normalMatrix.lookAt(new THREE.Vector3(0, 0, 0), refnormal, new THREE.Vector3(0, 0, -1));
        //     var q = new THREE.Quaternion();

        //     q.setFromRotationMatrix(normalMatrix);
        //     const xAxis = new THREE.Vector3(1, 0, 0);
        //     const qRotation = new THREE.Quaternion();
        //     qRotation.setFromAxisAngle(xAxis, Math.PI / 2);
        //     q.multiply(qRotation);

        //    // cadnode.quaternion.copy(q);
        //     //  refobj.updateMatrixWorld(true);
        //     //  refobj.updateMatrix();      
        //     cadnode.quaternion.copy(child.userData.refnormalobj.quaternion.clone());
        //     cadnode.quaternion.multiply(q);

        //     const rotationQuat = new THREE.Quaternion();
        //     if (params['rx'] != null) {
        //         const rxQuat = new THREE.Quaternion();
        //         rxQuat.setFromAxisAngle(new THREE.Vector3(1, 0, 0), THREE.MathUtils.degToRad(parseFloat(params['rx'])));
        //         rotationQuat.multiply(rxQuat);
        //     }
        //     if (params['ry'] != null) {
        //         const ryQuat = new THREE.Quaternion();
        //         ryQuat.setFromAxisAngle(new THREE.Vector3(0, 1, 0), THREE.MathUtils.degToRad(parseFloat(params['ry'])));
        //         rotationQuat.multiply(ryQuat);
        //     }
        //     if (params['rz'] != null) {
        //         const rzQuat = new THREE.Quaternion();
        //         rzQuat.setFromAxisAngle(new THREE.Vector3(0, 0, 1), THREE.MathUtils.degToRad(parseFloat(params['rz'])));
        //         rotationQuat.multiply(rzQuat);
        //     }
        //     cadnode.quaternion.multiply(rotationQuat);

        //     cadnode.updateMatrix();
        //     refnormalob.userData.refnormalobj = cadnode;





        if (child.userData.refposobj) {

            this.applylocaltrafos2(child.userData.refposobj, child.parent);
            child.userData.refposobj.children.forEach(grandChild => this.updateChild(grandChild, cadnode)); // TODO: ggf mehrfach aufrufen?
        }
    }

    applylocaltrafos2(obj, subscene) {
        var cadnode = obj;
        // get params from rows

        var params = Utils.mapRowToParams(obj.userData.row, obj.userData.commentrow);


        if (params['x'] != null) {
            let xDirection = new THREE.Vector3(parseFloat(params['x']), 0, 0); // Local X
            xDirection.applyQuaternion(cadnode.quaternion);
            cadnode.position.add(xDirection);
        }
        if (params['y'] != null) {
            let yDirection = new THREE.Vector3(0, parseFloat(params['y']), 0); // Local Y
            yDirection.applyQuaternion(cadnode.quaternion);
            cadnode.position.add(yDirection);
        }
        if (params['z'] != null) {
            let zDirection = new THREE.Vector3(0, 0, parseFloat(params['z'])); // Local Z
            zDirection.applyQuaternion(cadnode.quaternion);
            cadnode.position.add(zDirection);
        }


        // if (params['origin']) {
        //     const origin = params['origin'].split(',');
        //     if (origin.length == 3) {
        //         let direction = new THREE.Vector3(parseFloat(origin[0]), parseFloat(origin[1]), parseFloat(origin[2]));
        //         direction.applyQuaternion(cadnode.quaternion);
        //         cadnode.position.add(direction);
        //     }
        //     // sonst pos von reobj
        //     else {
        //         const [refoutputid, indexStr] = params['origin'].split('.');
        //         const index = parseInt(indexStr);
        //         let refobj = ThreeUtils.getObjectByUserDataProp(subscene, "outputid", refoutputid);
        //         if (!refobj)
        //             refobj = cadnode
        //         const refposob = refobj.children.find(child => child.userData.index === index);
        //         if (refposob)
        //             cadnode.position.sub(refposob.position);
        //     }

        // }
        if (params['origin']) {
            const origin = params['origin'].split(',');
            if (origin.length == 3) {
                let direction = new THREE.Vector3(parseFloat(origin[0]), parseFloat(origin[1]), parseFloat(origin[2]));
                direction.applyQuaternion(cadnode.quaternion);
                const rotx = params['rx'] != null ? THREE.MathUtils.degToRad(parseFloat(params['rx'])) : 0;
                const roty = params['ry'] != null ? THREE.MathUtils.degToRad(parseFloat(params['ry'])) : 0;
                const rotz = params['rz'] != null ? THREE.MathUtils.degToRad(parseFloat(params['rz'])) : 0;
                const rotationMatrix = new THREE.Matrix4();
                rotationMatrix.makeRotationFromEuler(new THREE.Euler(
                    THREE.MathUtils.degToRad(rotx),
                    THREE.MathUtils.degToRad(roty),
                    THREE.MathUtils.degToRad(rotz)
                ));
                //   direction.applyMatrix4(rotationMatrix);
                cadnode.position.add(direction);
            }
            // sonst pos von reobj
            else {
                const [refoutputid, indexStr] = params['origin'].split('.');
                const index = parseInt(indexStr);
                let refobj = ThreeUtils.getObjectByUserDataProp(subscene, "outputid", refoutputid);
                if (!refobj)
                    refobj = cadnode
                const refposob = refobj.children.find(child => child.userData.index === index);

                if (refposob) {
                    let direction = refposob.position.clone(); // beim 2. durchlauf hier nicht mehr oginal position, weil bereits verschoben // new THREE.Vector3(parseFloat(origin[0]), parseFloat(origin[1]), parseFloat(origin[2]));
                    // if (!refposob.userData.origpos) {
                    //     refposob.userData.origpos = refposob.position.clone();
                    // } else {
                    direction = refposob.userData.origpos.clone();
                    // }
                    direction.applyQuaternion(cadnode.quaternion);

                    const rotx = params['rx'] != null ? parseFloat(params['rx']) : 0;
                    const roty = params['ry'] != null ? parseFloat(params['ry']) : 0;
                    const rotz = params['rz'] != null ? parseFloat(params['rz']) : 0;
                    const rotationMatrix = new THREE.Matrix4();
                    rotationMatrix.makeRotationFromEuler(new THREE.Euler(
                        THREE.MathUtils.degToRad(rotx),
                        THREE.MathUtils.degToRad(roty),
                        THREE.MathUtils.degToRad(rotz)
                    ));
                    //      direction.applyMatrix4(rotationMatrix);

                    // todo, rot dazu

                    //cadnode.position.sub(refposob.position);
                    cadnode.position.sub(direction);
                }
            }

        }
    }


    addEdgesToNode(cadnode, params, typ) {
        if (["EXTRUSION", "CYLINDER", "SUBTRACTION", "CUBE"].includes(typ) && !(params['edges'] === false && typeof params['edges'] === "boolean")) {
            const egeometry = new THREE.EdgesGeometry(cadnode.geometry, 6);
            const linestandard = new THREE.LineSegments(egeometry, new THREE.LineBasicMaterial({ color: new THREE.Color('black'), linewidth: 1 }));
            linestandard.name = "KANTE";
            linestandard.userData.type = "edge";
            linestandard.userData.isHelper = true;
            linestandard.userData.path = cadnode.userData.path;

            cadnode.add(linestandard);
        }
    }

    setNodeTransformations(cadnode, params) {
        cadnode.position.set(params['x'] || 0, params['y'] || 0, params['z'] || 0);
        cadnode.rotation.set(this.grad2rad(params['rx'] || 0), this.grad2rad(params['ry'] || 0), this.grad2rad(params['rz'] || 0));
        cadnode.scale.set(params['sx'] || 1, params['sy'] || 1, params['sz'] || 1);
    }

    handleGltfNodes(cadnode, path, commentrow, row) {
        for (const comment of commentrow || []) {
            if (comment.startsWith("node")) {
                const objectname = path;
                const object1 = cadnode;
                const nodename = comment.split('=')[1];
                const [prop, value] = row[commentrow.indexOf(comment)].split('=');
                this.updateNodel(prop, nodename, value, object1);
            }
        }
    }

    async createGltf(filename) {

        var mesh = null;
        // var texture = null;
        // var material = null;
        // var textureLoader = new THREE.TextureLoader();
        // var materialLoader = new THREE.MaterialLoader();

        var gltf = await (this.loader).loadAsync(filename);
        var mixer = new THREE.AnimationMixer(gltf.scene);

        gltf.animations.forEach((clip) => {
            mixer.clipAction(clip).play();
            gltf.scene.userData.mixer = mixer;
        });

        gltf.scene.traverse((child) => {
            if ((child as any).isMesh || (child as any).type == "Object3D") {
                (child as any).cursor = 'pointer';
                child.castShadow = true;
                child.receiveShadow = true;
                //   (child as any).geometry.center(); // center here
            }
            if (child?.userData) {
                child.userData.isGltf = true;
            }
        });
        mesh = gltf.scene;
        // gltf = gltf;
        // mesh = gltf.scene.children[0];
        // loader.load(filename, function (gltf) {
        // texture = textureLoader.load(gltf.textures[0].source);
        // material = materialLoader.parse(gltf.materials[0]);
        // material.map = texture;
        // material.needsUpdate = true;
        // mesh.material = material;
        // });

        //  ThreeUtils.centerGltf(gltf);
        var bb = ThreeUtils.getBoundingBox(mesh);
        const dimensions = new THREE.Vector3().subVectors(bb.max, bb.min);
        mesh.userData.bb = bb;
        mesh.userData.dimensions = dimensions;

        return mesh;
    }





    cutMesh(meshtocut, cutmesh) {
        meshtocut.updateMatrixWorld(true);
        cutmesh.updateMatrixWorld(true);

        try {
            const bspA = CSG.fromMesh(cutmesh);
            const bspB = CSG.fromMesh(meshtocut);
            var intersection = bspB.intersect(bspA) as any;
            if (intersection?.polygons?.length > 0) {
                const bspResult = bspB.subtract(bspA);
                var meshResult = CSG.toMesh(bspResult, meshtocut.matrix) as any;
                meshResult.updateMatrix();
                meshResult.material = meshtocut.material;
                meshResult.receiveShadow = true;
                meshResult.castShadow = true;
                meshResult.name = meshtocut.name;
                meshResult.visible = true;
                meshResult.userData = JSON.parse(JSON.stringify(meshtocut.userData));

                // Preserve the original matrix transformations
                meshResult.position.copy(meshtocut.position);
                meshResult.rotation.copy(meshtocut.rotation);
                meshResult.scale.copy(meshtocut.scale);
                meshResult.updateMatrix();
                meshResult.updateMatrixWorld(true);

                meshtocut.visible = false;

                // Add edges like in cadnode
                const edges = new THREE.EdgesGeometry(meshResult.geometry, 55);
                const edgesMaterial = new THREE.LineBasicMaterial({ color: 0x000000 });
                const edgesMesh = new THREE.LineSegments(edges, edgesMaterial);
                meshResult.add(edgesMesh);

                // Recalculate face centers with the updated matrix
                this.addFaceCenters(meshResult, meshResult.userData.outputid);

                if (!meshResult) {
                    //       console.log('kein schnitt')
                }
                return meshResult;

            } else {
                //     console.log('keine überschneidung')

            }
        }
        catch (ie) {
            //      continue;
            console.log("fehler", ie)
        }
        return meshtocut;
    }
    async createSubtractionOld(tocutoutputids, cutoutputids, sheetid, scene, name, path, configuration, excels, recreated = false) {
        //log('createSubtraction', tocutoutputids, cutoutputids, sheetid, scene, name, path, configuration)


        // vorhandene ggf. löschen


        var tocutoutmeshes = tocutoutputids.split(",");
        var cutmeshes = cutoutputids.split(",");
        var resultmeshes = [];
        var configpath = path.substring(0, path.lastIndexOf('#'));
        for (var j = 0; j < cutmeshes.length; j++) {
            cutmeshes[j] = configpath + "#" + cutmeshes[j].trim();
        }
        for (var j = 0; j < tocutoutmeshes.length; j++) {
            tocutoutmeshes[j] = configpath + "#" + tocutoutmeshes[j].trim();
        }

        for (var i = 0; i < tocutoutmeshes.length; i++) {

            var meshtocut = scene.getObjectByName(tocutoutmeshes[i], true);

            if (recreated) {
                meshtocut = await this.recreateCADNode(meshtocut, scene, excels);
            }

            if (meshtocut) {


                resultmeshes = [];

                // var cutmesh = scene.getObjectByName(cutmeshes[i], true) as THREE.Mesh;
                // var resultmesh = this.cutMesh(meshtocut, cutmesh);
                // resultmesh.updateMatrix();
                // resultmesh.updateMatrixWorld(true);
                // resultmeshes.push(resultmesh);
                var resultmesh = meshtocut;
                var parent = meshtocut.parent;
                for (var j = 0; j < cutmeshes.length; j++) {
                    var cutmesh = scene.getObjectByName(cutmeshes[j], true);
                    if (cutmesh) {
                        cutmesh.updateMatrix();
                        cutmesh.updateMatrixWorld(true);

                        resultmesh = this.cutMesh(resultmesh, cutmesh);
                        if (resultmesh) {
                            //   resultmeshes.push(resultmesh);
                            resultmesh.visible = true;
                            cutmesh.visible = false;
                            resultmesh.userData = { ...meshtocut.userData };
                            resultmesh.userData.cuttedBy = cutmesh.name;
                            if (!cutmesh.userData.cutted)
                                cutmesh.userData.cutted = {};
                            cutmesh.userData.cutted[resultmesh.name] = resultmesh.name;
                            cutmesh.userData.tocutoutputids = tocutoutputids;
                            cutmesh.userData.cutoutputids = cutoutputids;
                            cutmesh.userData.subtraction = name;

                            // Add to parent and update matrices
                            if (j > 0) {
                                //           console.log('remove', resultmeshes[j - 1].name);
                                parent?.remove(resultmeshes[j - 1]);
                            } else {
                                //         console.log('remove', meshtocut.name);
                                parent?.remove(meshtocut);
                            }


                            //     console.log('add', resultmesh.name);
                            parent?.add(resultmesh);
                            resultmesh.updateMatrix();
                            resultmesh.updateMatrixWorld(true);



                            // Ensure face centers are updated with correct world positions
                            this.addFaceCenters(resultmesh, resultmesh.userData.outputid);


                            // connection
                            meshtocut.userData.subtraction = name;
                            meshtocut.userData.tocutoutputids = tocutoutputids;
                            meshtocut.userData.cutoutputids = cutoutputids;
                            resultmesh.userData.subtraction = name;
                            resultmesh.userData.tocutoutputids = tocutoutputids;
                            resultmesh.userData.cutoutputids = cutoutputids;
                            resultmeshes.push(resultmesh);
                        }
                        if (!name.startsWith('root^')) {
                            name = "root^" + name;
                        }
                    }
                }

            }
        }

        //        var parent1 = resultmeshes[resultmeshes.length - 1].parent;
        //        parent1.add(resultmeshes[resultmeshes.length - 1]);
        return resultmeshes[resultmeshes.length - 1];
    }
    async createSubtraction(tocutoutputids, cutoutputids, sheetid, scene, name, path, configuration, excels, recreated = false) {
        //log('createSubtraction', tocutoutputids, cutoutputids, sheetid, scene, name, path, configuration)

        try {
            var tocutoutmeshes_paths = tocutoutputids.split(",");
            var cutmeshes_paths = cutoutputids.split(",");
            var configpath = path.substring(0, path.lastIndexOf('#'));

            let results = [];

            for (let t = 0; t < tocutoutmeshes_paths.length; t++) {
                // Resolve mesh to be cut
                var meshtocut_path = configpath + "#" + tocutoutmeshes_paths[t].trim();
                var meshtocut = scene.getObjectByName(meshtocut_path, true) as THREE.Mesh;

                if (recreated && meshtocut) {
                    meshtocut = await this.recreateCADNode(meshtocut, scene, excels) as THREE.Mesh;
                }

                if (!meshtocut) {
                    //  console.warn("Mesh to cut not found:", meshtocut_path);
                    results.push(null);
                    continue;
                }

                // Resolve and union all cutting meshes
                let combinedCuttersBSP = null;
                const cutterObjects = [];

                for (var i = 0; i < cutmeshes_paths.length; i++) {
                    var cutter_path = configpath + "#" + cutmeshes_paths[i].trim();
                    var cutmesh = scene.getObjectByName(cutter_path, true) as THREE.Mesh;
                    if (cutmesh) {
                        cutterObjects.push(cutmesh);
                        cutmesh.updateMatrixWorld(true); // Ensure matrix is up-to-date
                        const cutterBSP = CSG.fromMesh(cutmesh);
                        if (!combinedCuttersBSP) {
                            combinedCuttersBSP = cutterBSP;
                        } else {
                            combinedCuttersBSP = combinedCuttersBSP.union(cutterBSP);
                        }
                    } else {
                        console.warn("Cutting mesh not found:", cutter_path);
                    }
                }

                if (!combinedCuttersBSP) {
                    console.warn("No valid cutting meshes found to perform subtraction.");
                    results.push(meshtocut); // Return the original mesh if no cutters
                    continue;
                }

                // Perform the single subtraction
                meshtocut.updateMatrixWorld(true);
                const meshtocutBSP = CSG.fromMesh(meshtocut);
                const finalBSPResult = meshtocutBSP.subtract(combinedCuttersBSP);
                var resultmesh = CSG.toMesh(finalBSPResult, meshtocut.matrix) as THREE.Mesh;

                resultmesh.updateMatrix();
                resultmesh.material = meshtocut.material; // Use material from original
                resultmesh.receiveShadow = true;
                resultmesh.castShadow = true;
                resultmesh.name = meshtocut.name; // Keep original name, or a new one if needed
                resultmesh.visible = true;
                resultmesh.userData = JSON.parse(JSON.stringify(meshtocut.userData)); // Deep copy userData

                // Preserve the original matrix transformations
                resultmesh.position.copy(meshtocut.position);
                resultmesh.rotation.copy(meshtocut.rotation);
                resultmesh.scale.copy(meshtocut.scale);
                resultmesh.updateMatrix();
                resultmesh.updateMatrixWorld(true);

                // Remove original mesh to be cut from parent and add the new resultmesh
                const parent = meshtocut.parent;
                if (parent) {
                    parent.remove(meshtocut);
                    parent.add(resultmesh);
                } else {
                    scene.remove(meshtocut); // Fallback if no parent (e.g., root object)
                    scene.add(resultmesh);
                }
                // Dispose old geometry and material to free resources
                if (meshtocut.geometry) meshtocut.geometry.dispose();
                // if (meshtocut.material) { // Be careful if material is shared
                //     if (Array.isArray(meshtocut.material)) {
                //         meshtocut.material.forEach(m => m.dispose());
                //     } else {
                //         meshtocut.material.dispose();
                //     }
                // }


                // Make cutter meshes invisible
                cutterObjects.forEach(cutter => {
                    cutter.visible = false;
                    // Also update userData for cutters
                    if (!cutter.userData.cutted) cutter.userData.cutted = {};
                    cutter.userData.cutted[resultmesh.name] = resultmesh.name;
                    cutter.userData.tocutoutputids = tocutoutputids; // Store original full list
                    cutter.userData.cutoutputids = cutoutputids;     // Store original full list
                    cutter.userData.subtraction = name; // The name of this subtraction operation
                });

                // Update userData for the result mesh
                resultmesh.userData.cuttedBy = cutterObjects.map(c => c.name).join(','); // Store names of all cutters
                resultmesh.userData.tocutoutputids = tocutoutputids;
                resultmesh.userData.cutoutputids = cutoutputids;
                resultmesh.userData.subtraction = name;


                // Add edges like in cadnode - NOW DONE ONCE ON FINAL RESULT
                const edges = new THREE.EdgesGeometry(resultmesh.geometry, 55); // Use appropriate threshold
                const edgesMaterial = new THREE.LineBasicMaterial({ color: 0x000000 });
                const edgesMesh = new THREE.LineSegments(edges, edgesMaterial);
                edgesMesh.name = "KANTE";
                edgesMesh.userData.type = "edge";
                edgesMesh.userData.isHelper = true;
                resultmesh.add(edgesMesh);

                // Recalculate face centers with the updated matrix - NOW DONE ONCE ON FINAL RESULT
                this.addFaceCenters(resultmesh, resultmesh.userData.outputid);


                if (!name.startsWith('root^')) {
                    name = "root^" + name;
                }
                // resultmesh.name = name; // Ensure the final mesh has the subtraction operation's name if needed

                results.push(resultmesh);
            }

            // Return the last result (to match old function's behavior)
            return results.length > 0 ? results[results.length - 1] : null;
        } catch (error) {
            console.warn("Error in createSubtraction:", error);
            return null;
        }
    }

    // async createSubtraction2(tocutoutputids, cutoutputids, sheetid, scene, name, path, configuration, excels, recreated = false) {
    //     console.log('createSubtraction', tocutoutputids, cutoutputids, sheetid, scene, name, path, configuration)
    //     var tocutoutmeshes = tocutoutputids.split(",");
    //     var cutmeshes = cutoutputids.split(",");
    //     var resultmeshes = [];

    //     // TODO: ggf mehrere verarbeiten
    //     var configpath = path.substring(0, path.lastIndexOf('#'));
    //     for (let i = 0; i < cutmeshes.length; i++) {
    //         cutmeshes[i] = configpath + "#" + cutmeshes[i].trim();
    //     }
    //     var cutmesh = scene.getObjectByName(cutmeshes[0], true);

    //     if (cutmesh) {
    //         var meshtocut = scene.getObjectByName(configpath + "#" + tocutoutmeshes[0], true);
    //         var resultmesh = this.cutMesh(meshtocut, cutmesh);
    //         for (var i = 1; i < tocutoutmeshes.length; i++) {
    //             var configpath = path.substring(0, path.lastIndexOf('#'));
    //             //   tocutoutmeshes[i] = configpath + "#" + tocutoutmeshes[i].trim();
    //             //     var meshtocut = scene.getObjectByName(tocutoutmeshes[i], true);
    //             cutmesh = scene.getObjectByName(cutmeshes[i], true);
    //             resultmesh = this.cutMesh(resultmesh, cutmesh);

    //             if (recreated) {
    //                 meshtocut = await this.recreateCADNode(meshtocut, scene, excels);
    //             }

    //             if (meshtocut) {
    //                 for (var j = 0; j < cutmeshes.length; j++) {
    //                     if (resultmesh) {
    //                         resultmeshes.push(resultmesh);
    //                         resultmesh.visible = true;
    //                         cutmesh.visible = false;
    //                         resultmesh.userData = { ...meshtocut.userData };
    //                         resultmesh.userData.cuttedBy = cutmesh.name;
    //                         if (!cutmesh.userData.cutted)
    //                             cutmesh.userData.cutted = {};
    //                         cutmesh.userData.cutted[resultmesh.name] = resultmesh.name;
    //                         cutmesh.userData.tocutoutputids = tocutoutputids;
    //                         var parent = meshtocut.parent;

    //                         // Add to parent and update matrices
    //                         parent.add(resultmesh);
    //                         resultmesh.updateMatrix();
    //                         resultmesh.updateMatrixWorld(true);

    //                         // Ensure face centers are updated with correct world positions
    //                         this.addFaceCenters(resultmesh, resultmesh.userData.outputid);

    //                         parent.remove(meshtocut);

    //                         // connection
    //                         meshtocut.userData.subtraction = name;
    //                         cutmesh.userData.subtraction = name;
    //                     }
    //                     if (!name.startsWith('root^')) {
    //                         name = "root^" + name;
    //                     }
    //                 }
    //             }
    //         }
    //     }
    //     return resultmeshes[resultmeshes.length - 1];
    // }

    updateCuts(cutmesh, resultmesh) {
        if (cutmesh.userData.cutted) {
            // Update the cutting relationship for the cut mesh
            if (!cutmesh.userData.cutted[resultmesh.name]) {
                cutmesh.userData.cutted[resultmesh.name] = resultmesh.name;

                // Create new result mesh from the cut operation
                var newResultMesh = this.cutMesh(resultmesh, cutmesh);
                if (newResultMesh) {
                    newResultMesh.visible = true;
                    cutmesh.visible = false;
                    newResultMesh.userData = { ...resultmesh.userData };
                    newResultMesh.userData.cuttedBy = cutmesh.name;

                    // Update parent relationship
                    var parent = resultmesh.parent;
                    if (parent) {
                        parent.add(newResultMesh);
                        parent.remove(resultmesh);
                    }
                }
            }
        } else {
            cutmesh.userData.cutted = { [resultmesh.name]: resultmesh.name };
        }

        if (resultmesh.userData.cuttedBy) {
            // Update the cutting relationship for the result mesh
            if (!resultmesh.userData.cuttedBy[cutmesh.name]) {
                resultmesh.userData.cuttedBy[cutmesh.name] = cutmesh.name;
            }
        } else {
            resultmesh.userData.cuttedBy = { [cutmesh.name]: cutmesh.name };
        }
    }

    createSphere(radius, material) {
        try {
            const widthSegments = 12;
            const heightSegments = 8;

            var material1 = this.str2material(material);


            const geometry = new THREE.SphereGeometry(radius, widthSegments, heightSegments);
            const mesh = new THREE.Mesh(geometry, material1);



            return mesh;
        } catch (error) {
            console.warn("warn", error);
            return null;
        }
    }

    createCapsule(radius, length, capSubdivisions, radialSegments, material) {
        try {
            var material1 = this.str2material(material);

            const geometry = new THREE.CapsuleGeometry(radius, length, capSubdivisions, radialSegments);
            const mesh = new THREE.Mesh(geometry, material1);
            mesh.castShadow = true;
            mesh.receiveShadow = true;

            return mesh;
        } catch (error) {
            console.warn("warn", error);
            return null;
        }
    }

    // Reset methods for connector sprites (similar to face center sprites)
    resetSelectedConnectorSprite() {
        if (this.selectedConnectorSprite) {
            // Reset to original material
            if (this.selectedConnectorSprite.userData.originalMaterial) {
                this.selectedConnectorSprite.material = this.selectedConnectorSprite.userData.originalMaterial;
            }
            this.selectedConnectorSprite = null;
        }
    }

    resetHoveredConnectorSprite() {
        if (this.hoveredConnectorSprite && this.hoveredConnectorOriginalMaterial) {
            this.hoveredConnectorSprite.material = this.hoveredConnectorOriginalMaterial;
            this.hoveredConnectorSprite = null;
            this.hoveredConnectorOriginalMaterial = null;
        }
    }

    /**
     * Get connector position by connector name for refpos functionality
     * @param scene The Three.js scene
     * @param connectorName The name/label of the connector
     * @returns Vector3 position or null if not found
     */
    getConnectorPositionByName(scene: THREE.Scene, connectorName: string): THREE.Vector3 | null {
        let connectorGroup: THREE.Group | null = null;

        scene.traverse((child) => {
            if (child.userData?.isConnector &&
                child.userData?.connectorLabel === connectorName &&
                child instanceof THREE.Group) {
                connectorGroup = child;
            }
        });

        if (connectorGroup && connectorGroup.userData?.position) {
            // Get world position of the connector
            const worldPosition = new THREE.Vector3();
            connectorGroup.getWorldPosition(worldPosition);
            return worldPosition;
        }

        return null;
    }

    /**
     * Get connector world position by name (similar to getWorldVectorByObjectNameAndFaceCenterIndex)
     * @param scene The Three.js scene  
     * @param connectorName The name/label of the connector
     * @param cadnode The CAD node requesting the position
     * @returns Vector3 world position or null if not found
     */
    getWorldVectorByConnectorName(scene: THREE.Scene, connectorName: string, cadnode?: THREE.Object3D): THREE.Vector3 | null {
        let connectorGroup: THREE.Group | null = null;

        scene.traverse((child) => {
            if (child.userData?.isConnector &&
                child.userData?.connectorLabel === connectorName &&
                child instanceof THREE.Group) {
                connectorGroup = child;
            }
        });

        if (connectorGroup) {
            // Get world position of the connector
            const worldPosition = new THREE.Vector3();
            connectorGroup.updateMatrixWorld();
            connectorGroup.getWorldPosition(worldPosition);
            return worldPosition;
        }

        console.warn(`Connector '${connectorName}' not found for positioning`);
        return null;
    }

    str2material(str): THREE.Material {
        try {
            var material1 = new THREE.MeshStandardMaterial({
                color: 'gray',
                metalness: 0.5,
                roughness: 0.5,
                side: THREE.DoubleSide
            });

            var splitted = str.split(';');
            material1 = new THREE.MeshStandardMaterial({
                color: splitted[0],
                metalness: 0.5,
                roughness: 0.5,
                side: THREE.DoubleSide
            });
            if (splitted.length > 1) {
                material1.roughness = parseFloat(splitted[1]);
            }
            if (splitted.length > 2) {
                material1.metalness = parseFloat(splitted[2]);
            }
            if (splitted.length > 3) {
                //material1.reflectivity = parseFloat(splitted[3]);
                material1.transparent = true;
            }
            if (splitted.length > 4) {
                material1.opacity = parseFloat(splitted[4]);
            }
        } catch (error) {
            console.warn("str2material", str, error);

        }
        return material1;

    }

    createCube(width, length, height, material, segments: number = 1) {
        try {
            // create box
            var geometry = new THREE.BoxGeometry(width, length, height, segments, segments, segments);

            var material1 = this.str2material(material);

            const mesh = new THREE.Mesh(geometry, material1);
            mesh.castShadow = true;
            mesh.receiveShadow = true;
            return mesh;
        } catch (error) {
            console.warn("warn", error);
            return null;
        }
    }
    createCylinder(radiusTop, radiusBottom, height, material) {
        try {
            const radialSegments = 20;
            const geometry = new THREE.CylinderGeometry(radiusTop, radiusBottom, height, radialSegments);

            var material1 = this.str2material(material);

            const mesh = new THREE.Mesh(geometry, material1);
            mesh.castShadow = true;
            mesh.receiveShadow = true;

            return mesh;
        } catch (error) {
            console.warn("warn", error);
            return null;
        }
    }

    createSpring(radius: number, pitch: number, turns: number, wireRadius: number, length: number, material: THREE.Material): THREE.Mesh | null {
        try {
            // Create helical curve for the spring path
            class HelixCurve extends THREE.Curve<THREE.Vector3> {
                constructor(private radius: number, private pitch: number, private turns: number, private length: number) {
                    super();
                }

                getPoint(t: number): THREE.Vector3 {
                    // t goes from 0 to 1
                    const angle = t * this.turns * 2 * Math.PI;
                    const y = (t - 0.5) * this.length; // Center the spring vertically

                    return new THREE.Vector3(
                        this.radius * Math.cos(angle),
                        y,
                        this.radius * Math.sin(angle)
                    );
                }
            }

            // Create the helical path
            const helixPath = new HelixCurve(radius, pitch, turns, length);

            // Create tube geometry along the helical path
            const tubularSegments = Math.max(64, turns * 16); // More segments for smoother curves
            const radialSegments = 8;
            const closed = false;

            const geometry = new THREE.TubeGeometry(helixPath, tubularSegments, wireRadius, radialSegments, closed);

            // Apply material
            var material1 = this.str2material(material);

            const mesh = new THREE.Mesh(geometry, material1);
            mesh.castShadow = true;
            mesh.receiveShadow = true;

            return mesh;
        } catch (error) {
            console.warn("createSpring error:", error);
            return null;
        }
    }

    async createBillboard(width, height, material, imagePath) {
        // create sprite material
        // var material1 = this.str2material(material) as any;
        // material1 = new THREE.SpriteMaterial();
        // //       material1.
        // // Load the texture
        // const loader = new THREE.TextureLoader();
        // var texture = await loader.loadAsync(imagePath);
        // material1.map = texture;
        // //  texture.encoding = THREE.sRGBEncoding;
        // //      texture.encoding = THREE.sRGBEncoding;
        // texture.colorSpace = THREE.SRGBColorSpace;
        // //   material1.transparent = true;
        // //   material1.premultipliedAlpha = false;

        // const sprite = new THREE.Sprite(material1);
        // sprite.scale.set(width, height, 1);
        return this.createShapeWithTexture(imagePath, width, height);
    }

    async createShapeWithTexture(texturePath, width, height) {
        try {
            const shape = new THREE.Group();

            // Create front face
            const geometry = new THREE.PlaneGeometry(width, height);
            const textureLoader = new THREE.TextureLoader();
            const texture = await textureLoader.loadAsync(texturePath);
            texture.colorSpace = THREE.SRGBColorSpace;
            texture.repeat.set(1, 1);
            texture.wrapS = THREE.ClampToEdgeWrapping;
            texture.wrapT = THREE.ClampToEdgeWrapping;

            const material = new THREE.MeshStandardMaterial({
                map: texture,
                side: THREE.DoubleSide
            });

            const plane = new THREE.Mesh(geometry, material);
            shape.add(plane);

            return shape;
        } catch (error) {
            console.warn("warn", error);
            return null;
        }
    }


    createDimensionLine(p1, p2, lineWidth, lineColor, params = {} as any) {
        console.log('Dimension line params:', params);
        try {
            var depthTest = params.depthTest || true;

            // Parse p1 and p2 from strings
            p1 = p1.replace('(', '').replace(')', '').split(',');
            p2 = p2.replace('(', '').replace(')', '').split(',');

            const x1 = parseFloat(p1[0]);
            const y1 = parseFloat(p1[1]);
            const z1 = parseFloat(p1[2]);
            const x2 = parseFloat(p2[0]);
            const y2 = parseFloat(p2[1]);
            const z2 = parseFloat(p2[2]);

            const start = new THREE.Vector3(x1, y1, z1);
            const end = new THREE.Vector3(x2, y2, z2);
            let center = new THREE.Vector3().addVectors(start, end).multiplyScalar(0.5);
            const group = new THREE.Group();

            // Calculate main direction and rotation vectors
            const direction = new THREE.Vector3().subVectors(end, start).normalize();
            const up = new THREE.Vector3(0, 0, 1);
            const right = new THREE.Vector3().crossVectors(direction, up).normalize();

            // Apply rotation around line axis if specified
            if (params.rotation) {
                const angle = THREE.MathUtils.degToRad(parseFloat(params.rotation));
                right.applyAxisAngle(direction, angle);
                up.crossVectors(right, direction);
            }

            // Create the main dimension line
            let points = [x1, y1, z1, x2, y2, z2];
            let lineGeometry = new LineGeometry();
            lineGeometry.setPositions(points);

            let lineMaterial = new LineMaterial({
                color: lineColor,
                linewidth: lineWidth,
                resolution: new THREE.Vector2(window.innerWidth, window.innerHeight),
                dashed: params.dashed || false,
                dashScale: params.dashScale || 1,
                dashSize: params.dashSize || 3,
                gapSize: params.gapSize || 1,
                depthTest: depthTest
            });

            let line = new Line2(lineGeometry, lineMaterial);
            line.computeLineDistances();
            line.renderOrder = 999999;
            // group.add(line);

            // Create text sprite
            const length = start.distanceTo(end);
            const dimensionText = params.text || `${length.toFixed(1)}`;
            const sprite = new threeSpritetext(dimensionText);
            sprite.position.copy(center);
            sprite.material.depthTest = depthTest;
            sprite.textHeight = params.textSize || 10;
            sprite.padding = params.textPadding || 2;
            sprite.backgroundColor = params.textBackground || 'rgba(255,255,255,0.9)';
            sprite.color = params.textColor || lineColor;
            sprite.renderOrder = 999999;

            // this.addInteractiveObject(sprite);
            this.interactionManager.add(sprite, {
                mouseEnter: (obj) => {
                    console.log('Mouse entered object:', obj);
                    this.interactionManager.cursorType = 'pointer';
                    sprite.scale.multiplyScalar(1.1);
                    sprite.color = 'red';
                    //   sprite.material.color.set('red');
                },
                mouseLeave: (obj) => {
                    // Remove highlight - use original scale to ensure proper reset
                    if (obj instanceof THREE.Sprite && obj.userData.originalScale) {
                        obj.scale.copy(obj.userData.originalScale);
                    }
                    document.body.style.cursor = 'default';
                    //   sprite.material.color.set('black');
                },
                click: (obj, event) => {
                    console.log('Object clicked:', obj);
                }
            });
            // Add user data for interaction
            sprite.userData.isDimensionText = true;
            sprite.userData.dimensionValue = length;
            sprite.userData.dimensionLine = group;
            sprite.userData.editcell = params.editcell;
            sprite.userData.p1 = p1;
            sprite.userData.p2 = p2;
            sprite.userData.originalScale = sprite.scale.clone();
            sprite.userData.originalColor = sprite.color;
            sprite.userData.originalBgColor = sprite.backgroundColor;
            sprite.userData.isInteractive = true;

            // Create cones at endpoints
            if (params.showArrows !== false) {
                const coneHeight = lineWidth * (params.arrowSize || 4);
                const coneRadius = coneHeight * 0.5;
                const coneGeometry = new THREE.ConeGeometry(coneRadius, coneHeight, 12);
                const coneMaterial = new THREE.MeshBasicMaterial({
                    color: lineColor,
                    depthTest: depthTest
                });

                // Start cone
                const startCone = new THREE.Mesh(coneGeometry, coneMaterial);
                const startConeOffset = direction.clone().multiplyScalar(coneHeight / 2);
                startCone.position.copy(start).add(startConeOffset);
                startCone.lookAt(end);
                startCone.rotateX(-Math.PI / 2);
                if (params.rotation) {
                    //    startCone.rotateZ(THREE.MathUtils.degToRad(parseFloat(params.rotation)));
                }
                startCone.renderOrder = 999999;
                //    group.add(startCone);

                // End cone
                const endCone = new THREE.Mesh(coneGeometry, coneMaterial);
                const endConeOffset = direction.clone().multiplyScalar(-coneHeight / 2);
                endCone.position.copy(end).add(endConeOffset);
                endCone.lookAt(end);
                endCone.rotateX(Math.PI / 2);
                if (params.rotation) {
                    //     endCone.rotateZ(THREE.MathUtils.degToRad(parseFloat(params.rotation)));
                }
                endCone.renderOrder = 999999;
                //    group.add(endCone);
            }

            // Create orthogonal lines
            const orthogonalLength = params.orthogonalLength || 20;
            const orthogonalOffset = params.orthogonalOffset || 0;

            // Calculate orthogonal direction based on main line direction
            const orthoDirection = right.clone();

            // If rotation is specified, rotate the orthogonal direction around the dimension line axis
            if (params.rotation) {
                const rotationAngle = THREE.MathUtils.degToRad(parseFloat(params.rotation));

                // Get the initial up vector
                const up = new THREE.Vector3(0, 0, 1);

                // Calculate initial right vector as cross product of direction and up
                const initialRight = new THREE.Vector3().crossVectors(direction, up).normalize();

                // Create quaternion for rotation
                const quaternion = new THREE.Quaternion();
                quaternion.setFromAxisAngle(direction.normalize(), rotationAngle);

                // Apply rotation to initial right vector
                initialRight.applyQuaternion(quaternion);

                // Set orthoDirection to the rotated vector
                orthoDirection.copy(initialRight);
            }

            // Start orthogonal line
            const startOffset = start.clone();
            if (orthogonalOffset) {
                startOffset.add(direction.clone().multiplyScalar(orthogonalOffset));
            }

            const startOrthoStart = startOffset.clone();
            const startOrthoEnd = startOffset.clone().add(
                orthoDirection.clone().normalize().multiplyScalar(orthogonalLength)
            );

            // End orthogonal line
            const endOffset = end.clone();
            if (orthogonalOffset) {
                endOffset.sub(direction.clone().multiplyScalar(orthogonalOffset));
            }

            const endOrthoStart = endOffset.clone();
            const endOrthoEnd = endOffset.clone().add(
                orthoDirection.clone().normalize().multiplyScalar(orthogonalLength)
            );

            // Create the main dimension line between orthogonal line endpoints
            // Calculate gap size based on actual text dimensions
            const textLength = dimensionText.toString().length;
            const charWidth = (params.textSize || 10) * 0.6; // Approximate width per character
            const textWidth = charWidth * textLength;
            const gapSize = textWidth * 1.1; // Slightly smaller than text width for better appearance

            const gapCenter = new THREE.Vector3().addVectors(startOrthoEnd, endOrthoEnd).multiplyScalar(0.5);
            const lineDirection = new THREE.Vector3().subVectors(endOrthoEnd, startOrthoEnd).normalize();
            const gapOffset = lineDirection.clone().multiplyScalar(gapSize / 2);

            // Create first half of the line
            const firstLinePoints = [
                startOrthoEnd.x, startOrthoEnd.y, startOrthoEnd.z,
                gapCenter.x - gapOffset.x, gapCenter.y - gapOffset.y, gapCenter.z - gapOffset.z
            ];
            const firstLineGeometry = new LineGeometry();
            firstLineGeometry.setPositions(firstLinePoints);
            const firstLine = new Line2(firstLineGeometry, lineMaterial);
            firstLine.computeLineDistances();
            firstLine.renderOrder = 999999;
            group.add(firstLine);

            // Create second half of the line
            const secondLinePoints = [
                gapCenter.x + gapOffset.x, gapCenter.y + gapOffset.y, gapCenter.z + gapOffset.z,
                endOrthoEnd.x, endOrthoEnd.y, endOrthoEnd.z
            ];
            const secondLineGeometry = new LineGeometry();
            secondLineGeometry.setPositions(secondLinePoints);
            const secondLine = new Line2(secondLineGeometry, lineMaterial);
            secondLine.computeLineDistances();
            secondLine.renderOrder = 999999;
            group.add(secondLine);

            // Create orthogonal lines
            const orthoLineMaterial = new LineMaterial({
                color: lineColor,
                linewidth: lineWidth,
                resolution: new THREE.Vector2(window.innerWidth, window.innerHeight),
                dashed: false,
                depthTest: depthTest
            });

            // Start orthogonal line
            const startOrthoPoints = [
                startOrthoStart.x, startOrthoStart.y, startOrthoStart.z,
                startOrthoEnd.x, startOrthoEnd.y, startOrthoEnd.z
            ];
            const startOrthoGeometry = new LineGeometry();
            startOrthoGeometry.setPositions(startOrthoPoints);
            const startOrthoLine = new Line2(startOrthoGeometry, orthoLineMaterial);
            startOrthoLine.computeLineDistances();
            startOrthoLine.renderOrder = 999999;
            group.add(startOrthoLine);

            // End orthogonal line
            const endOrthoPoints = [
                endOrthoStart.x, endOrthoStart.y, endOrthoStart.z,
                endOrthoEnd.x, endOrthoEnd.y, endOrthoEnd.z
            ];
            const endOrthoGeometry = new LineGeometry();
            endOrthoGeometry.setPositions(endOrthoPoints);
            const endOrthoLine = new Line2(endOrthoGeometry, orthoLineMaterial);
            endOrthoLine.computeLineDistances();
            endOrthoLine.renderOrder = 999999;
            group.add(endOrthoLine);

            // Create cones at the orthogonal line endpoints
            if (params.showArrows !== false) {
                const coneHeight = lineWidth * (params.arrowSize || 4);
                const coneRadius = coneHeight * 0.5;
                const coneGeometry = new THREE.ConeGeometry(coneRadius, coneHeight, 12);
                const coneMaterial = new THREE.MeshBasicMaterial({
                    color: lineColor,
                    depthTest: depthTest
                });

                // Calculate direction for cones (along the dimension line)
                const dimensionDirection = new THREE.Vector3().subVectors(endOrthoEnd, startOrthoEnd).normalize();

                // Start cone
                const startCone = new THREE.Mesh(coneGeometry, coneMaterial);
                const startConeOffset = dimensionDirection.clone().multiplyScalar(coneHeight / 2);
                startCone.position.copy(startOrthoEnd).add(startConeOffset);
                startCone.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), dimensionDirection);
                startCone.rotateZ(Math.PI);
                startCone.renderOrder = 999999;
                group.add(startCone);

                // End cone
                const endCone = new THREE.Mesh(coneGeometry, coneMaterial);
                const endConeOffset = dimensionDirection.clone().multiplyScalar(-coneHeight / 2);
                endCone.position.copy(endOrthoEnd).add(endConeOffset);
                endCone.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), dimensionDirection);
                endCone.rotateY(Math.PI / 2);
                endCone.renderOrder = 999999;
                group.add(endCone);
            }

            // Update text position to be centered on the dimension line
            center = new THREE.Vector3().addVectors(startOrthoEnd, endOrthoEnd).multiplyScalar(0.5);
            sprite.position.copy(center);

            group.renderOrder = 999999;
            // Add the sprite to the group
            group.add(sprite);


            return group;
        } catch (error) {
            console.warn("warn", error);
            return null;
        }
    }

    createLathe(points, material) {
        try {
            var ps = points.split(";");

            for (let i = 0; i < ps.length; i++) {
                var p = ps[i].replace('(', '').replace(')', '').split(",");
                points.push(new THREE.Vector2(p[0], p[1]));
            }
            const geometry = new THREE.LatheGeometry(ps);
            const mesh = new THREE.Mesh(geometry, new THREE.MeshPhongMaterial({ color: material }));
            return mesh;
        } catch (error) {
            console.warn("warn", error);
            return null;
        }
    }

    ////////////////////////////////////////////////////////////
    createShape(pointsStr: string, depth: number, materialStr: string, splinePathString?: string, splineDivisions?: number) {
        try {
            const shapeDefinitionPoints: { x: number, y: number }[] = [];

            if (splinePathString && typeof splinePathString === 'string' && splinePathString.trim() !== "") {
                const splinePointTokens = splinePathString.split(';').filter(t => t.trim() !== "");
                const catmullControlPoints: THREE.Vector2[] = [];

                splinePointTokens.forEach(token => {
                    const p = token.replace("(", "").replace(")", "").split(",");
                    if (p.length === 2) {
                        const x = parseFloat(p[0]);
                        const y = parseFloat(p[1]);
                        if (!isNaN(x) && !isNaN(y)) {
                            catmullControlPoints.push(new THREE.Vector2(x, y));
                        }
                    }
                });

                if (catmullControlPoints.length >= 2) { // CatmullRomCurve3 needs at least 2 points.
                    const curve = new THREE.CatmullRomCurve3(
                        catmullControlPoints.map(v2 => new THREE.Vector3(v2.x, v2.y, 0))
                    );
                    const numDivisions = splineDivisions !== undefined && splineDivisions > 0 ? splineDivisions : Math.max(20, catmullControlPoints.length * 10);
                    const curveGeneratedPoints3D = curve.getPoints(numDivisions);

                    curveGeneratedPoints3D.forEach(p3d => {
                        shapeDefinitionPoints.push({ x: p3d.x, y: p3d.y });
                    });
                } else {
                    if (catmullControlPoints.length > 0) {
                        console.warn("Spline path provided but with less than 2 valid points. Falling back to 'points' parameter if available.");
                    }
                    // Fall through to use pointsStr if spline is invalid
                }
            }

            // If spline was not used or resulted in no points, use the original pointsStr
            if (shapeDefinitionPoints.length === 0) {
                if (!pointsStr || typeof pointsStr !== 'string' || pointsStr.trim() === "") {
                    console.error("Error creating shape: Neither valid spline nor direct points provided.");
                    return null;
                }
                const pointTokens = pointsStr.split(';').filter(t => t.trim() !== "");
                pointTokens.forEach(token => {
                    const p = token.replace("(", "").replace(")", "").split(",");
                    if (p.length === 2) {
                        const x = parseFloat(p[0]);
                        const y = parseFloat(p[1]);
                        if (!isNaN(x) && !isNaN(y)) {
                            shapeDefinitionPoints.push({ x: x, y: y });
                        }
                    }
                });
            }

            if (shapeDefinitionPoints.length < 2) {
                console.error("Error creating shape: Not enough valid points to form a shape (need at least 2). Resulting points:", shapeDefinitionPoints);
                return null;
            }

            const shape1 = new THREE.Shape();
            shape1.autoClose = true;
            shape1.moveTo(shapeDefinitionPoints[0].x, shapeDefinitionPoints[0].y);
            for (let i = 1; i < shapeDefinitionPoints.length; i++) {
                shape1.lineTo(shapeDefinitionPoints[i].x, shapeDefinitionPoints[i].y);
            }

            const extrudeSettings = { depth: depth, bevelEnabled: false, bevelSegments: 2, steps: 2, bevelSize: 1, bevelThickness: 1 };
            const geometry = new THREE.ExtrudeGeometry(shape1, extrudeSettings);
            const material1 = this.str2material(materialStr);
            const mesh = new THREE.Mesh(geometry, material1);
            return mesh;

        } catch (error) {
            console.warn("Error in createShape:", error, "Points:", pointsStr, "Spline:", splinePathString);
            return null;
        }
    }



    // create three.js surface
    createSurface(points, indices, material) {

        //var geometry = new THREE.BufferGeometry();
        // var material = new THREE.MeshPhongMaterial({
        //     color: 0xffff00,
        //     polygonOffset: true,
        //     polygonOffsetFactor: 1, // positive value pushes polygon further away
        //     polygonOffsetUnits: 1
        // });

        // var vertices = mesh.vertices;
        // var faces = mesh.faces;
        // var normals = mesh.faceVertexNormals;

        // for (var i = 0; i < faces.length; i++) {
        //     var face = faces[i];
        //     var normal = normals[i];
        //     var va = vertices[face.a];
        //     var vb = vertices[face.b];
        //     var vc = vertices[face.c];

        //     geometry.vertices.push(va);
        //     geometry.vertices.push(vb);
        //     geometry.vertices.push(vc);

        //     geometry.faces.push(new THREE.Face3(i * 3, i * 3 + 1, i * 3 + 2));
        //     geometry.faces[i].normal = normal;
        // }

        // geometry.computeFaceNormals();
        // geometry.computeVertexNormals();

        // var mesh = new THREE.Mesh(geometry, material);
        // mesh.material.side = THREE.DoubleSide;
        // mesh.material.depthWrite = false;

        // return mesh;
    }

    // // create three js text

    async createText(text, fonturl, fontsize, color, align = 'left') {
        try {
            fonturl = "assets/Roboto_Bold.json";
            return new Promise((resolve, reject) => {
                const loader = new FontLoader();
                loader.load(fonturl, function (font) {
                    const textGeometry = new TextGeometry(text, {
                        font: font,
                        size: fontsize * 10,
                        height: 0.1,
                        curveSegments: 12,
                    });

                    const material = this.str2material(color);
                    const textMesh = new THREE.Mesh(textGeometry, material);

                    // Center the text geometry based on alignment
                    textGeometry.computeBoundingBox();
                    const textWidth = textGeometry.boundingBox.max.x - textGeometry.boundingBox.min.x;

                    // Create a container group to handle alignment
                    const container = new THREE.Group();
                    container.add(textMesh);

                    // Apply alignment to the text mesh within the container
                    switch (align.toLowerCase()) {
                        case 'center':
                            textMesh.position.x = -textWidth / 2;
                            break;
                        case 'right':
                            textMesh.position.x = -textWidth;
                            break;
                        case 'left':
                        default:
                            textMesh.position.x = 0;
                            break;
                    }

                    // Store alignment info for future reference
                    container.userData.textAlign = align.toLowerCase();
                    container.userData.isTextContainer = true;

                    resolve(container);
                }.bind(this));
            });
        } catch (error) {
            console.warn("warn", error);
            return null;
        }
    }


    // // create three.js light
    createLight(color, intensity, distance, decay) {
        var light = new THREE.PointLight(color, intensity, distance, decay);

        return light;
    }

    // // create three.js line
    createLine(p1, p2, width, material) {
        try {
            p1 = p1.replace('(', '').replace(')', '').split(',');
            p2 = p2.replace('(', '').replace(')', '').split(',');
            var x1 = parseFloat(p1[0]);
            var y1 = parseFloat(p1[1]);
            var z1 = parseFloat(p1[2]);
            var x2 = parseFloat(p2[0]);
            var y2 = parseFloat(p2[1]);
            var z2 = parseFloat(p2[2]);
            //    const points = [];
            //   points.push(new THREE.Vector3(x1, y1, z1));
            //   points.push(new THREE.Vector3(x2, y2, z2));
            const points = [x1, y1, z1, x2, y2, z2];

            // const geometry = new THREE.BufferGeometry().setFromPoints(points);
            const geometry = new LineGeometry();
            geometry.setPositions(points);
            const material2 = new LineMaterial({
                color: material,  // Choose the color as needed
                linewidth: width,  // Adjust the line width for visibility
                resolution: new THREE.Vector2(window.innerWidth, window.innerHeight)  // Necessary for LineMaterial
            });
            var material1 = new THREE.LineBasicMaterial({ color: material, linewidth: width });
            var line = new Line2(geometry, material2);
            line.computeLineDistances();

            return line;
        } catch (error) {
            console.warn("warn", error);
            return null;
        }
    }

    createArrow(start, end, width, material, headLength, headWidth) {
        try {
            // Parse start and end points
            start = start.replace('(', '').replace(')', '').split(',');
            end = end.replace('(', '').replace(')', '').split(',');
            const startVec = new THREE.Vector3(
                parseFloat(start[0]),
                parseFloat(start[1]),
                parseFloat(start[2])
            );
            const endVec = new THREE.Vector3(
                parseFloat(end[0]),
                parseFloat(end[1]),
                parseFloat(end[2])
            );

            // Create group to hold all arrow parts
            const group = new THREE.Group();

            // Create the line part
            const points = [
                startVec.x, startVec.y, startVec.z,
                endVec.x, endVec.y, endVec.z
            ];
            const lineGeometry = new LineGeometry();
            lineGeometry.setPositions(points);
            const lineMaterial = new LineMaterial({
                color: material,
                linewidth: width,
                resolution: new THREE.Vector2(window.innerWidth, window.innerHeight)
            });
            const line = new Line2(lineGeometry, lineMaterial);
            line.computeLineDistances();
            group.add(line);

            // Create the arrow head
            const direction = new THREE.Vector3().subVectors(endVec, startVec).normalize();
            const coneGeometry = new THREE.ConeGeometry(headWidth, headLength, 12);
            const coneMaterial = new THREE.MeshBasicMaterial({ color: material });
            const cone = new THREE.Mesh(coneGeometry, coneMaterial);

            // Position the cone at the end point
            cone.position.copy(endVec);

            // Orient the cone to point in the direction of the line
            cone.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), direction);

            group.add(cone);

            return group;
        } catch (error) {
            console.warn("warn", error);
            return null;
        }
    }


    // createLine() {

    //     var geometry = new THREE.BoxGeometry(100, 100, 200);

    //     // mesh
    //     var material = new THREE.MeshPhongMaterial({
    //         color: 0xff0000,
    //         polygonOffset: true,
    //         polygonOffsetFactor: 1, // positive value pushes polygon further away
    //         polygonOffsetUnits: 1
    //     });
    //     var mesh = new THREE.Mesh(geometry, material);
    //     //     this.scene.add(mesh);
    //     this.testmesh = mesh;


    //     var geo = new THREE.EdgesGeometry(mesh.geometry); // or WireframeGeometry
    //     var mat = new THREE.LineBasicMaterial({ color: 0xffffff });
    //     var wireframe = new THREE.LineSegments(geo, mat);
    //     mesh.add(wireframe);
    // }

    public createExtrusion(baseplane, extrusionvector, material, bevelWidth = 0, bevelSegments = 1) {
        try {
            var material1 = this.str2material(material);

            // Parse extrusion vector
            extrusionvector = extrusionvector.replace(/\s/g, '').replace('(', '').replace(')', '').split(',');
            var extrusionDir = new THREE.Vector3(
                parseFloat(extrusionvector[0]),
                parseFloat(extrusionvector[1]),
                parseFloat(extrusionvector[2])
            );

            // Parse base plane points and potential holes
            const planeParts = baseplane.split('#');
            const mainShapePointsStr = planeParts[0];
            const holePointsStrArray = planeParts.slice(1);

            var pointsstrs = mainShapePointsStr.replace(/\s/g, '').split(";");
            var points = [];
            for (var i = 0; i < pointsstrs.length; i++) {
                var pointstr = pointsstrs[i].substring(1, pointsstrs[i].length - 1);
                var x = parseFloat(pointstr.split(",")[0]);
                var y = parseFloat(pointstr.split(",")[1]);
                points.push({ x: x, y: y });
            }

            // Create shape from points
            const shape1 = new THREE.Shape();
            shape1.autoClose = true;
            if (points.length > 0) {
                shape1.moveTo(points[0].x, points[0].y);
                for (var i = 1; i < points.length; i++) {
                    shape1.lineTo(points[i].x, points[i].y);
                }
            } else {
                console.error("Error creating extrusion: No points for main shape.");
                return null;
            }


            // Add holes if any
            for (const holePointsStr of holePointsStrArray) {
                const holePath = new THREE.Path();
                const holePstrs = holePointsStr.replace(/\s/g, '').split(";");
                if (holePstrs.length > 0 && holePstrs[0]) { // Check if holePstrs[0] is not empty
                    const firstPstr = holePstrs[0].substring(1, holePstrs[0].length - 1);
                    const firstPx = parseFloat(firstPstr.split(",")[0]);
                    const firstPy = parseFloat(firstPstr.split(",")[1]);
                    holePath.moveTo(firstPx, firstPy);

                    for (var i = 1; i < holePstrs.length; i++) {
                        if (holePstrs[i]) { // Check if holePstrs[i] is not empty
                            const pstr = holePstrs[i].substring(1, holePstrs[i].length - 1);
                            const px = parseFloat(pstr.split(",")[0]);
                            const py = parseFloat(pstr.split(",")[1]);
                            holePath.lineTo(px, py);
                        }
                    }
                    shape1.holes.push(holePath);
                }
            }


            // Create extrude settings with the Z component as depth
            var extrudeSettings = {
                steps: 1,
                bevelEnabled: bevelWidth > 0,
                bevelThickness: bevelWidth, // Use bevelWidth for thickness
                bevelSize: bevelWidth,      // Typically same as thickness, might adjust later if needed
                bevelSegments: bevelSegments,
                depth: Math.abs(extrusionDir.z)
            };

            // Create geometry and mesh
            const geometry = new THREE.ExtrudeGeometry(shape1, extrudeSettings);
            const mesh = new THREE.Mesh(geometry, material1);

            // Create shear matrix
            const matrix = new THREE.Matrix4();
            if (extrusionDir.z !== 0) {
                // Calculate shear factors - note the change in how we calculate these
                const Sxz = extrusionDir.x / extrusionDir.z; // X shear in Z direction
                const Syz = extrusionDir.y / extrusionDir.z; // Y shear in Z direction

                // Set up the shear matrix - note the changed positions of the shear factors
                matrix.set(
                    1, 0, Sxz, 0,
                    0, 1, Syz, 0,
                    0, 0, 1, 0,
                    0, 0, 0, 1
                );

                // Apply shear transformation
                geometry.applyMatrix4(matrix);
            }

            // If extrusion is in negative Z direction, flip the mesh
            if (extrusionDir.z < 0) {
                const flipMatrix = new THREE.Matrix4();
                flipMatrix.makeScale(1, 1, -1);
                geometry.applyMatrix4(flipMatrix);
                mesh.position.z = extrusionDir.z;
            }

            mesh.receiveShadow = true;
            mesh.castShadow = true;

            return mesh;
        } catch (error) {
            console.error("Error creating extrusion:", error);
            return null;
        }
    }

    public createAluProfile(series: string, size: string, length: number, material: THREE.Material): THREE.Mesh {
        try {
            // Get profile dimensions from AluminumProfiles class
            const profileDimensions = AluminumProfiles.getDimensions(series as AluProfileSeries, size);

            if (!profileDimensions) {
                console.error(`Profile not found: ${series} ${size}`);
                return null;
            }

            const { width, height, wallThickness, cornerRadius = 0, slotWidth = 0, slotDepth = 0 } = profileDimensions;

            // Create the base shape for extrusion
            const shape = new THREE.Shape();

            // Outer profile
            shape.moveTo(-width / 2, -height / 2);
            shape.lineTo(width / 2, -height / 2);
            shape.lineTo(width / 2, height / 2);
            shape.lineTo(-width / 2, height / 2);
            shape.lineTo(-width / 2, -height / 2);

            // Inner profile (hollow part)
            const innerWidth = width - 2 * wallThickness;
            const innerHeight = height - 2 * wallThickness;
            const hole = new THREE.Path();
            hole.moveTo(-innerWidth / 2, -innerHeight / 2);
            hole.lineTo(innerWidth / 2, -innerHeight / 2);
            hole.lineTo(innerWidth / 2, innerHeight / 2);
            hole.lineTo(-innerWidth / 2, innerHeight / 2);
            hole.lineTo(-innerWidth / 2, -innerHeight / 2);
            shape.holes.push(hole);

            // Create T-slots if specified
            if (slotWidth > 0 && slotDepth > 0) {
                // Add T-slots on each side
                const addSlot = (x: number, y: number, rotation: number) => {
                    const slot = new THREE.Path();
                    slot.moveTo(x, y);
                    slot.lineTo(x + slotWidth, y);
                    slot.lineTo(x + slotWidth, y + slotDepth);
                    slot.lineTo(x, y + slotDepth);
                    slot.lineTo(x, y);
                    shape.holes.push(slot);
                };

                // Add slots on all four sides
                addSlot(-slotWidth / 2, -height / 2, 0);  // Bottom
                addSlot(-slotWidth / 2, height / 2 - slotDepth, Math.PI);  // Top
                addSlot(-width / 2, -slotWidth / 2, -Math.PI / 2);  // Left
                addSlot(width / 2 - slotDepth, -slotWidth / 2, Math.PI / 2);  // Right
            }

            // Create the extrusion geometry
            const extrudeSettings = {
                steps: 1,
                depth: length,
                bevelEnabled: false
            };

            const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
            const mesh = new THREE.Mesh(geometry, material);

            // Rotate the profile so it's oriented along the Z-axis
            mesh.rotation.x = -Math.PI / 2;

            return mesh;
        } catch (error) {
            console.warn("warn", error);
            return null;
        }
    }

    public createIBeam(profile: string, width: number, height: number, length: number, flangeThickness: number, webThickness: number, material: THREE.Material, startSlope: number = 0, endSlope: number = 0): THREE.Mesh {
        try {
            // console.log("Creating I-beam with params:", { profile, width, height, length, flangeThickness, webThickness, startSlope, endSlope });

            // Get standard profile dimensions if a profile name is provided
            if (profile) {
                const [standard, size] = profile.split(' ');
                const profileDims = IBeamStandards.getDimensions(standard as IBeamStandard, size);
                if (profileDims) {
                    width = profileDims.width;
                    height = profileDims.height;
                    flangeThickness = profileDims.flangeThickness;
                    webThickness = profileDims.webThickness;
                    //   console.log("Using standard profile dimensions:", profileDims);
                } else {
                    //   console.warn("Profile not found:", profile);
                }
            }

            // Validate dimensions
            if (!width || !height || !length) {
                console.warn("Invalid I-beam dimensions:", { width, height, length });
                return null;
            }

            // Create the basic I-beam shape
            const shape = new THREE.Shape();
            const halfWidth = width / 2;
            const halfWebThickness = webThickness / 2;

            // Define the I-beam profile points
            shape.moveTo(-halfWidth, -height / 2);
            shape.lineTo(halfWidth, -height / 2);
            shape.lineTo(halfWidth, -height / 2 + flangeThickness);
            shape.lineTo(halfWebThickness, -height / 2 + flangeThickness);
            shape.lineTo(halfWebThickness, height / 2 - flangeThickness);
            shape.lineTo(halfWidth, height / 2 - flangeThickness);
            shape.lineTo(halfWidth, height / 2);
            shape.lineTo(-halfWidth, height / 2);
            shape.lineTo(-halfWidth, height / 2 - flangeThickness);
            shape.lineTo(-halfWebThickness, height / 2 - flangeThickness);
            shape.lineTo(-halfWebThickness, -height / 2 + flangeThickness);
            shape.lineTo(-halfWidth, -height / 2 + flangeThickness);
            shape.lineTo(-halfWidth, -height / 2);

            // Create extrusion settings
            const extrudeSettings = {
                steps: 1,
                depth: length,
                bevelEnabled: false
            };

            // Create the basic geometry
            const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);

            // Apply slopes if needed
            if (startSlope !== 0 || endSlope !== 0) {
                const positions = geometry.attributes.position.array;
                const vertexCount = positions.length / 3;

                for (let i = 0; i < vertexCount; i++) {
                    const x = positions[i * 3];
                    const y = positions[i * 3 + 1];
                    const z = positions[i * 3 + 2];

                    // Apply start slope (at z = 0)
                    if (z < 0.01) {
                        const startOffset = y * Math.tan(this.grad2rad(startSlope));
                        positions[i * 3 + 2] = startOffset;
                    }

                    // Apply end slope (at z = length)
                    if (Math.abs(z - length) < 0.01) {
                        const endOffset = y * Math.tan(this.grad2rad(endSlope));
                        positions[i * 3 + 2] = length - endOffset;
                    }
                }

                geometry.attributes.position.needsUpdate = true;
                geometry.computeVertexNormals();
            }

            // Create and return the mesh
            const mesh = new THREE.Mesh(geometry, material);

            // Add edges to the I-beam
            const egeometry = new THREE.EdgesGeometry(geometry, 6);
            const linestandard = new THREE.LineSegments(egeometry, new THREE.LineBasicMaterial({ color: new THREE.Color('black'), linewidth: 1 }));
            linestandard.name = "KANTE";
            linestandard.userData.type = "edge";
            linestandard.userData.isHelper = true;
            mesh.add(linestandard);

            // Rotate the beam to align with Z-axis like other profiles
            mesh.rotation.x = -Math.PI / 2;

            // Center the beam along its length
            mesh.position.z = -length / 2;

            //     console.log("I-beam created successfully");
            return mesh;
        } catch (error) {
            console.warn("warn", error);
            return null;
        }
    }

    /// deprecated ///////////////////////////////////////////////////////
    private rotateAboutWorldAxis(obj: THREE.Object3D, axis: string, rotation: number) {

        //Create a matrix
        var matrix = new THREE.Matrix4();
        // Rotate the matrix
        if (axis == "x")
            matrix.makeRotationX(rotation);
        else if (axis == "y")
            matrix.makeRotationY(rotation);
        else if (axis == "z")
            matrix.makeRotationZ(rotation);

        //rotate the object using the matrix
        obj.applyMatrix4(matrix);

    }

    public EdgesGeometry(geometry) {
        try {
            // var thresholdAngle = 1; // (thresholdAngle !== undefined) ? thresholdAngle : 1;
            // // buffer
            var vertices = [];
            // // helper variables
            var thresholdDot = Math.cos(THREE.MathUtils.DEG2RAD * 1);
            var thresholdDot2 = Math.cos(THREE.MathUtils.DEG2RAD * 1111);
            var edge = [0, 0], edges = {}, edge1, edge2;
            var key, keys = ['a', 'b', 'c'];
            // prepare source geometry
            var geometry2;
            if (geometry.isBufferGeometry) {
                geometry2 = new THREE.BufferGeometry();
                //     geometry2.fromBufferGeometry(geometry);
            } else {
                geometry2 = geometry.clone();
            }
            geometry2.mergeVertices();
            geometry2.computeFaceNormals();
            var sourceVertices = geometry2.vertices;
            var faces = geometry2.faces;
            // now create a data structure where each entry represents an edge with its adjoining faces
            for (var i = 0, l = faces.length; i < l; i++) {
                var face = faces[i];
                for (var j = 0; j < 3; j++) {
                    edge1 = face[keys[j]];
                    edge2 = face[keys[(j + 1) % 3]];
                    edge[0] = Math.min(edge1, edge2);
                    edge[1] = Math.max(edge1, edge2);
                    key = edge[0] + ',' + edge[1];
                    if (edges[key] === undefined) {
                        edges[key] = { index1: edge[0], index2: edge[1], face1: i, face2: undefined };
                    } else {
                        edges[key].face2 = i;
                    }
                }
            }

            // generate vertices
            for (key in edges) {
                var e = edges[key];
                // an edge is only rendered if the angle (in degrees) between the face normals of the adjoining faces exceeds this value. default = 1 degree.
                if (
                    e.face2 === undefined ||
                    (faces[e.face1].normal.dot(faces[e.face2].normal) <= thresholdDot)) {//} && faces[e.face1].normal.dot(faces[e.face2].normal) >= thresholdDot2)) {

                    if (e.face2 !== undefined) {
                        var vertex = sourceVertices[e.index1];
                        vertices.push(vertex.x, vertex.y, vertex.z);
                        vertex = sourceVertices[e.index2];
                        vertices.push(vertex.x, vertex.y, vertex.z);
                    }

                }
            }

            var g = new THREE.BufferGeometry() as any; /// TODO: funzt?
            g.type = "EdgesGeometry";
            // build geometry
            var b = new THREE.Float32BufferAttribute(vertices, 3);
            g.setAttribute('position', b);

            return g;
        } catch (error) {
            console.warn("warn", error);
            return null;
        }
    }

    /**
     * Creates a connector sprite with customizable parameters
     * @param label The text label to display on the connector
     * @param params Additional parameters for customization
     * @returns THREE.Sprite
     */
    private createConnectorSprite(label: string, params: {
        size?: number,
        backgroundColor?: string,
        borderColor?: string,
        textColor?: string,
        fontSize?: number,
        shape?: 'circle' | 'square' | 'diamond',
        borderWidth?: number,
        opacity?: number
    } = {}): THREE.Sprite {
        try {
            // Default parameters
            const config = {
                size: params.size || 256,
                backgroundColor: params.backgroundColor || 'rgba(255, 100, 100, 1)',
                borderColor: params.borderColor || 'rgba(0, 0, 0, 0.8)',
                textColor: params.textColor || 'rgba(255, 255, 255, 1)',
                fontSize: params.fontSize || 100,
                shape: params.shape || 'circle',
                borderWidth: params.borderWidth || 6,
                opacity: params.opacity || 1
            };

            const canvas = document.createElement('canvas');
            canvas.width = config.size;
            canvas.height = config.size;
            const context = canvas.getContext('2d');

            // Clear the canvas with transparent background
            context.clearRect(0, 0, canvas.width, canvas.height);

            const centerX = canvas.width / 2;
            const centerY = canvas.height / 2;
            const radius = canvas.width / 2 - 5;

            // Draw shape based on configuration
            context.beginPath();
            switch (config.shape) {
                case 'circle':
                    context.arc(centerX, centerY, radius, 0, 2 * Math.PI);
                    break;
                case 'square':
                    const size = radius * 1.4;
                    context.rect(centerX - size / 2, centerY - size / 2, size, size);
                    break;
                case 'diamond':
                    context.moveTo(centerX, centerY - radius);
                    context.lineTo(centerX + radius, centerY);
                    context.lineTo(centerX, centerY + radius);
                    context.lineTo(centerX - radius, centerY);
                    context.closePath();
                    break;
            }

            // Create gradient or solid fill
            if (config.backgroundColor.includes('gradient')) {
                const gradient = context.createRadialGradient(centerX, centerY, 0, centerX, centerY, radius);
                gradient.addColorStop(0, 'rgba(255, 100, 100, ' + config.opacity + ')');
                gradient.addColorStop(1, 'rgba(200, 50, 50, ' + config.opacity + ')');
                context.fillStyle = gradient;
            } else {
                context.fillStyle = config.backgroundColor;
            }
            context.fill();

            // Add border
            context.strokeStyle = config.borderColor;
            context.lineWidth = config.borderWidth;
            context.stroke();

            // Draw the label with improved contrast
            context.fillStyle = config.textColor;
            context.strokeStyle = 'rgba(0, 0, 0, 0.8)';
            context.lineWidth = Math.max(2, config.borderWidth / 3);
            context.textAlign = 'center';
            context.textBaseline = 'middle';
            context.font = `bold ${config.fontSize}px Arial`;

            // Add text stroke for better visibility
            context.strokeText(label, centerX, centerY);
            context.fillText(label, centerX, centerY);

            const texture = new THREE.CanvasTexture(canvas);
            texture.needsUpdate = true;

            const spriteMaterial = new THREE.SpriteMaterial({
                map: texture,
                transparent: true,
                depthTest: false,
                depthWrite: false,
                sizeAttenuation: true,
                alphaTest: 0.1
            });

            const sprite = new THREE.Sprite(spriteMaterial);
            sprite.scale.set(10, 10, 1);
            sprite.renderOrder = 999; // Same as face center sprites

            // Store original scale for hover effects
            sprite.userData.originalScale = sprite.scale.clone();

            // Store configuration in userData for later reference
            sprite.userData.connectorConfig = config;
            sprite.userData.label = label;
            sprite.userData.isConnector = true;
            sprite.userData.type = 'connector'; // Add this so InteractionManager recognizes it

            // Ensure sprite is raycastable
            sprite.raycast = THREE.Sprite.prototype.raycast;

            return sprite;
        } catch (error) {
            console.warn("warn", error);
            return null;
        }
    }

    /**
     * Creates a comprehensive connector visualization with normal vector and additional features
     * @param position The 3D position of the connector
     * @param normal The normal vector at the connector point
     * @param label The label for the connector
     * @param params Additional parameters for customization
     * @returns THREE.Group containing all connector elements
     */
    private createConnectorVisualization(position: THREE.Vector3, normal: THREE.Vector3, label: string, params: {
        showArrow?: boolean,
        showSphere?: boolean,
        arrowLength?: number,
        arrowColor?: number,
        sphereRadius?: number,
        sphereColor?: number,
        connectorType?: string,
        size?: number,
        shape?: 'circle' | 'square' | 'diamond',
        backgroundColor?: string,
        borderColor?: string,
        textColor?: string,
        interactive?: boolean,
        type?: string
    } = {}): THREE.Group {
        try {
            // Determine connector type - default to sphere
            const connectorType = params.type || 'sphere';
            console.log('[CONNECTOR DEBUG] Creating connector with type:', connectorType, 'params:', params);

            const config = {
                showArrow: params.showArrow !== false,
                showSphere: connectorType === 'sphere' || connectorType === 'both' || !!params.showSphere,
                showSprite: connectorType === 'sprite' || connectorType === 'both',
                arrowLength: params.arrowLength || 15,
                arrowColor: params.arrowColor || 0xff0000,
                sphereRadius: params.sphereRadius || 3,
                sphereColor: params.sphereColor || 0xFF69B4, // Pink default for spheres
                connectorType: params.connectorType || 'default',
                interactive: params.interactive !== false,
                type: connectorType,
                ...params
            };

            console.log('[CONNECTOR DEBUG] Config determined:', {
                type: config.type,
                showSphere: config.showSphere,
                showSprite: config.showSprite,
                showArrow: config.showArrow
            });

            const group = new THREE.Group();

            // Set the group position to the intended position
            group.position.copy(position);

            // Create sprite for the connector point with custom parameters (if needed)
            if (config.showSprite) {
                console.log('[CONNECTOR DEBUG] Creating sprite for connector:', label);
                const spriteParams = {
                    size: config.size,
                    shape: config.shape,
                    backgroundColor: config.backgroundColor,
                    borderColor: config.borderColor,
                    textColor: config.textColor
                };
                const sprite = this.createConnectorSprite(label, spriteParams);
                // Keep sprite at origin relative to group
                sprite.position.set(0, 0, 0);
                sprite.userData.connectorType = config.connectorType;
                sprite.userData.isConnectorSprite = true;
                group.add(sprite);
                console.log('[CONNECTOR DEBUG] Sprite added to group');
            } else {
                console.log('[CONNECTOR DEBUG] Skipping sprite creation for connector:', label, 'showSprite:', config.showSprite);
            }

            // Create arrow to show normal direction (optional)
            if (config.showArrow) {
                const arrowHelper = new THREE.ArrowHelper(
                    normal.clone().normalize(),
                    new THREE.Vector3(0, 0, 0), // Arrow at origin relative to group
                    config.arrowLength,
                    config.arrowColor,
                    config.arrowLength * 0.3, // Head length
                    config.arrowLength * 0.2  // Head width
                );
                arrowHelper.userData.isConnectorArrow = true;
                group.add(arrowHelper);
            }

            // Create sphere at connector point (optional)
            if (config.showSphere) {
                console.log('[CONNECTOR DEBUG] Creating sphere for connector:', label);
                const sphereGeometry = new THREE.SphereGeometry(config.sphereRadius, 16, 16);
                const sphereMaterial = new THREE.MeshStandardMaterial({
                    color: config.sphereColor,
                    metalness: 0.1,
                    roughness: 0.3,
                    transparent: false
                });
                const sphere = new THREE.Mesh(sphereGeometry, sphereMaterial);
                // Keep sphere at origin relative to group
                sphere.position.set(0, 0, 0);
                sphere.userData.isConnectorSphere = true;
                sphere.userData.connectorLabel = label;
                sphere.userData.connectorType = config.connectorType;
                // Add properties for proximity effect
                sphere.userData.type = 'connector';
                sphere.userData.originalScale = 1.0;
                sphere.userData.originalOpacity = sphereMaterial.opacity || 1.0;
                group.add(sphere);
                console.log('[CONNECTOR DEBUG] Sphere added to group, radius:', config.sphereRadius);
            } else {
                console.log('[CONNECTOR DEBUG] Skipping sphere creation for connector:', label, 'showSphere:', config.showSphere);
            }

            // Store all configuration in group userData
            group.userData.isConnector = true;
            group.userData.connectorLabel = label;
            group.userData.connectorType = config.connectorType;
            group.userData.position = position.clone();
            group.userData.normal = normal.clone();
            group.userData.config = config;

            // Add interaction capabilities if enabled
            if (config.interactive && this.interactionManager) {
                this.setupConnectorInteractions(group);
            }

            return group;
        } catch (error) {
            console.warn("warn", error);
            return null;
        }
    }

    /**
     * Sets up interactive behaviors for connector elements
     * @param connectorGroup The connector group to make interactive
     */
    private setupConnectorInteractions(connectorGroup: THREE.Group): void {
        console.log('[CONNECTOR DEBUG] Setting up interactions for:', connectorGroup?.userData?.connectorLabel);

        // Add the main connector group to the interaction manager
        if (this.interactionManager) {
            console.log('[CONNECTOR DEBUG] Adding connector to InteractionManager');
            this.interactionManager.add(connectorGroup, {
                mouseEnter: (obj) => {
                    // Handle hover for different connector types
                    obj.traverse((child) => {
                        if (child instanceof THREE.Sprite && child.userData.isConnectorSprite) {
                            child.scale.multiplyScalar(1.2);
                        }
                        // For sphere connectors, just highlight sphere (no sprite)
                        if (child instanceof THREE.Mesh && child.userData.isConnectorSphere) {
                            // Highlight sphere
                            const material = child.material as THREE.MeshStandardMaterial;
                            child.userData.originalColor = material.color.clone();
                            material.color.setHex(0xFFEB3B); // Yellow highlight
                        }
                    });
                    document.body.style.cursor = 'pointer';
                },
                mouseLeave: (obj) => {
                    // Handle unhover for different connector types
                    obj.traverse((child) => {
                        if (child instanceof THREE.Sprite && child.userData.isConnectorSprite && child.userData.originalScale) {
                            child.scale.copy(child.userData.originalScale);
                        }
                        // For sphere connectors, restore sphere color
                        if (child instanceof THREE.Mesh && child.userData.isConnectorSphere) {
                            // Restore sphere color
                            if (child.userData.originalColor) {
                                const material = child.material as THREE.MeshStandardMaterial;
                                material.color.copy(child.userData.originalColor);
                            }
                        }
                    });
                    document.body.style.cursor = 'default';
                },
                click: (obj, event) => {
                    // Handle connector click
                    console.log('[CONNECTOR DEBUG] Main connector group clicked:', obj.userData.connectorLabel);

                    // Emit connector selection event with mouse coordinates
                    if (typeof window !== 'undefined' && (window as any).dispatchEvent) {
                        const customEvent = new CustomEvent('connectorSelected', {
                            detail: {
                                label: obj.userData.connectorLabel,
                                outputid: obj.userData.outputid,
                                position: obj.userData.position,
                                normal: obj.userData.normal,
                                type: obj.userData.connectorType,
                                mouseEvent: {
                                    clientX: event.clientX,
                                    clientY: event.clientY,
                                    layerX: event.layerX,
                                    layerY: event.layerY
                                }
                            }
                        });
                        window.dispatchEvent(customEvent);
                        console.log('[CONNECTOR DEBUG] Dispatched connectorSelected event with outputid:', obj.userData.outputid);
                    }
                }
            });
        }

        // Also add individual children for more granular control
        connectorGroup.traverse((child) => {
            if (child.userData?.isConnector || child.userData?.isConnectorArrow || child.userData?.isConnectorSphere) {
                if (this.interactionManager) {
                    this.interactionManager.add(child, {
                        mouseEnter: (obj) => {
                            // Highlight specific element on hover
                            if (obj instanceof THREE.Sprite && obj.userData.isConnectorSprite) {
                                obj.scale.multiplyScalar(1.2);
                            }
                            // Handle sphere connector hover
                            if (obj instanceof THREE.Mesh && obj.userData.isConnectorSphere) {
                                const material = obj.material as THREE.MeshStandardMaterial;
                                obj.userData.originalColor = material.color.clone();
                                material.color.setHex(0xFFEB3B); // Yellow highlight
                            }
                            document.body.style.cursor = 'pointer';
                        },
                        mouseLeave: (obj) => {
                            // Remove highlight
                            if (obj instanceof THREE.Sprite && obj.userData.isConnectorSprite) {
                                obj.scale.divideScalar(1.2);
                            }
                            // Handle sphere connector unhover
                            if (obj instanceof THREE.Mesh && obj.userData.isConnectorSphere) {
                                if (obj.userData.originalColor) {
                                    const material = obj.material as THREE.MeshStandardMaterial;
                                    material.color.copy(obj.userData.originalColor);
                                }
                            }
                            document.body.style.cursor = 'default';
                        },
                        click: (obj, event) => {
                            // Handle connector element click
                            const group = obj.parent || obj;
                            console.log('[CONNECTOR DEBUG] Connector element clicked:', group.userData?.connectorLabel);

                            // Emit connector selection event with mouse coordinates
                            if (typeof window !== 'undefined' && (window as any).dispatchEvent) {
                                const customEvent = new CustomEvent('connectorSelected', {
                                    detail: {
                                        label: group.userData.connectorLabel,
                                        outputid: group.userData.outputid,
                                        position: group.userData.position,
                                        normal: group.userData.normal,
                                        type: group.userData.connectorType,
                                        mouseEvent: {
                                            clientX: event.clientX,
                                            clientY: event.clientY,
                                            layerX: event.layerX,
                                            layerY: event.layerY
                                        }
                                    }
                                });
                                window.dispatchEvent(customEvent);
                                console.log('[CONNECTOR DEBUG] Dispatched connectorSelected event from element with outputid:', group.userData.outputid);
                            }
                        }
                    });
                }
            }
        });
    }

    public setupDimensionLineInteractions(group: THREE.Group, interactionManager: InteractionManager) {
        group.traverse((object) => {
            if (object.userData?.isDimensionText && object.userData?.isInteractive) {
                interactionManager.add(object, {
                    mouseEnter: (obj) => {
                        const sprite = obj as threeSpritetext;  // Cast to correct type
                        sprite.scale.multiplyScalar(1.2);
                        interactionManager.cursorType = 'pointer';
                        sprite.color = '#ff0000';
                        sprite.backgroundColor = 'rgba(255,255,255,0.9)';
                    },
                    mouseLeave: (obj) => {
                        const sprite = obj as threeSpritetext;  // Cast to correct type
                        sprite.scale.copy(sprite.userData.originalScale);
                        interactionManager.cursorType = 'default';
                        sprite.color = sprite.userData.originalColor;
                        sprite.backgroundColor = sprite.userData.originalBgColor;
                    },
                    click: (obj, event) => {
                        const sprite = obj as THREE.Sprite;
                        console.log('Clicked dimension text:', sprite.userData.dimensionValue);
                        if (sprite.userData.editcell) {
                            // Handle edit cell interaction if needed
                        }
                    }
                });
            }
        });
        return group;
    }



    // Example of adding an object with interactions:
    private addInteractiveObject(object: THREE.Object3D) {
        this.interactionManager.add(object, {
            mouseEnter: (obj) => {
                console.log('Mouse entered object:', obj);
                document.body.style.cursor = 'pointer';
                // Add hover effects
            },
            mouseLeave: (obj) => {
                document.body.style.cursor = 'default';
                // Remove hover effects
            },
            click: (obj, event) => {
                // Handle click
                console.log('Object clicked:', obj);
            },
            doubleClick: (obj, event) => {
                // Handle double click
                //  this.sceneDoubleClick(event);
            }
        });
    }

    /**
     * Creates a connector from row data parameters
     * @param position Position as string "x,y,z" or THREE.Vector3
     * @param normal Normal vector as string "x,y,z" or THREE.Vector3
     * @param label The connector label
     * @param params Additional parameters from row data
     * @returns THREE.Group containing the connector
     */
    public createConnector(position: string | THREE.Vector3, normal: string | THREE.Vector3, label: string, params: any = {}): THREE.Group {
        try {
            console.log('[CONNECTOR DEBUG] Creating connector:', label);

            // Parse position
            let pos: THREE.Vector3;
            if (typeof position === 'string') {
                const [x, y, z] = position.split(',').map(Number);
                pos = new THREE.Vector3(x || 0, y || 0, z || 0);
            } else {
                pos = position.clone();
            }

            // Parse normal
            let norm: THREE.Vector3;
            if (typeof normal === 'string') {
                const [x, y, z] = normal.split(',').map(Number);
                norm = new THREE.Vector3(x || 0, y || 1, z || 0).normalize();
            } else {
                norm = normal.clone().normalize();
            }

            // Parse additional parameters
            const connectorParams = {
                type: params.type || 'sphere', // Default to sphere
                showArrow: this.parseBoolean(params.showArrow),
                arrowLength: parseFloat(params.arrowLength) || 15,
                arrowColor: params.arrowColor ? parseInt(params.arrowColor.replace('#', '0x')) : 0xff0000,
                sphereRadius: parseFloat(params.sphereRadius) || 3,
                sphereColor: params.sphereColor ? parseInt(params.sphereColor.replace('#', '0x')) : 0xFF69B4,
                connectorType: params.connectorType || 'default',
                size: parseFloat(params.size) || 128,
                shape: params.shape || 'circle',
                backgroundColor: params.backgroundColor || 'rgba(255, 255, 255, 0.9)',
                borderColor: params.borderColor || 'rgba(0, 0, 0, 0.8)',
                textColor: params.textColor || 'rgba(0, 0, 0, 1)',
                interactive: this.parseBoolean(params.interactive) !== false
            };

            const connector = this.createConnectorVisualization(pos, norm, label, connectorParams);
            console.log('[CONNECTOR DEBUG] Connector created, has InteractionManager:', !!this.interactionManager);

            return connector;
        } catch (error) {
            console.warn("Error creating connector:", error);
            return new THREE.Group(); // Return empty group on error
        }
    }

    /**
     * Updates an existing connector with new parameters
     * @param connector The connector group to update
     * @param newParams New parameters to apply
     */
    public updateConnector(connector: THREE.Group, newParams: any = {}): void {
        if (!connector.userData?.isConnector) return;

        try {
            // Update position if provided
            if (newParams.position) {
                let newPos: THREE.Vector3;
                if (typeof newParams.position === 'string') {
                    const [x, y, z] = newParams.position.split(',').map(Number);
                    newPos = new THREE.Vector3(x || 0, y || 0, z || 0);
                } else {
                    newPos = newParams.position.clone();
                }

                connector.traverse((child) => {
                    if (child.userData?.isConnector) {
                        child.position.copy(newPos);
                    }
                });
                connector.userData.position = newPos;
            }

            // Update visibility
            if (newParams.visible !== undefined) {
                connector.visible = newParams.visible;
            }

            // Update scale
            if (newParams.scale) {
                const scale = parseFloat(newParams.scale);
                connector.traverse((child) => {
                    if (child instanceof THREE.Sprite) {
                        child.scale.setScalar(scale);
                    }
                });
            }
        } catch (error) {
            console.warn("Error updating connector:", error);
        }
    }

    /**
     * Gets all connectors in the scene
     * @param scene The Three.js scene
     * @returns Array of connector groups
     */
    public getConnectors(scene: THREE.Scene): THREE.Group[] {
        const connectors: THREE.Group[] = [];
        scene.traverse((child) => {
            if (child.userData?.isConnector && child instanceof THREE.Group) {
                connectors.push(child);
            }
        });
        return connectors;
    }

    /**
     * Creates an InstancedMesh from an existing mesh
     * @param sourceMesh The source mesh to create instances from
     * @param count The number of instances to create
     * @param transforms Array of objects containing position, rotation, and scale for each instance
     * @returns THREE.InstancedMesh
     */
    createInstancedMeshFromExisting(sourceMesh: THREE.Mesh, count: number, transforms: Array<{
        position: THREE.Vector3,
        rotation: THREE.Euler,
        scale: THREE.Vector3
    }> = []): THREE.InstancedMesh {
        // Create the instanced mesh
        const instancedMesh = new THREE.InstancedMesh(
            sourceMesh.geometry,
            sourceMesh.material,
            count
        );

        // Copy properties from source mesh
        instancedMesh.castShadow = sourceMesh.castShadow;
        instancedMesh.receiveShadow = sourceMesh.receiveShadow;
        instancedMesh.name = sourceMesh.name + "_instanced";

        // Set up matrix for each instance
        const matrix = new THREE.Matrix4();
        const position = new THREE.Vector3();
        const rotation = new THREE.Euler();
        const quaternion = new THREE.Quaternion();
        const scale = new THREE.Vector3(1, 1, 1);

        // Apply transforms for each instance
        for (let i = 0; i < count; i++) {
            if (transforms[i]) {
                position.copy(transforms[i].position);
                rotation.copy(transforms[i].rotation);
                scale.copy(transforms[i].scale);
            } else {
                // Default transform if not provided
                position.set(0, 0, 0);
                rotation.set(0, 0, 0);
                scale.set(1, 1, 1);
            }

            // Create matrix from position, rotation, and scale
            matrix.compose(
                position,
                quaternion.setFromEuler(rotation),
                scale
            );

            // Set the matrix for this instance
            instancedMesh.setMatrixAt(i, matrix);
        }

        // Copy user data from source mesh
        instancedMesh.userData = { ...sourceMesh.userData };
        instancedMesh.userData.isInstanced = true;
        instancedMesh.userData.sourceGeometry = sourceMesh.geometry.uuid;
        instancedMesh.userData.instanceCount = count;

        // Update the instance matrix
        instancedMesh.instanceMatrix.needsUpdate = true;

        return instancedMesh;
    }

    /**
     * Updates the transform of a specific instance in an InstancedMesh
     * @param instancedMesh The InstancedMesh to update
     * @param instanceIndex The index of the instance to update
     * @param position New position
     * @param rotation New rotation
     * @param scale New scale
     */
    updateInstanceTransform(
        instancedMesh: THREE.InstancedMesh,
        instanceIndex: number,
        position: THREE.Vector3,
        rotation: THREE.Euler,
        scale: THREE.Vector3
    ): void {
        if (instanceIndex >= instancedMesh.count) {
            console.warn('Instance index out of bounds');
            return;
        }

        const matrix = new THREE.Matrix4();
        const quaternion = new THREE.Quaternion();
        quaternion.setFromEuler(rotation);

        matrix.compose(position, quaternion, scale);
        instancedMesh.setMatrixAt(instanceIndex, matrix);
        instancedMesh.instanceMatrix.needsUpdate = true;
    }

    // Add this method to the CADNodeEngine class

    getRefPoses(scene: THREE.Scene): RefPos[] {
        const refPoses: RefPos[] = [];

        // Traverse the scene to find all reference points
        scene.traverse((child) => {
            if (child.userData?.type === "refpoint" && child.userData?.isHelper) {
                const refPos: RefPos = {
                    index: child.userData.index,
                    position: child.position.clone(),
                    worldPosition: new THREE.Vector3(),
                    outputid: child.userData.outputid2,
                    name: child.name,
                    path: child.userData.path,
                    parentName: child.parent?.name,
                    parentPath: child.parent?.userData?.path,
                    origPos: child.userData.origpos?.clone(),
                    normal: undefined  // Initialize as undefined
                };

                // Get world position
                child.getWorldPosition(refPos.worldPosition);

                // Add any normal vector if it exists
                const normalObject = child.parent?.children.find(
                    sibling => sibling.userData?.type === "refnormal" &&
                        sibling.userData?.index === child.userData.index
                );

                if (normalObject?.userData?.normal) {
                    refPos.normal = normalObject.userData.normal.clone();
                }

                refPoses.push(refPos);
            }
        });

        // Sort by outputid and index for consistent ordering
        refPoses.sort((a, b) => {
            if (a.outputid === b.outputid) {
                return a.index - b.index;
            }
            return a.outputid.localeCompare(b.outputid);
        });

        return refPoses;
    }

    // Add after other methods
    public exportToSTEP(scene: THREE.Scene): void {
        const stepExporter = new StepExporter();
        stepExporter.export(scene);
    }

    public async createCopy(sourceObjectId: string, scene: THREE.Scene): Promise<THREE.Object3D | null> {
        // Find the source object in the scene
        const sourceObject = scene.getObjectByName(sourceObjectId);
        if (!sourceObject) {
            console.warn(`Source object with ID ${sourceObjectId} not found`);
            return null;
        }

        // Create a deep clone of the object
        const clonedObject = sourceObject.clone();

        // Generate a unique name for the cloned object
        const baseName = sourceObjectId.replace(/\d+$/, '');
        let counter = 1;
        let newName = `${baseName}${counter}`;
        while (scene.getObjectByName(newName)) {
            counter++;
            newName = `${baseName}${counter}`;
        }
        clonedObject.name = newName;

        // Slightly offset the position of the cloned object
        if (clonedObject.position) {
            clonedObject.position.x += 50; // Offset by 50 units in x direction
        }

        // Copy materials
        if (clonedObject instanceof THREE.Mesh && sourceObject instanceof THREE.Mesh) {
            if (Array.isArray(sourceObject.material)) {
                clonedObject.material = sourceObject.material.map(mat => mat.clone());
            } else {
                clonedObject.material = sourceObject.material.clone();
            }
        }

        // Copy any custom properties
        for (const prop in sourceObject.userData) {
            clonedObject.userData[prop] = JSON.parse(JSON.stringify(sourceObject.userData[prop]));
        }

        return clonedObject;
    }


    createMeasuringGrid(path: string, width: number, length: number, mainGap: number, subGap: number, nthLabel: number, labelSize: number, lineWidth: number, mainColor: string, subColor: string, labelColor: string, params: any = {}): THREE.Group {
        try {
            const group = new THREE.Group();

            var outputid = path.split('#').pop();
            // Default visibility settings
            const showMainLines = params.showMainLines !== false;
            const showSubLines = params.showSubLines !== false;
            const showLabels = params.showLabels !== false;
            const showXAxis = params.showXAxis !== false;
            const showYAxis = params.showYAxis !== false;
            const startX = params.startX || -width / 2;
            const endX = params.endX || width / 2;
            const startY = params.startY || -length / 2;
            const endY = params.endY || length / 2;
            const labelOffsetX = parseFloat(params.labelOffsetX) || 0;  // Ensure we parse the offset value
            const labelOffsetY = parseFloat(params.labelOffsetY) || 0;  // Ensure we parse the offset value

            // Create main grid lines
            const mainLinesX = Math.floor(width / mainGap) + 1;
            const mainLinesY = Math.floor(length / mainGap) + 1;

            // Create sub grid lines
            const subLinesX = Math.floor(width / subGap) + 1;
            const subLinesY = Math.floor(length / subGap) + 1;

            // Helper function to format point as string
            const formatPoint = (x: number, y: number, z: number): string => {
                return `(${x},${y},${z})`;
            };

            // Helper function to create a line
            const createLine = (startX: number, startY: number, startZ: number, endX: number, endY: number, endZ: number, color: string, width: number) => {
                const line = this.createLine(
                    formatPoint(startX, startY, startZ),
                    formatPoint(endX, endY, endZ),
                    width,
                    color
                );
                group.add(line);
                return line;
            };

            // Helper function to create text sprite
            const createLabel = (text: string, position: THREE.Vector3) => {
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');

                // Set canvas size based on text metrics
                if (context) {
                    context.font = `${labelSize * 10}px Arial`;
                    const metrics = context.measureText(text);
                    const textWidth = metrics.width * 1.5; // Stretch text width
                    const textHeight = labelSize * 22; // Reduce text height

                    // Add padding around text
                    canvas.width = textWidth * 1.1;
                    canvas.height = textHeight * 1.1;

                    // Need to reset font after changing canvas size
                    context.font = `${labelSize * 10}px Arial`;
                    context.fillStyle = labelColor;
                    context.textAlign = 'center';
                    context.textBaseline = 'middle';
                    context.fillText(text, canvas.width / 2, canvas.height / 2);
                }

                const texture = new THREE.CanvasTexture(canvas);
                const spriteMaterial = new THREE.SpriteMaterial({ map: texture });
                const sprite = new THREE.Sprite(spriteMaterial);
                sprite.position.copy(position);
                sprite.scale.set(labelSize, labelSize, 1);
                return sprite;
            };

            // Create sub grid lines
            if (showSubLines) {
                for (let i = 0; i < subLinesX; i++) {
                    const x = (i * subGap) - (width / 2);
                    if (x >= startX && x <= endX) {
                        createLine(
                            x, Math.max(-length / 2, startY), 0,  // start point
                            x, Math.min(length / 2, endY), 0,   // end point
                            subColor,
                            lineWidth * 0.5
                        );
                    }
                }

                for (let i = 0; i < subLinesY; i++) {
                    const y = (i * subGap) - (length / 2);
                    if (y >= startY && y <= endY) {
                        createLine(
                            Math.max(-width / 2, startX), y, 0,  // start point
                            Math.min(width / 2, endX), y, 0,   // end point
                            subColor,
                            lineWidth * 0.5
                        );
                    }
                }
            }

            // Store face centers for interaction
            const faceCenters = [];

            // Create main grid lines and labels, and store face centers
            for (let i = 0; i < mainLinesX; i++) {
                const x = (i * mainGap) - (width / 2);

                // Only create visible grid lines if they're within the visible range
                if (showMainLines && x >= startX && x <= endX) {
                    createLine(
                        x, Math.max(-length / 2, startY), 0,  // start point
                        x, Math.min(length / 2, endY), 0,   // end point
                        mainColor,
                        lineWidth
                    );

                    // Add labels every nth line if they're within the visible range
                    if (showLabels && i % nthLabel === 0) {
                        const labelValue = Math.round(x); // Get actual position
                        const labelX = x;
                        const labelY = Math.max(-length / 2, startY) - labelSize; // Position label at the start of visible grid
                        const label = createLabel((labelValue + labelOffsetX).toString(), new THREE.Vector3(labelX, labelY, 0));
                        group.add(label);
                    }
                }

                // Add face centers at all main grid intersections, regardless of visibility
                for (let j = 0; j < mainLinesY; j++) {
                    const y = (j * mainGap) - (length / 2);
                    faceCenters.push({
                        position: new THREE.Vector3(x, y, 0),
                        normal: new THREE.Vector3(0, 0, 1),
                        index: i * mainLinesY + j + 1,
                        outputid: outputid
                    });
                }
            }

            if (showMainLines) {
                for (let i = 0; i < mainLinesY; i++) {
                    const y = (i * mainGap) - (length / 2);
                    if (y >= startY && y <= endY) {
                        createLine(
                            Math.max(-width / 2, startX), y, 0,  // start point
                            Math.min(width / 2, endX), y, 0,   // end point
                            mainColor,
                            lineWidth
                        );

                        // Add labels every nth line
                        if (showLabels && i % nthLabel === 0) {
                            const labelValue = Math.round(y); // Get actual position
                            const labelX = Math.max(-width / 2, startX) - labelSize; // Position label at the start of visible grid
                            const labelY = y;
                            const label = createLabel((labelValue + labelOffsetY).toString(), new THREE.Vector3(labelX, labelY, 0));
                            group.add(label);
                        }
                    }
                }
            }

            // Store face centers in userData for editor interaction
            group.userData.faceCenters = faceCenters;

            return group;
        } catch (error) {
            console.warn("warn", error);
            return null;
        }
    }

    // needed for cuts to just recreate one node without tree generation
    async recreateCADNode(oldNode: THREE.Object3D, scene: THREE.Scene, excels: any): Promise<THREE.Object3D | null> {
        if (!oldNode) {
            console.warn("Cannot recreate node - missing oldNode", oldNode);
            return null;
        }
        if (!oldNode.userData?.row || !oldNode.userData?.commentrow) {
            console.warn("Cannot recreate node - missing userData", oldNode);
            return null;
        }


        // Store the old node's data
        const oldUserData = JSON.parse(JSON.stringify(oldNode?.userData));
        const oldName = oldNode?.name;
        const oldPath = oldNode?.userData?.path;
        const oldParent = oldNode?.parent;

        // Create new node using stored data
        const newNode = await this.createOrUpdateCADNode(
            oldUserData.rowindex,
            oldUserData.sheetid,
            oldName,
            oldUserData.row,
            oldUserData.commentrow,
            scene,
            excels, // excels - not needed for recreation
            oldUserData.configuration,
            null, // loaded nicht gnutzt
            null, // workers nicht gnutzt
            oldUserData.customerid,
            oldUserData.projectid,
            null, // projectconfigmodel 
            oldUserData.sourcesheetid,
            true
        );

        if (newNode) {
            // Remove the old node from its parent
            console.log('removefp', oldNode.name);
            oldNode.removeFromParent();

            // Add new node to the old node's parent if it exists, otherwise to the scene
            if (oldParent) {
                oldParent.add(newNode);
            } else {
                scene.add(newNode);
            }

            // Ensure the new node has the same name and path
            newNode.name = oldName;
            if (!newNode.userData) newNode.userData = {};
            newNode.userData.path = oldPath;

            return newNode;
        }

        return null;
    }

    private async updateConfigurationAndOutputRows(path: string, projectconfigmodel: any, excels: any, outputRows: any[], outputRowIndexes: number[]) {
        let configProps = {} as any;
        if (projectconfigmodel) {
            configProps = Object.keys(projectconfigmodel)
                .filter(key => key.startsWith(path))
                .reduce((obj, key) => {
                    obj[key] = projectconfigmodel[key];
                    return obj;
                }, {});
        }

        for (const key in configProps) {
            let config = configProps[key];
            let rowindex = config.rowindex;
            let sheetid = config.sheetid;
            let row = config.row;
            let configuration = config.configuration;
            var changes = await excels[configuration].setCellContents({ sheet: sheetid, row: rowindex, col: 0 }, [row]);
            console.log("changes", changes);

            if (changes && changes.length > 0) {
                for (const change of changes) {
                    const changeRowIndex = change.address.row;
                    const outputRowPosition = outputRowIndexes.indexOf(changeRowIndex);
                    if (outputRowPosition !== -1 && changeRowIndex !== rowindex) {
                        outputRows[outputRowPosition][change.address.col] = change.newValue;
                    }
                }
            }
        }

        return { outputRows, outputRowIndexes };
    }

    public getFlattenedNodes(scene: THREE.Scene): Array<{
        name: string;
        path: string;
        userData: any;
        type: string;
        visible: boolean;
        position: THREE.Vector3;
        rotation: THREE.Euler;
        scale: THREE.Vector3;
        parent?: {
            name: string;
            path: string;
        };
    }> {
        const flattenedNodes: Array<{
            name: string;
            path: string;
            userData: any;
            type: string;
            visible: boolean;
            position: THREE.Vector3;
            rotation: THREE.Euler;
            scale: THREE.Vector3;
            parent?: {
                name: string;
                path: string;
            };
        }> = [];

        scene.traverse((node: THREE.Object3D) => {
            // Skip helpers and invisible objects
            if (node.userData?.isHelper || !node.visible) {
                return;
            }

            // Create a clean copy of userData without circular references
            const cleanUserData = JSON.parse(JSON.stringify(node.userData));

            const nodeInfo = {
                name: node.name,
                path: node.userData?.path || '',
                userData: cleanUserData,
                type: node.type,
                visible: node.visible,
                position: node.position.clone(),
                rotation: node.rotation.clone(),
                scale: node.scale.clone(),
                parent: node.parent ? {
                    name: node.parent.name,
                    path: node.parent.userData?.path || ''
                } : undefined
            };

            flattenedNodes.push(nodeInfo);
        });

        // Sort by path for consistent ordering
        flattenedNodes.sort((a, b) => a.path.localeCompare(b.path));

        return flattenedNodes;
    }

    mergeMeshes(meshes: THREE.Mesh[]): THREE.Mesh | null {
        if (!meshes || meshes.length === 0) {
            return null;
        }

        if (meshes.length === 1) {
            return meshes[0];
        }

        try {
            // Update matrix world for all meshes
            meshes.forEach(mesh => mesh.updateMatrixWorld(true));

            // Start with the first mesh
            let baseMesh = meshes[0];
            let bspResult = CSG.fromMesh(baseMesh);

            // Union with all other meshes
            for (let i = 1; i < meshes.length; i++) {
                const currentMesh = meshes[i];
                const bspCurrent = CSG.fromMesh(currentMesh);
                bspResult = bspResult.union(bspCurrent);
            }

            // Convert back to mesh
            const resultMesh = CSG.toMesh(bspResult, baseMesh.matrix) as THREE.Mesh;
            resultMesh.material = baseMesh.material;
            resultMesh.receiveShadow = true;
            resultMesh.castShadow = true;
            resultMesh.name = 'MergedMesh';
            resultMesh.visible = true;
            resultMesh.userData = { merged: true, sources: meshes.map(m => m.name) };

            // Add edges
            const edges = new THREE.EdgesGeometry(resultMesh.geometry);
            const edgesMaterial = new THREE.LineBasicMaterial({ color: 0x000000 });
            const edgesMesh = new THREE.LineSegments(edges, edgesMaterial);
            resultMesh.add(edgesMesh);

            // Recalculate face centers
            this.addFaceCenters(resultMesh, 'merged');

            return resultMesh;
        } catch (error) {
            console.error("Error merging meshes:", error);
            return null;
        }
    }

    /**
     * Merges all visible meshes in the scene into a single mesh
     * @param scene The THREE.Scene containing meshes to merge
     * @param options Options for merging (filter function, material, name)
     * @returns The merged mesh or null if no meshes to merge
     */
    mergeMeshesInScene(scene: THREE.Scene, options: {
        filter?: (mesh: THREE.Mesh) => boolean,
        material?: THREE.Material,
        name?: string
    } = {}): THREE.Mesh | null {
        // Default options
        const filterFn = options.filter || ((mesh: THREE.Mesh) =>
            mesh.visible &&
            mesh.geometry &&
            !mesh.userData.merged &&
            mesh instanceof THREE.Mesh);

        // Find all meshes that match the filter
        const meshesToMerge: THREE.Mesh[] = [];
        scene.traverse((object) => {
            if (object instanceof THREE.Mesh && filterFn(object)) {
                meshesToMerge.push(object);
            }
        });

        if (meshesToMerge.length === 0) {
            console.warn("No meshes found to merge");
            return null;
        }

        // Merge the meshes
        const mergedMesh = this.mergeMeshes(meshesToMerge);

        if (mergedMesh) {
            // Apply custom options
            if (options.material) {
                mergedMesh.material = options.material;
            }

            if (options.name) {
                mergedMesh.name = options.name;
            }

            // Hide original meshes
            meshesToMerge.forEach(mesh => {
                mesh.visible = false;
            });

            // Add the merged mesh to the scene
            scene.add(mergedMesh);
        }

        return mergedMesh;
    }

    // --- REVISED createTube Function (Extruded Arcs for Elbows) ---
    createTube(pathString: string, radius: number, bendRadiusFactor: number, material: THREE.Material): THREE.Group {
        const group = new THREE.Group();
        const points = pathString.replace(/\s/g, '').split(";").map(pStr => {
            // ... (robust point parsing) ...
            if (!pStr.startsWith("(") || !pStr.endsWith(")")) return null;
            const coords = pStr.substring(1, pStr.length - 1).split(",");
            if (coords.length !== 3) return null;
            const x = parseFloat(coords[0]);
            const y = parseFloat(coords[1]);
            const z = parseFloat(coords[2]);
            if (isNaN(x) || isNaN(y) || isNaN(z)) return null;
            return new THREE.Vector3(x, y, z);
        }).filter(p => p !== null);

        if (points.length < 2) {
            console.warn("Tube path needs at least 2 valid points. Path:", pathString);
            return group; // Return empty group
        }

        const radialSegments = 12; // Segments around the tube cross-section
        const bendCurveSegments = 16; // Segments along the bend arc curve
        const idealTubeBendRadius = Math.max(radius + 0.01, radius * bendRadiusFactor); // Ensure bend radius is at least tube radius
        const minSegmentLength = 0.001; // Small epsilon for geometric checks
        const minPracticalBendRadius = radius + minSegmentLength;


        // Create the 2D shape for the tube cross-section
        const tubeShape = new THREE.Shape();
        tubeShape.absarc(0, 0, radius, 0, Math.PI * 2, false); // Circle shape

        let lastPointProcessed = points[0]; // Tracks the end point of the last added segment (straight or bend)

        try {
            for (let i = 0; i < points.length - 1; i++) {
                const P_curr = points[i];
                const P_next = points[i + 1]; // This is the potential corner point

                let drawStraightOnly = true; // Assume straight segment initially
                let bendStartPt: THREE.Vector3 | null = null;
                let bendEndPt: THREE.Vector3 | null = null;
                let bendCenterPt: THREE.Vector3 | null = null;
                let actualBendRadius = idealTubeBendRadius;
                let V_in_Final: THREE.Vector3 | null = null;
                let V_out_Final: THREE.Vector3 | null = null;
                let bendAxis: THREE.Vector3 | null = null;
                let bendAngle = 0;


                // --- Check if a bend needs to be calculated at P_next ---
                if (i < points.length - 2) {
                    const P_after_next = points[i + 2];
                    const V_in = new THREE.Vector3().subVectors(P_next, P_curr).normalize();
                    const V_out = new THREE.Vector3().subVectors(P_after_next, P_next).normalize();
                    const dot = V_in.dot(V_out);

                    if (Math.abs(dot) < 0.999 && P_curr.distanceTo(P_next) > minSegmentLength && P_next.distanceTo(P_after_next) > minSegmentLength) { // It's a potential bend
                        const angle = Math.acos(THREE.MathUtils.clamp(dot, -1, 1)); // Angle between V_in.negate() and V_out

                        if (angle > minSegmentLength * 2) { // Only proceed if angle is significant
                            const halfAngle = angle / 2;
                            const tanHalfAngle = Math.tan(halfAngle);

                            if (Math.abs(tanHalfAngle) > minSegmentLength) { // Avoid issues if tanHalfAngle is near zero
                                let currentProposedBendRadius = idealTubeBendRadius;
                                let requiredTangentDist = currentProposedBendRadius / tanHalfAngle;

                                const availableLengthIn = P_curr.distanceTo(P_next);
                                const availableLengthOut = P_next.distanceTo(P_after_next);

                                // Check if ideal bend fits
                                if (requiredTangentDist > availableLengthIn - minSegmentLength || requiredTangentDist > availableLengthOut - minSegmentLength) {
                                    // Ideal bend doesn't fit, calculate max possible bend radius
                                    const maxPossibleTangentDist = Math.min(availableLengthIn - minSegmentLength, availableLengthOut - minSegmentLength);

                                    if (maxPossibleTangentDist > minSegmentLength) {
                                        currentProposedBendRadius = maxPossibleTangentDist * tanHalfAngle;
                                        // Ensure new radius is not too small or larger than original ideal
                                        currentProposedBendRadius = Math.max(minPracticalBendRadius, currentProposedBendRadius);
                                        currentProposedBendRadius = Math.min(idealTubeBendRadius, currentProposedBendRadius); // Don't exceed original if path allows more

                                        requiredTangentDist = currentProposedBendRadius / tanHalfAngle;

                                        // Final check if this adjusted radius is feasible
                                        if (currentProposedBendRadius < minPracticalBendRadius - minSegmentLength || // ensure it's practically bendable
                                            requiredTangentDist > availableLengthIn - minSegmentLength + minSegmentLength || // add tolerance
                                            requiredTangentDist > availableLengthOut - minSegmentLength + minSegmentLength) {
                                            // console.warn(`Tube: Point ${i + 1}: Adjusted bend (R=${currentProposedBendRadius.toFixed(2)}) still doesn't fit. Segments: In=${availableLengthIn.toFixed(2)}, Out=${availableLengthOut.toFixed(2)}. RequiredTangent=${requiredTangentDist.toFixed(2)}. Treating as straight.`);
                                            drawStraightOnly = true;
                                        } else {
                                            actualBendRadius = currentProposedBendRadius;
                                            drawStraightOnly = false;
                                            // console.log(`Tube: Point ${i + 1}: Adjusted bend radius to ${actualBendRadius.toFixed(2)}.`);
                                        }
                                    } else {
                                        // console.warn(`Tube: Point ${i + 1}: Segments too short for any bend. In=${availableLengthIn.toFixed(2)}, Out=${availableLengthOut.toFixed(2)}. Treating as straight.`);
                                        drawStraightOnly = true;
                                    }
                                } else {
                                    // Ideal bend fits
                                    actualBendRadius = idealTubeBendRadius;
                                    drawStraightOnly = false;
                                }

                                if (!drawStraightOnly) {
                                    bendStartPt = P_next.clone().addScaledVector(V_in, -requiredTangentDist);
                                    bendEndPt = P_next.clone().addScaledVector(V_out, requiredTangentDist);

                                    V_in_Final = V_in;
                                    V_out_Final = V_out;
                                    bendAngle = angle;
                                    bendAxis = new THREE.Vector3().crossVectors(V_in, V_out).normalize();
                                    if (bendAxis.lengthSq() < minSegmentLength * minSegmentLength) { // collinear?
                                        // console.warn(`Collinear segments at point ${i+1}, forcing straight.`);
                                        drawStraightOnly = true; // Fallback if axis is zero
                                    } else {
                                        const bisector = new THREE.Vector3().addVectors(V_in.clone().multiplyScalar(-1), V_out).normalize();
                                        const sinHalfAngle = Math.sin(halfAngle);
                                        const centerToCornerDist = (sinHalfAngle > minSegmentLength) ? actualBendRadius / sinHalfAngle : actualBendRadius;
                                        bendCenterPt = P_next.clone().addScaledVector(bisector, centerToCornerDist);
                                    }
                                }
                            }
                        }
                    }
                }


                if (!drawStraightOnly && bendStartPt && bendEndPt && bendCenterPt && V_in_Final && V_out_Final && bendAxis) {
                    // 1. Add Straight Segment before bend
                    const straightLengthBeforeBend = lastPointProcessed.distanceTo(bendStartPt);
                    if (straightLengthBeforeBend > minSegmentLength) {
                        const straightGeom = new THREE.CylinderGeometry(radius, radius, straightLengthBeforeBend, radialSegments, 1, false);
                        const straightMesh = new THREE.Mesh(straightGeom, material);
                        straightMesh.castShadow = true; straightMesh.receiveShadow = true;
                        const midpoint = new THREE.Vector3().addVectors(lastPointProcessed, bendStartPt).multiplyScalar(0.5);
                        straightMesh.position.copy(midpoint);
                        const direction = new THREE.Vector3().subVectors(bendStartPt, lastPointProcessed).normalize();
                        if (direction.lengthSq() > minSegmentLength * minSegmentLength) straightMesh.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), direction);
                        group.add(straightMesh);
                    }

                    // 2. Add Bend Segment (TubeGeometry)
                    const arcPointsForSpline: THREE.Vector3[] = [];
                    const startVecForArc = new THREE.Vector3().subVectors(bendStartPt, bendCenterPt);

                    // Simplified and safe heuristic for controlPointOffset using only locally available values:
                    const controlPointOffset = Math.min(actualBendRadius * 0.25, radius * 1.5);

                    // Control point before bendStartPt
                    arcPointsForSpline.push(bendStartPt.clone().addScaledVector(V_in_Final.clone().negate(), Math.max(minSegmentLength, controlPointOffset)));

                    // Points on the arc including bendStartPt and bendEndPt
                    for (let j = 0; j <= bendCurveSegments; j++) {
                        const t = j / bendCurveSegments;
                        arcPointsForSpline.push(bendCenterPt.clone().add(startVecForArc.clone().applyAxisAngle(bendAxis, bendAngle * t)));
                    }

                    // Control point after bendEndPt
                    arcPointsForSpline.push(bendEndPt.clone().addScaledVector(V_out_Final, Math.max(minSegmentLength, controlPointOffset)));


                    if (arcPointsForSpline.length >= 4) { // CatmullRom needs at least 2 points for the curve part, plus 2 controls.
                        const arcCurve = new THREE.CatmullRomCurve3(arcPointsForSpline, false, 'catmullrom', 0.5);

                        const bendGeom = new THREE.TubeGeometry(
                            arcCurve,
                            bendCurveSegments * 2, // Increase segments along the curve for TubeGeometry
                            radius,
                            radialSegments,
                            false
                        );
                        const bendMesh = new THREE.Mesh(bendGeom, material);
                        bendMesh.castShadow = true; bendMesh.receiveShadow = true;
                        group.add(bendMesh);
                        lastPointProcessed = bendEndPt;
                    } else {
                        // Fallback if not enough points were generated (should be rare with new control point logic)
                        // console.error("Insufficient points for CatmullRom spline with controls at index:", i + 1, "Reverting to straight to corner.");
                        const straightLengthToCorner = lastPointProcessed.distanceTo(P_next);
                        if (straightLengthToCorner > minSegmentLength) {
                            const straightGeom = new THREE.CylinderGeometry(radius, radius, straightLengthToCorner, radialSegments, 1, false);
                            const straightMesh = new THREE.Mesh(straightGeom, material);
                            straightMesh.castShadow = true; straightMesh.receiveShadow = true;
                            const midpoint = new THREE.Vector3().addVectors(lastPointProcessed, P_next).multiplyScalar(0.5);
                            straightMesh.position.copy(midpoint);
                            const direction = new THREE.Vector3().subVectors(P_next, lastPointProcessed).normalize();
                            if (direction.lengthSq() > minSegmentLength * minSegmentLength) straightMesh.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), direction);
                            group.add(straightMesh);
                        }
                        lastPointProcessed = P_next;
                    }
                } else {
                    // --- Straight segment (no bend, or last segment, or bend calculation failed) ---
                    const straightLength = lastPointProcessed.distanceTo(P_next);
                    if (straightLength > minSegmentLength) {
                        const straightGeom = new THREE.CylinderGeometry(radius, radius, straightLength, radialSegments, 1, false);
                        const straightMesh = new THREE.Mesh(straightGeom, material);
                        straightMesh.castShadow = true; straightMesh.receiveShadow = true;

                        const midpoint = new THREE.Vector3().addVectors(lastPointProcessed, P_next).multiplyScalar(0.5);
                        straightMesh.position.copy(midpoint);
                        const direction = new THREE.Vector3().subVectors(P_next, lastPointProcessed).normalize();
                        if (direction.lengthSq() > minSegmentLength * minSegmentLength) straightMesh.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), direction);
                        group.add(straightMesh);
                    }
                    lastPointProcessed = P_next;
                }
            }

        } catch (error) {
            console.error("Error creating tube with extruded elbows:", error, "Path:", pathString, "Points:", points);
            while (group.children.length > 0) { group.remove(group.children[0]); } // Cleanup
            return group; // Return empty group on error
        }

        // Add userData to the group itself for identification
        group.userData = { type: 'TubeGroup', pathString, radius, bendRadiusFactor };

        return group;
    }
    // --- END REVISED createTube Function ---

    createCable(pathString: string, diameter: number, flexibility: number, material: THREE.Material, hangFactor: number = 0.2): THREE.Group {
        const cableGroup = new THREE.Group();
        cableGroup.name = "cable";

        // Parse the path points
        const pathPoints = pathString.split(';').map(point => {
            const coords = point.replace('(', '').replace(')', '').split(',');
            return new THREE.Vector3(
                parseFloat(coords[0]),
                parseFloat(coords[1]),
                parseFloat(coords[2])
            );
        });

        if (pathPoints.length < 2) return cableGroup;

        // Calculate cable path with hanging effect
        const curvePoints = [];

        for (let i = 0; i < pathPoints.length - 1; i++) {
            const start = pathPoints[i];
            const end = pathPoints[i + 1];
            const distance = start.distanceTo(end);

            // Add start point
            curvePoints.push(start.clone());

            // If segment is long enough, add hanging point in the middle
            if (distance > 50) {
                // Calculate midpoint with a downward hang
                const mid = new THREE.Vector3().addVectors(start, end).multiplyScalar(0.5);
                // Apply hang based on distance and flexibility
                const hangAmount = distance * hangFactor * flexibility;
                mid.y -= hangAmount;

                curvePoints.push(mid);
            }
        }

        // Add end point
        curvePoints.push(pathPoints[pathPoints.length - 1].clone());

        // Create a smooth curve from the points
        const curve = new THREE.CatmullRomCurve3(curvePoints);

        // Create the cable geometry
        const radius = diameter / 2;
        const tubeGeometry = new THREE.TubeGeometry(
            curve,
            Math.max(20, curvePoints.length * 10), // segments - more for smoother cables
            radius,
            8, // radial segments
            false // closed
        );

        // Create the cable mesh
        const cableMesh = new THREE.Mesh(tubeGeometry, material);
        cableMesh.name = "cableMesh";

        cableGroup.add(cableMesh);

        return cableGroup;
    }

    // Helper function for CSG union
    unionMesh(meshA: THREE.Mesh, meshB: THREE.Mesh): THREE.Mesh | null {
        try {
            const mesh1 = meshA.clone();
            const mesh2 = meshB.clone();

            mesh1.updateMatrixWorld();
            mesh2.updateMatrixWorld();

            // Apply world transforms directly to geometry
            // Ensure geometries are BufferGeometry and index exists if needed by applyMatrix4
            if (mesh1.geometry instanceof THREE.BufferGeometry) {
                mesh1.geometry.applyMatrix4(mesh1.matrixWorld);
            } else {
                console.warn("Mesh1 geometry is not BufferGeometry, cannot apply matrix directly.");
                // Potentially handle Geometry type if necessary, though BufferGeometry is standard
            }
            if (mesh2.geometry instanceof THREE.BufferGeometry) {
                mesh2.geometry.applyMatrix4(mesh2.matrixWorld);
            } else {
                console.warn("Mesh2 geometry is not BufferGeometry, cannot apply matrix directly.");
            }


            // Reset mesh transforms as they are now baked into the geometry vertices
            mesh1.position.set(0, 0, 0);
            mesh1.rotation.set(0, 0, 0);
            mesh1.scale.set(1, 1, 1);
            mesh1.updateMatrixWorld();

            mesh2.position.set(0, 0, 0);
            mesh2.rotation.set(0, 0, 0);
            mesh2.scale.set(1, 1, 1);
            mesh2.updateMatrixWorld();

            // Perform CSG union (Assuming CSG is imported/available from three-csg-ts)
            const bsp1 = CSG.fromMesh(mesh1);
            const bsp2 = CSG.fromMesh(mesh2);
            const bspResult = bsp1.union(bsp2);
            const resultMesh = CSG.toMesh(bspResult, new THREE.Matrix4()); // Use identity matrix as transforms are baked


            resultMesh.material = meshA.material; // Use material from the first mesh
            resultMesh.name = meshA.name + "_union_" + meshB.name; // Simple naming

            // Clean up (optional, library might handle this)
            // mesh1.geometry.dispose();
            // mesh2.geometry.dispose();

            return resultMesh;
        } catch (error) {
            console.error("CSG Union failed:", error);
            if (error.message && error.message.includes("coplanar")) {
                console.warn("CSG Union failed likely due to coplanar faces. Consider slight adjustments to object positions/sizes.");
            }
            return null; // Return null on error
        }
    }

    async createUnion(mergedOutputIdsStr: string, sheetid: number, scene: THREE.Scene, name: string, path: string, configuration: string, excels: any, params: any, recreated = false) {
        if (!mergedOutputIdsStr || typeof mergedOutputIdsStr !== 'string') {
            console.error("Invalid mergedOutputIds string:", mergedOutputIdsStr);
            return null;
        }

        const outputIds = mergedOutputIdsStr.split(',').map(id => id.trim()).filter(id => id);
        if (outputIds.length < 2) {
            console.warn("Union requires at least two objects. Provided:", outputIds);
            return null;
        }

        let baseMesh: THREE.Mesh | null = null;
        const meshesToRemove: THREE.Object3D[] = [];
        const originalUserData: any[] = []; // Store original userData

        // Find the first mesh
        const firstMeshPath = path + '/' + outputIds[0];
        const firstMeshObj = scene.getObjectByProperty('path', firstMeshPath);

        if (firstMeshObj instanceof THREE.Mesh) {
            // Important: Clone the first mesh immediately to avoid modifying the original in scene
            baseMesh = firstMeshObj.clone() as THREE.Mesh;
            // Ensure the clone also has necessary properties like userData
            baseMesh.userData = { ...firstMeshObj.userData };
            baseMesh.name = firstMeshObj.name; // Keep original name for intermediate steps

            meshesToRemove.push(firstMeshObj); // Add original to removal list
            originalUserData.push(firstMeshObj.userData);
        } else {
            console.error(`First object for union not found or not a Mesh: ${firstMeshPath}`);
            return null;
        }

        // Iterate and union subsequent meshes
        for (let i = 1; i < outputIds.length; i++) {
            const currentMeshPath = path + '/' + outputIds[i];
            const currentMeshObj = scene.getObjectByProperty('path', currentMeshPath);

            if (currentMeshObj instanceof THREE.Mesh) {
                // Clone the current mesh before union operation
                const currentMeshClone = currentMeshObj.clone() as THREE.Mesh;
                currentMeshClone.userData = { ...currentMeshObj.userData };
                currentMeshClone.name = currentMeshObj.name;

                // Perform union between the current baseMesh result and the clone of the next object
                const unionResult = this.unionMesh(baseMesh, currentMeshClone);

                if (unionResult) {
                    // The result from unionMesh is a new mesh, replace baseMesh
                    // Dispose previous baseMesh geometry if needed
                    if (baseMesh && baseMesh.geometry) {
                        // baseMesh.geometry.dispose(); // Consider disposal strategy carefully
                    }
                    baseMesh = unionResult; // Update baseMesh with the union result
                    meshesToRemove.push(currentMeshObj); // Add original to removal list
                    originalUserData.push(currentMeshObj.userData);
                } else {
                    console.error(`Union operation failed between intermediate result and ${currentMeshPath}`);
                    // Clean up potentially created intermediate baseMesh geometry
                    if (baseMesh && baseMesh.geometry) {
                        // baseMesh.geometry.dispose();
                    }
                    return null; // Stop on failure
                }
            } else {
                console.warn(`Object for union not found or not a Mesh, skipping: ${currentMeshPath}`);
                // Continue to the next object even if one is skipped
            }
        }

        if (!baseMesh) {
            console.error("Union resulted in no final mesh.");
            return null;
        }

        // --- Finalize the resulting mesh ---
        baseMesh.name = name; // Assign the user-defined name from the spreadsheet row
        baseMesh.userData = {
            // ...baseMesh.userData, // CSG result might not have useful userData, start fresh
            type: 'union',
            outputid: name,
            path: path + '/' + name,
            sheetid: sheetid,
            configuration: configuration,
            params: { ...params, mergedoutputids: mergedOutputIdsStr }, // Store combined parameters
            originalPaths: meshesToRemove.map(m => m.userData.path), // Keep track of originals
            originalUserData: originalUserData, // Store original userData for potential future use
            isCSGResult: true, // Flag it as a result of CSG
        };
        baseMesh.visible = params.visible !== undefined ? this.parseBoolean(params.visible) : true; // Use parsed boolean value
        baseMesh.castShadow = true;
        baseMesh.receiveShadow = true;

        // Position the result mesh at the origin, as transforms are baked into geometry
        baseMesh.position.set(0, 0, 0);
        baseMesh.rotation.set(0, 0, 0);
        baseMesh.scale.set(1, 1, 1);
        baseMesh.updateMatrixWorld(true);

        // Add the final union mesh to the scene
        scene.add(baseMesh);
        console.log("Union successful, added:", baseMesh.userData.path);

        // Remove original meshes from the scene (or hide them)
        meshesToRemove.forEach(mesh => {
            mesh.visible = false; // Hide originals instead of removing, safer for dependencies/undo
            // scene.remove(mesh);
            // Optionally dispose geometry and material if they are not shared and no longer needed
            if (mesh instanceof THREE.Mesh && mesh.geometry) { // Check if it's a Mesh before accessing geometry
                // mesh.geometry.dispose(); // Careful with disposal
            }
        });
        console.log("Hid original meshes:", meshesToRemove.map(m => m.userData.path));

        return baseMesh; // Return the resulting mesh
    }

    // Helper to parse boolean values from spreadsheet strings
    private parseBoolean(value: any): boolean {
        if (typeof value === 'boolean') {
            return value;
        }
        if (typeof value === 'string') {
            return value.toLowerCase() === 'true' || value === '1';
        }
        return !!value; // Fallback for numbers or other types
    }

    // Create a Ring geometry
    createRing(outerRadiusStr, innerRadiusStr, depthStr, material) {
        try {
            const outerR = parseFloat(outerRadiusStr);
            const innerR = parseFloat(innerRadiusStr);
            const d = parseFloat(depthStr);

            if (isNaN(outerR) || isNaN(innerR) || isNaN(d) || innerR >= outerR || d <= 0) {
                console.warn("Invalid parameters for createRing:",
                    { outerRadiusStr, innerRadiusStr, depthStr },
                    `Parsed: outerR=${outerR}, innerR=${innerR}, d=${d}`);
                return null;
            }

            const shape = new THREE.Shape();
            // Outer circle
            shape.absarc(0, 0, outerR, 0, Math.PI * 2, false);

            // Inner hole
            const holePath = new THREE.Path();
            holePath.absarc(0, 0, innerR, 0, Math.PI * 2, true); // true = clockwise for hole
            shape.holes.push(holePath);

            const extrudeSettings = {
                depth: d,
                bevelEnabled: false,
                steps: 1
            };

            const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
            geometry.userData.isRing = true;
            geometry.userData.outerRadius = outerR; // Store parsed number
            geometry.userData.innerRadius = innerR; // Store parsed number
            geometry.userData.depth = d;         // Store parsed number
            const material1 = this.str2material(material);

            const mesh = new THREE.Mesh(geometry, material1);
            mesh.castShadow = true;
            mesh.receiveShadow = true;

            // Rotate to be flat on XY plane by default if needed, depends on desired orientation
            mesh.rotation.x = -Math.PI / 2;


            return mesh;
        } catch (error) {
            console.warn("Error creating ring:", error);
            return null;
        }
    }

    // Create a circle shape (useful for holes and circular features)
    createCircleShape(centerStr: string, radiusStr: string, depth: number, materialStr: string): THREE.Mesh | null {
        try {
            const center = centerStr.replace('(', '').replace(')', '').split(',');
            const radius = parseFloat(radiusStr);
            const cx = parseFloat(center[0]);
            const cy = parseFloat(center[1]);

            if (isNaN(cx) || isNaN(cy) || isNaN(radius) || radius <= 0) {
                console.error("Invalid circle parameters:", { cx, cy, radius });
                return null;
            }

            // Create circle shape
            const circleShape = new THREE.Shape();
            circleShape.absarc(cx, cy, radius, 0, Math.PI * 2, false);

            // Extrude the circle
            const extrudeSettings = { depth: depth, bevelEnabled: false };
            const geometry = new THREE.ExtrudeGeometry(circleShape, extrudeSettings);
            const material1 = this.str2material(materialStr);
            const mesh = new THREE.Mesh(geometry, material1);
            mesh.castShadow = true;
            mesh.receiveShadow = true;

            return mesh;
        } catch (error) {
            console.warn("Error in createCircleShape:", error);
            return null;
        }
    }

    // Enhanced shape creation with mixed segments support
    createEnhancedShape(params: any): THREE.Mesh | null {
        try {
            // Check if this is a circle shape
            if (params['shapeType'] === 'circle') {
                return this.createCircleShape(
                    params['center'] || '(0,0)',
                    params['radius'] || '10',
                    parseFloat(params['depth']) || 10,
                    params['material'] || '#445566'
                );
            }

            // Check if segments are defined for mixed line/spline shapes
            if (params['segments'] && typeof params['segments'] === 'string' && params['segments'].trim() !== '') {
                return this.createShapeFromSegments(
                    params['segments'],
                    parseFloat(params['depth']) || 10,
                    params['material'] || '#445566',
                    parseInt(params['splineDivisions']) || 30
                );
            }

            // Fall back to regular shape creation
            return this.createShape(
                params['points'] || '',
                parseFloat(params['depth']) || 10,
                params['material'] || '#445566',
                params['splinePath'],
                parseInt(params['splineDivisions'])
            );
        } catch (error) {
            console.warn("Error in createEnhancedShape:", error);
            return null;
        }
    }

    // Create shape from mixed segments definition
    createShapeFromSegments(segmentsStr: string, depth: number, materialStr: string, splineDivisions: number = 30): THREE.Mesh | null {
        try {
            const segments = this.parseSegmentsString(segmentsStr);
            if (segments.length === 0) {
                console.warn("No valid segments found in:", segmentsStr);
                return null;
            }

            const allPoints: { x: number, y: number }[] = [];

            segments.forEach(segment => {
                if (segment.type === 'line') {
                    allPoints.push(...segment.points);
                } else if (segment.type === 'spline') {
                    const splinePoints = this.generateSplinePointsFromCoordinates(segment.points, splineDivisions);
                    allPoints.push(...splinePoints);
                } else if (segment.type === 'circle') {
                    const circlePoints = this.generateCirclePointsFromDefinition(segment.points[0] as any, splineDivisions);
                    allPoints.push(...circlePoints);
                }
            });

            if (allPoints.length < 3) {
                console.warn("Not enough points to create shape:", allPoints.length);
                return null;
            }

            // Create THREE.Shape from points
            const shape = new THREE.Shape();
            shape.moveTo(allPoints[0].x, allPoints[0].y);
            for (let i = 1; i < allPoints.length; i++) {
                shape.lineTo(allPoints[i].x, allPoints[i].y);
            }

            const extrudeSettings = { depth: depth, bevelEnabled: false };
            const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
            const material1 = this.str2material(materialStr);
            const mesh = new THREE.Mesh(geometry, material1);
            mesh.castShadow = true;
            mesh.receiveShadow = true;

            return mesh;
        } catch (error) {
            console.warn("Error in createShapeFromSegments:", error);
            return null;
        }
    }

    // Parse segments string (e.g., "line:(0,0)-(100,0);spline:(100,0)-(100,100)-(0,100)")
    parseSegmentsString(segmentsStr: string): Array<{ type: string, points: Array<{ x: number, y: number }> }> {
        const segments: Array<{ type: string, points: Array<{ x: number, y: number }> }> = [];

        const segmentParts = segmentsStr.split(';').filter(s => s.trim() !== '');

        segmentParts.forEach(part => {
            const trimmed = part.trim();
            if (trimmed.startsWith('line:')) {
                const pointsStr = trimmed.substring(5);
                const points = this.parsePointsFromSegment(pointsStr);
                if (points.length >= 2) {
                    segments.push({ type: 'line', points });
                }
            } else if (trimmed.startsWith('spline:')) {
                const pointsStr = trimmed.substring(7);
                const points = this.parsePointsFromSegment(pointsStr);
                if (points.length >= 2) {
                    segments.push({ type: 'spline', points });
                }
            } else if (trimmed.startsWith('circle:')) {
                const circleStr = trimmed.substring(7);
                const circleData = this.parseCircleFromSegment(circleStr);
                if (circleData) {
                    segments.push({ type: 'circle', points: [circleData] });
                }
            }
        });

        return segments;
    }

    // Parse points from segment (e.g., "(0,0)-(100,0)" or "(100,0)-(100,100)-(0,100)")
    parsePointsFromSegment(pointsStr: string): Array<{ x: number, y: number }> {
        const points: Array<{ x: number, y: number }> = [];
        const pointTokens = pointsStr.split('-').map(s => s.trim());

        pointTokens.forEach(token => {
            const coords = token.replace('(', '').replace(')', '').split(',');
            if (coords.length === 2) {
                const x = parseFloat(coords[0]);
                const y = parseFloat(coords[1]);
                if (!isNaN(x) && !isNaN(y)) {
                    points.push({ x, y });
                }
            }
        });

        return points;
    }

    // Parse circle from segment (e.g., "(50,50,25)" for center x,y and radius)
    parseCircleFromSegment(circleStr: string): { x: number, y: number, radius: number } | null {
        const coords = circleStr.replace('(', '').replace(')', '').split(',');
        if (coords.length === 3) {
            const x = parseFloat(coords[0]);
            const y = parseFloat(coords[1]);
            const radius = parseFloat(coords[2]);
            if (!isNaN(x) && !isNaN(y) && !isNaN(radius) && radius > 0) {
                return { x, y, radius };
            }
        }
        return null;
    }

    generateSplinePointsFromCoordinates(controlPoints: Array<{ x: number, y: number }>, divisions: number): Array<{ x: number, y: number }> {
        if (controlPoints.length < 2) return controlPoints;

        const curve = new THREE.CatmullRomCurve3(
            controlPoints.map(p => new THREE.Vector3(p.x, p.y, 0))
        );

        const curvePoints = curve.getPoints(divisions);
        return curvePoints.map(p => ({ x: p.x, y: p.y }));
    }

    generateCirclePointsFromDefinition(circleData: { x: number, y: number, radius: number }, divisions: number): Array<{ x: number, y: number }> {
        const points: Array<{ x: number, y: number }> = [];

        for (let i = 0; i < divisions; i++) {
            const angle = (i / divisions) * Math.PI * 2;
            const x = circleData.x + Math.cos(angle) * circleData.radius;
            const y = circleData.y + Math.sin(angle) * circleData.radius;
            points.push({ x, y });
        }

        return points;
    }



    /**
     * Updates a dependent object's position based on its reference connector
     * This method ensures one-way dependency (connector -> object, not object -> connector)
     * @param refObj The object that depends on a connector
     * @param connectorNode The connector that the object references
     * @param scene The scene containing all objects
     */
    private updateDependentObjectPosition(refObj: THREE.Object3D, connectorNode: THREE.Object3D, scene: THREE.Scene): void {
        if (!refObj.userData.refpos) return;

        let refposvector: THREE.Vector3 | null = null;

        // Check if refpos is a connector reference (outputid.connector format)
        if (refObj.userData.refpos.includes('.') && refObj.userData.refpos.endsWith('.connector')) {
            // Get world position of the connector
            refposvector = new THREE.Vector3();
            connectorNode.getWorldPosition(refposvector);
        } else if (!refObj.userData.refpos.includes('.')) {
            // Handle standalone connector name
            refposvector = new THREE.Vector3();
            connectorNode.getWorldPosition(refposvector);
        }

        if (refposvector) {
            // CRITICAL: Never modify connector positions!
            if (refObj.userData?.isConnector) {
                console.warn('[CONNECTOR PROTECTION] Blocked attempt to modify connector position in updateDependentObjectPosition:', refObj.userData.connectorLabel || refObj.userData.outputid);
                return; // Skip position modification for connectors
            }

            // Store the original position before applying rotations
            const originalPosition = refposvector.clone();

            // Apply local transformations from the object's parameters
            const params = Utils.mapRowToParams(refObj.userData.row, refObj.userData.commentrow);

            // Set base position
            refObj.position.copy(originalPosition);

            // Apply local offset transformations
            refObj.updateMatrix();
            if (params['x'] != null) {
                let xDirection = new THREE.Vector3(parseFloat(params['x']), 0, 0);
                xDirection.applyQuaternion(refObj.quaternion);
                refObj.position.add(xDirection);
            }
            if (params['y'] != null) {
                let yDirection = new THREE.Vector3(0, parseFloat(params['y']), 0);
                yDirection.applyQuaternion(refObj.quaternion);
                refObj.position.add(yDirection);
            }
            if (params['z'] != null) {
                let zDirection = new THREE.Vector3(0, 0, parseFloat(params['z']));
                zDirection.applyQuaternion(refObj.quaternion);
                refObj.position.add(zDirection);
            }

            // Update matrices after all transformations
            refObj.updateMatrix();
            refObj.updateMatrixWorld(true);
        }

        // Recursively handle nested reference objects (but only for non-connector objects)
        if (!refObj.userData?.isConnector) {
            this.handleRefObjects(refObj, scene);
        }
    }
}


export { CADNodeEngine }